/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as WorkspaceRouteImport } from './routes/_workspace'
import { Route as ExcelUniverDemoRouteImport } from './routes/excel-univer-demo'
import { Route as LoginRouteImport } from './routes/login'
import { Route as PptEditorDemoRouteImport } from './routes/ppt-editor-demo'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as WordEditorDemoRouteImport } from './routes/word-editor-demo'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppAccountRouteImport } from './routes/_app/account'
import { Route as AppDataCenterRouteRouteImport } from './routes/_app/data-center/route'
import { Route as AppDocCenterRouteImport } from './routes/_app/doc-center'
import { Route as AppKbRouteRouteImport } from './routes/_app/kb/route'
import { Route as AppRecycleBinRouteImport } from './routes/_app/recycle-bin'
import { Route as AppSearchRouteImport } from './routes/_app/search'
import { Route as AppSemanticPlatformRouteRouteImport } from './routes/_app/semantic-platform/route'
import { Route as AppSettingsRouteRouteImport } from './routes/_app/settings/route'
import { Route as AppSuggestionsRouteImport } from './routes/_app/suggestions'
import { Route as AppTenantSettingsRouteRouteImport } from './routes/_app/tenant-settings/route'
import { Route as AppTruthRouteRouteImport } from './routes/_app/truth/route'
import { Route as InviteInviteIdRouteImport } from './routes/invite.$inviteId'
import { Route as AppBotMarketIndexRouteImport } from './routes/_app/bot-market/index'
import { Route as AppBotsIndexRouteImport } from './routes/_app/bots/index'
import { Route as AppBotsNewRouteImport } from './routes/_app/bots/new'
import { Route as AppCadEditIdRouteImport } from './routes/_app/cad-edit.$id'
import { Route as AppDataCenterIndexRouteImport } from './routes/_app/data-center/index'
import { Route as AppDataCenterDatasourcesRouteImport } from './routes/_app/data-center/datasources'
import { Route as AppDataCenterExportsRouteImport } from './routes/_app/data-center/exports'
import { Route as AppDataCenterExtractionRouteRouteImport } from './routes/_app/data-center/extraction/route'
import { Route as AppDataCenterMetadataRouteImport } from './routes/_app/data-center/metadata'
import { Route as AppDataCenterTmplRouteRouteImport } from './routes/_app/data-center/tmpl/route'
import { Route as AppDocGenerationIndexRouteImport } from './routes/_app/doc-generation/index'
import { Route as AppDocGenerationCreateRouteImport } from './routes/_app/doc-generation/create'
import { Route as AppDocGenerationTemplatesRouteImport } from './routes/_app/doc-generation/templates'
import { Route as AppDocGenerationWritingStyleRouteImport } from './routes/_app/doc-generation/writing-style'
import { Route as AppFilePreviewFileIdRouteImport } from './routes/_app/file-preview.$fileId'
import { Route as AppKbIndexRouteImport } from './routes/_app/kb/index'
import { Route as AppProjectsIndexRouteImport } from './routes/_app/projects/index'
import { Route as AppSemanticPlatformIndexRouteImport } from './routes/_app/semantic-platform/index'
import { Route as AppSemanticPlatformConceptsRouteRouteImport } from './routes/_app/semantic-platform/concepts/route'
import { Route as AppSemanticPlatformDataAssetsRouteRouteImport } from './routes/_app/semantic-platform/data-assets/route'
import { Route as AppSemanticPlatformDataGovernanceRouteRouteImport } from './routes/_app/semantic-platform/data-governance/route'
import { Route as AppSemanticPlatformDataLineageRouteImport } from './routes/_app/semantic-platform/data-lineage'
import { Route as AppSemanticPlatformDataModelsRouteRouteImport } from './routes/_app/semantic-platform/data-models/route'
import { Route as AppSemanticPlatformKnowledgeDebugRouteRouteImport } from './routes/_app/semantic-platform/knowledge-debug/route'
import { Route as AppSemanticPlatformQuantitiesRouteRouteImport } from './routes/_app/semantic-platform/quantities/route'
import { Route as AppSemanticPlatformTagCenterRouteRouteImport } from './routes/_app/semantic-platform/tag-center/route'
import { Route as AppSemanticPlatformTagsRouteRouteImport } from './routes/_app/semantic-platform/tags/route'
import { Route as AppSemanticPlatformVocabulariesRouteRouteImport } from './routes/_app/semantic-platform/vocabularies/route'
import { Route as AppSettingsIndexRouteImport } from './routes/_app/settings/index'
import { Route as AppSettingsAiModelsRouteImport } from './routes/_app/settings/ai-models'
import { Route as AppSettingsAuditLogsRouteImport } from './routes/_app/settings/audit-logs'
import { Route as AppSettingsBotsRouteImport } from './routes/_app/settings/bots'
import { Route as AppSettingsDataSourcesRouteImport } from './routes/_app/settings/data-sources'
import { Route as AppSettingsDatabaseRouteImport } from './routes/_app/settings/database'
import { Route as AppSettingsHelpDocsRouteImport } from './routes/_app/settings/help-docs'
import { Route as AppSettingsIndustryPacksRouteImport } from './routes/_app/settings/industry-packs'
import { Route as AppSettingsJobManagerRouteRouteImport } from './routes/_app/settings/job-manager/route'
import { Route as AppSettingsLicenseRouteImport } from './routes/_app/settings/license'
import { Route as AppSettingsMetadataTemplatesRouteImport } from './routes/_app/settings/metadata-templates'
import { Route as AppSettingsParserRouteImport } from './routes/_app/settings/parser'
import { Route as AppSettingsQuotaManagementRouteImport } from './routes/_app/settings/quota-management'
import { Route as AppSettingsStorageCleanupRouteImport } from './routes/_app/settings/storage-cleanup'
import { Route as AppSettingsSystemRouteImport } from './routes/_app/settings/system'
import { Route as AppSettingsSystemStatusRouteImport } from './routes/_app/settings/system-status'
import { Route as AppSettingsTenantsRouteRouteImport } from './routes/_app/settings/tenants/route'
import { Route as AppSsBidGenResourcesRouteImport } from './routes/_app/ss-bid-gen/resources'
import { Route as AppTenantSettingsIndexRouteImport } from './routes/_app/tenant-settings/index'
import { Route as AppTenantSettingsAiModelsRouteImport } from './routes/_app/tenant-settings/ai-models'
import { Route as AppTenantSettingsAuditLogsRouteImport } from './routes/_app/tenant-settings/audit-logs'
import { Route as AppTenantSettingsBotsRouteImport } from './routes/_app/tenant-settings/bots'
import { Route as AppTenantSettingsDataSourcesRouteImport } from './routes/_app/tenant-settings/data-sources'
import { Route as AppTenantSettingsDepartmentsRouteImport } from './routes/_app/tenant-settings/departments'
import { Route as AppTenantSettingsDocSettingsRouteImport } from './routes/_app/tenant-settings/doc-settings'
import { Route as AppTenantSettingsDocumentSecurityRouteImport } from './routes/_app/tenant-settings/document-security'
import { Route as AppTenantSettingsIndustryPacksRouteImport } from './routes/_app/tenant-settings/industry-packs'
import { Route as AppTenantSettingsInvitesRouteImport } from './routes/_app/tenant-settings/invites'
import { Route as AppTenantSettingsMetadataTemplatesRouteImport } from './routes/_app/tenant-settings/metadata-templates'
import { Route as AppTenantSettingsParseEnginesRouteImport } from './routes/_app/tenant-settings/parse-engines'
import { Route as AppTenantSettingsPermissionsRouteImport } from './routes/_app/tenant-settings/permissions'
import { Route as AppTenantSettingsPublicationsRouteImport } from './routes/_app/tenant-settings/publications'
import { Route as AppTenantSettingsRolesRouteImport } from './routes/_app/tenant-settings/roles'
import { Route as AppTenantSettingsSemanticGovernanceRouteImport } from './routes/_app/tenant-settings/semantic-governance'
import { Route as AppTenantSettingsShareGovernanceRouteImport } from './routes/_app/tenant-settings/share-governance'
import { Route as AppTenantSettingsSystemStatusRouteImport } from './routes/_app/tenant-settings/system-status'
import { Route as AppTenantSettingsTenantInfoRouteImport } from './routes/_app/tenant-settings/tenant-info'
import { Route as AppTenantSettingsUsersRouteImport } from './routes/_app/tenant-settings/users'
import { Route as AppTruthIndexRouteImport } from './routes/_app/truth/index'
import { Route as AppTruthComparesRouteImport } from './routes/_app/truth/compares'
import { Route as AppWorkbenchIndexRouteImport } from './routes/_app/workbench/index'
import { Route as WorkspaceProjectsProjectIdRouteImport } from './routes/_workspace/projects/$projectId'
import { Route as DataCenterCleaningIdRouteImport } from './routes/data-center.cleaning.$id'
import { Route as DataCenterReviewTaskIdRouteImport } from './routes/data-center.review.$taskId'
import { Route as ShareDocTokenRouteImport } from './routes/share/doc/$token'
import { Route as AppBotsBotIdRunRouteImport } from './routes/_app/bots/$botId/run'
import { Route as AppBotsBotIdStudioRouteImport } from './routes/_app/bots/$botId/studio'
import { Route as AppBotsCredentialsCredentialIdRouteImport } from './routes/_app/bots/credentials/$credentialId'
import { Route as AppBotsCredentialsNewRouteImport } from './routes/_app/bots/credentials/new'
import { Route as AppBotsSkillsSkillIdRouteImport } from './routes/_app/bots/skills/$skillId'
import { Route as AppBotsSkillsNewRouteImport } from './routes/_app/bots/skills/new'
import { Route as AppBotsToolsToolIdRouteImport } from './routes/_app/bots/tools/$toolId'
import { Route as AppBotsToolsNewRouteImport } from './routes/_app/bots/tools/new'
import { Route as AppDataCenterCleaningIndexRouteImport } from './routes/_app/data-center/cleaning/index'
import { Route as AppDataCenterExportsExportIdRouteImport } from './routes/_app/data-center/exports_/$exportId'
import { Route as AppDataCenterExtractionIndexRouteImport } from './routes/_app/data-center/extraction/index'
import { Route as AppDataCenterExtractionTaskIdRouteImport } from './routes/_app/data-center/extraction/$taskId'
import { Route as AppDataCenterExtractionCreateRouteImport } from './routes/_app/data-center/extraction/create'
import { Route as AppDataCenterReviewIndexRouteImport } from './routes/_app/data-center/review/index'
import { Route as AppDataCenterTmplIndexRouteImport } from './routes/_app/data-center/tmpl/index'
import { Route as AppDataCenterTmplMetadataRouteImport } from './routes/_app/data-center/tmpl/metadata'
import { Route as AppDataCenterTmplNewRouteImport } from './routes/_app/data-center/tmpl/new'
import { Route as AppDocGenerationTaskIdIndexRouteImport } from './routes/_app/doc-generation/$taskId/index'
import { Route as AppDocGenerationTaskIdArtifactRouteImport } from './routes/_app/doc-generation/$taskId/artifact'
import { Route as AppDocGenerationTaskIdOutlineRouteImport } from './routes/_app/doc-generation/$taskId/outline'
import { Route as AppDocGenerationTaskIdWritingRouteImport } from './routes/_app/doc-generation/$taskId/writing'
import { Route as AppKbKbIdIndexRouteImport } from './routes/_app/kb/$kbId/index'
import { Route as AppKbKbIdDocIdRouteImport } from './routes/_app/kb/$kbId/$docId'
import { Route as AppKbKbIdSettingsRouteImport } from './routes/_app/kb/$kbId/settings'
import { Route as AppProjectsTemplatesIndexRouteImport } from './routes/_app/projects/templates/index'
import { Route as AppProjectsTemplatesTemplateIdRouteImport } from './routes/_app/projects/templates/$templateId'
import { Route as AppSemanticPlatformConceptsIndexRouteImport } from './routes/_app/semantic-platform/concepts/index'
import { Route as AppSemanticPlatformConceptsIdRouteImport } from './routes/_app/semantic-platform/concepts/$id'
import { Route as AppSemanticPlatformDataAssetsIndexRouteImport } from './routes/_app/semantic-platform/data-assets/index'
import { Route as AppSemanticPlatformDataAssetsAssetIdRouteImport } from './routes/_app/semantic-platform/data-assets/$assetId'
import { Route as AppSemanticPlatformDataModelsIndexRouteImport } from './routes/_app/semantic-platform/data-models/index'
import { Route as AppSemanticPlatformDataModelsIdRouteImport } from './routes/_app/semantic-platform/data-models/$id'
import { Route as AppSemanticPlatformKnowledgeDebugIndexRouteImport } from './routes/_app/semantic-platform/knowledge-debug/index'
import { Route as AppSemanticPlatformNamespacesIndexRouteImport } from './routes/_app/semantic-platform/namespaces/index'
import { Route as AppSemanticPlatformQuantitiesIndexRouteImport } from './routes/_app/semantic-platform/quantities/index'
import { Route as AppSemanticPlatformQuantitiesIdRouteImport } from './routes/_app/semantic-platform/quantities/$id'
import { Route as AppSemanticPlatformTagsIndexRouteImport } from './routes/_app/semantic-platform/tags/index'
import { Route as AppSemanticPlatformVocabulariesIndexRouteImport } from './routes/_app/semantic-platform/vocabularies/index'
import { Route as AppSemanticPlatformVocabulariesIdRouteImport } from './routes/_app/semantic-platform/vocabularies/$id'
import { Route as AppSettingsAuditLogsIndexRouteImport } from './routes/_app/settings/audit-logs/index'
import { Route as AppSettingsAuditLogsIdRouteImport } from './routes/_app/settings/audit-logs/$id'
import { Route as AppSettingsIndustryPacksIndexRouteImport } from './routes/_app/settings/industry-packs/index'
import { Route as AppSettingsIndustryPacksKeyRouteImport } from './routes/_app/settings/industry-packs/$key'
import { Route as AppSettingsTenantsTenantIdRouteImport } from './routes/_app/settings/tenants/$tenantId'
import { Route as AppTenantSettingsAuditLogsIndexRouteImport } from './routes/_app/tenant-settings/audit-logs/index'
import { Route as AppTenantSettingsAuditLogsIdRouteImport } from './routes/_app/tenant-settings/audit-logs/$id'
import { Route as AppTenantSettingsIndustryPacksIndexRouteImport } from './routes/_app/tenant-settings/industry-packs/index'
import { Route as AppTenantSettingsIndustryPacksKeyRouteImport } from './routes/_app/tenant-settings/industry-packs/$key'
import { Route as AppTenantSettingsMetadataTemplatesIndexRouteImport } from './routes/_app/tenant-settings/metadata-templates/index'
import { Route as AppTenantSettingsSemanticGovernanceIndexRouteImport } from './routes/_app/tenant-settings/semantic-governance/index'
import { Route as AppTenantSettingsSemanticGovernanceCategoriesRouteImport } from './routes/_app/tenant-settings/semantic-governance/categories'
import { Route as AppTruthComparesCompareIdRouteImport } from './routes/_app/truth/compares.$compareId'
import { Route as AppTruthRoundsSessionIdRouteImport } from './routes/_app/truth/rounds.$sessionId'
import { Route as DataCenterReviewRunRunIdRouteImport } from './routes/data-center.review.run.$runId'
import { Route as AppDataCenterExtractionEditTaskIdRouteImport } from './routes/_app/data-center/extraction/edit.$taskId'
import { Route as AppDataCenterTmplEditIdRouteImport } from './routes/_app/data-center/tmpl/edit.$id'
import { Route as AppDataCenterTmplVersionsIdRouteImport } from './routes/_app/data-center/tmpl/versions.$id'
import { Route as AppSemanticPlatformDataAssetsBatchesBatchIdRouteImport } from './routes/_app/semantic-platform/data-assets/batches.$batchId'
import { Route as AppSemanticPlatformDataAssetsEntitiesEntityIdRouteImport } from './routes/_app/semantic-platform/data-assets/entities/$entityId'
import { Route as AppSemanticPlatformDataGovernanceAnalysisIndexRouteImport } from './routes/_app/semantic-platform/data-governance/analysis/index'
import { Route as AppSemanticPlatformDataGovernanceClassificationsIndexRouteImport } from './routes/_app/semantic-platform/data-governance/classifications/index'
import { Route as AppSemanticPlatformDataGovernanceImpactIndexRouteImport } from './routes/_app/semantic-platform/data-governance/impact/index'
import { Route as AppSemanticPlatformDataGovernanceQualityIndexRouteImport } from './routes/_app/semantic-platform/data-governance/quality/index'
import { Route as AppSemanticPlatformDataGovernanceSuggestionsIndexRouteImport } from './routes/_app/semantic-platform/data-governance/suggestions/index'
import { Route as AppSemanticPlatformDataModelsEditIdRouteImport } from './routes/_app/semantic-platform/data-models/edit.$id'
import { Route as AppSemanticPlatformTagCenterFieldsIndexRouteImport } from './routes/_app/semantic-platform/tag-center/fields/index'
import { Route as AppSemanticPlatformTagCenterStatsIndexRouteImport } from './routes/_app/semantic-platform/tag-center/stats/index'
import { Route as AppSemanticPlatformTagCenterSuggestionsIndexRouteImport } from './routes/_app/semantic-platform/tag-center/suggestions/index'
import { Route as AppSettingsJobManagerScheduleScheduleIdRouteImport } from './routes/_app/settings/job-manager/schedule/$scheduleId'
import { Route as AppSettingsJobManagerTaskTaskIdRouteImport } from './routes/_app/settings/job-manager/task/$taskId'
import { Route as AppTenantSettingsSemanticGovernanceTermsNewRouteImport } from './routes/_app/tenant-settings/semantic-governance/terms.new'
import { Route as AppKbKbIdCompilationArtifactsArtifactIdRouteImport } from './routes/_app/kb/$kbId/compilation.artifacts.$artifactId'
import { Route as AppKbKbIdCompilationRunsRunIdRouteImport } from './routes/_app/kb/$kbId/compilation.runs.$runId'
import { Route as AppKbKbIdSettingsTermsNewRouteImport } from './routes/_app/kb/$kbId/settings/terms.new'
import { Route as AppSettingsJobManagerScheduleScheduleIdTaskIdRouteImport } from './routes/_app/settings/job-manager/schedule/$scheduleId/$taskId'
import { Route as AppTenantSettingsSemanticGovernanceTermsEditIdRouteImport } from './routes/_app/tenant-settings/semantic-governance/terms.edit.$id'
import { Route as AppKbKbIdSettingsTermsEditIdRouteImport } from './routes/_app/kb/$kbId/settings/terms.edit.$id'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkspaceRoute = WorkspaceRouteImport.update({
  id: '/_workspace',
  getParentRoute: () => rootRouteImport,
} as any)
const ExcelUniverDemoRoute = ExcelUniverDemoRouteImport.update({
  id: '/excel-univer-demo',
  path: '/excel-univer-demo',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const PptEditorDemoRoute = PptEditorDemoRouteImport.update({
  id: '/ppt-editor-demo',
  path: '/ppt-editor-demo',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
  id: '/privacy-policy',
  path: '/privacy-policy',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const WordEditorDemoRoute = WordEditorDemoRouteImport.update({
  id: '/word-editor-demo',
  path: '/word-editor-demo',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountRoute = AppAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AppRoute,
} as any)
const AppDataCenterRouteRoute = AppDataCenterRouteRouteImport.update({
  id: '/data-center',
  path: '/data-center',
  getParentRoute: () => AppRoute,
} as any)
const AppDocCenterRoute = AppDocCenterRouteImport.update({
  id: '/doc-center',
  path: '/doc-center',
  getParentRoute: () => AppRoute,
} as any)
const AppKbRouteRoute = AppKbRouteRouteImport.update({
  id: '/kb',
  path: '/kb',
  getParentRoute: () => AppRoute,
} as any)
const AppRecycleBinRoute = AppRecycleBinRouteImport.update({
  id: '/recycle-bin',
  path: '/recycle-bin',
  getParentRoute: () => AppRoute,
} as any)
const AppSearchRoute = AppSearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => AppRoute,
} as any)
const AppSemanticPlatformRouteRoute =
  AppSemanticPlatformRouteRouteImport.update({
    id: '/semantic-platform',
    path: '/semantic-platform',
    getParentRoute: () => AppRoute,
  } as any)
const AppSettingsRouteRoute = AppSettingsRouteRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppSuggestionsRoute = AppSuggestionsRouteImport.update({
  id: '/suggestions',
  path: '/suggestions',
  getParentRoute: () => AppRoute,
} as any)
const AppTenantSettingsRouteRoute = AppTenantSettingsRouteRouteImport.update({
  id: '/tenant-settings',
  path: '/tenant-settings',
  getParentRoute: () => AppRoute,
} as any)
const AppTruthRouteRoute = AppTruthRouteRouteImport.update({
  id: '/truth',
  path: '/truth',
  getParentRoute: () => AppRoute,
} as any)
const InviteInviteIdRoute = InviteInviteIdRouteImport.update({
  id: '/invite/$inviteId',
  path: '/invite/$inviteId',
  getParentRoute: () => rootRouteImport,
} as any)
const AppBotMarketIndexRoute = AppBotMarketIndexRouteImport.update({
  id: '/bot-market/',
  path: '/bot-market/',
  getParentRoute: () => AppRoute,
} as any)
const AppBotsIndexRoute = AppBotsIndexRouteImport.update({
  id: '/bots/',
  path: '/bots/',
  getParentRoute: () => AppRoute,
} as any)
const AppBotsNewRoute = AppBotsNewRouteImport.update({
  id: '/bots/new',
  path: '/bots/new',
  getParentRoute: () => AppRoute,
} as any)
const AppCadEditIdRoute = AppCadEditIdRouteImport.update({
  id: '/cad-edit/$id',
  path: '/cad-edit/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppDataCenterIndexRoute = AppDataCenterIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppDataCenterRouteRoute,
} as any)
const AppDataCenterDatasourcesRoute =
  AppDataCenterDatasourcesRouteImport.update({
    id: '/datasources',
    path: '/datasources',
    getParentRoute: () => AppDataCenterRouteRoute,
  } as any)
const AppDataCenterExportsRoute = AppDataCenterExportsRouteImport.update({
  id: '/exports',
  path: '/exports',
  getParentRoute: () => AppDataCenterRouteRoute,
} as any)
const AppDataCenterExtractionRouteRoute =
  AppDataCenterExtractionRouteRouteImport.update({
    id: '/extraction',
    path: '/extraction',
    getParentRoute: () => AppDataCenterRouteRoute,
  } as any)
const AppDataCenterMetadataRoute = AppDataCenterMetadataRouteImport.update({
  id: '/metadata',
  path: '/metadata',
  getParentRoute: () => AppDataCenterRouteRoute,
} as any)
const AppDataCenterTmplRouteRoute = AppDataCenterTmplRouteRouteImport.update({
  id: '/tmpl',
  path: '/tmpl',
  getParentRoute: () => AppDataCenterRouteRoute,
} as any)
const AppDocGenerationIndexRoute = AppDocGenerationIndexRouteImport.update({
  id: '/doc-generation/',
  path: '/doc-generation/',
  getParentRoute: () => AppRoute,
} as any)
const AppDocGenerationCreateRoute = AppDocGenerationCreateRouteImport.update({
  id: '/doc-generation/create',
  path: '/doc-generation/create',
  getParentRoute: () => AppRoute,
} as any)
const AppDocGenerationTemplatesRoute =
  AppDocGenerationTemplatesRouteImport.update({
    id: '/doc-generation/templates',
    path: '/doc-generation/templates',
    getParentRoute: () => AppRoute,
  } as any)
const AppDocGenerationWritingStyleRoute =
  AppDocGenerationWritingStyleRouteImport.update({
    id: '/doc-generation/writing-style',
    path: '/doc-generation/writing-style',
    getParentRoute: () => AppRoute,
  } as any)
const AppFilePreviewFileIdRoute = AppFilePreviewFileIdRouteImport.update({
  id: '/file-preview/$fileId',
  path: '/file-preview/$fileId',
  getParentRoute: () => AppRoute,
} as any)
const AppKbIndexRoute = AppKbIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppKbRouteRoute,
} as any)
const AppProjectsIndexRoute = AppProjectsIndexRouteImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => AppRoute,
} as any)
const AppSemanticPlatformIndexRoute =
  AppSemanticPlatformIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppSemanticPlatformRouteRoute,
  } as any)
const AppSemanticPlatformConceptsRouteRoute =
  AppSemanticPlatformConceptsRouteRouteImport.update({
    id: '/concepts',
    path: '/concepts',
    getParentRoute: () => AppSemanticPlatformRouteRoute,
  } as any)
const AppSemanticPlatformDataAssetsRouteRoute =
  AppSemanticPlatformDataAssetsRouteRouteImport.update({
    id: '/data-assets',
    path: '/data-assets',
    getParentRoute: () => AppSemanticPlatformRouteRoute,
  } as any)
const AppSemanticPlatformDataGovernanceRouteRoute =
  AppSemanticPlatformDataGovernanceRouteRouteImport.update({
    id: '/data-governance',
    path: '/data-governance',
    getParentRoute: () => AppSemanticPlatformRouteRoute,
  } as any)
const AppSemanticPlatformDataLineageRoute =
  AppSemanticPlatformDataLineageRouteImport.update({
    id: '/data-lineage',
    path: '/data-lineage',
    getParentRoute: () => AppSemanticPlatformRouteRoute,
  } as any)
const AppSemanticPlatformDataModelsRouteRoute =
  AppSemanticPlatformDataModelsRouteRouteImport.update({
    id: '/data-models',
    path: '/data-models',
    getParentRoute: () => AppSemanticPlatformRouteRoute,
  } as any)
const AppSemanticPlatformKnowledgeDebugRouteRoute =
  AppSemanticPlatformKnowledgeDebugRouteRouteImport.update({
    id: '/knowledge-debug',
    path: '/knowledge-debug',
    getParentRoute: () => AppSemanticPlatformRouteRoute,
  } as any)
const AppSemanticPlatformQuantitiesRouteRoute =
  AppSemanticPlatformQuantitiesRouteRouteImport.update({
    id: '/quantities',
    path: '/quantities',
    getParentRoute: () => AppSemanticPlatformRouteRoute,
  } as any)
const AppSemanticPlatformTagCenterRouteRoute =
  AppSemanticPlatformTagCenterRouteRouteImport.update({
    id: '/tag-center',
    path: '/tag-center',
    getParentRoute: () => AppSemanticPlatformRouteRoute,
  } as any)
const AppSemanticPlatformTagsRouteRoute =
  AppSemanticPlatformTagsRouteRouteImport.update({
    id: '/tags',
    path: '/tags',
    getParentRoute: () => AppSemanticPlatformRouteRoute,
  } as any)
const AppSemanticPlatformVocabulariesRouteRoute =
  AppSemanticPlatformVocabulariesRouteRouteImport.update({
    id: '/vocabularies',
    path: '/vocabularies',
    getParentRoute: () => AppSemanticPlatformRouteRoute,
  } as any)
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsAiModelsRoute = AppSettingsAiModelsRouteImport.update({
  id: '/ai-models',
  path: '/ai-models',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsAuditLogsRoute = AppSettingsAuditLogsRouteImport.update({
  id: '/audit-logs',
  path: '/audit-logs',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsBotsRoute = AppSettingsBotsRouteImport.update({
  id: '/bots',
  path: '/bots',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsDataSourcesRoute = AppSettingsDataSourcesRouteImport.update({
  id: '/data-sources',
  path: '/data-sources',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsDatabaseRoute = AppSettingsDatabaseRouteImport.update({
  id: '/database',
  path: '/database',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsHelpDocsRoute = AppSettingsHelpDocsRouteImport.update({
  id: '/help-docs',
  path: '/help-docs',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsIndustryPacksRoute =
  AppSettingsIndustryPacksRouteImport.update({
    id: '/industry-packs',
    path: '/industry-packs',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsJobManagerRouteRoute =
  AppSettingsJobManagerRouteRouteImport.update({
    id: '/job-manager',
    path: '/job-manager',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsLicenseRoute = AppSettingsLicenseRouteImport.update({
  id: '/license',
  path: '/license',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsMetadataTemplatesRoute =
  AppSettingsMetadataTemplatesRouteImport.update({
    id: '/metadata-templates',
    path: '/metadata-templates',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsParserRoute = AppSettingsParserRouteImport.update({
  id: '/parser',
  path: '/parser',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsQuotaManagementRoute =
  AppSettingsQuotaManagementRouteImport.update({
    id: '/quota-management',
    path: '/quota-management',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsStorageCleanupRoute =
  AppSettingsStorageCleanupRouteImport.update({
    id: '/storage-cleanup',
    path: '/storage-cleanup',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsSystemRoute = AppSettingsSystemRouteImport.update({
  id: '/system',
  path: '/system',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsSystemStatusRoute = AppSettingsSystemStatusRouteImport.update({
  id: '/system-status',
  path: '/system-status',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsTenantsRouteRoute = AppSettingsTenantsRouteRouteImport.update({
  id: '/tenants',
  path: '/tenants',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSsBidGenResourcesRoute = AppSsBidGenResourcesRouteImport.update({
  id: '/ss-bid-gen/resources',
  path: '/ss-bid-gen/resources',
  getParentRoute: () => AppRoute,
} as any)
const AppTenantSettingsIndexRoute = AppTenantSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppTenantSettingsRouteRoute,
} as any)
const AppTenantSettingsAiModelsRoute =
  AppTenantSettingsAiModelsRouteImport.update({
    id: '/ai-models',
    path: '/ai-models',
    getParentRoute: () => AppTenantSettingsRouteRoute,
  } as any)
const AppTenantSettingsAuditLogsRoute =
  AppTenantSettingsAuditLogsRouteImport.update({
    id: '/audit-logs',
    path: '/audit-logs',
    getParentRoute: () => AppTenantSettingsRouteRoute,
  } as any)
const AppTenantSettingsBotsRoute = AppTenantSettingsBotsRouteImport.update({
  id: '/bots',
  path: '/bots',
  getParentRoute: () => AppTenantSettingsRouteRoute,
} as any)
const AppTenantSettingsDataSourcesRoute =
  AppTenantSettingsDataSourcesRouteImport.update({
    id: '/data-sources',
    path: '/data-sources',
    getParentRoute: () => AppTenantSettingsRouteRoute,
  } as any)
const AppTenantSettingsDepartmentsRoute =
  AppTenantSettingsDepartmentsRouteImport.update({
    id: '/departments',
    path: '/departments',
    getParentRoute: () => AppTenantSettingsRouteRoute,
  } as any)
const AppTenantSettingsDocSettingsRoute =
  AppTenantSettingsDocSettingsRouteImport.update({
    id: '/doc-settings',
    path: '/doc-settings',
    getParentRoute: () => AppTenantSettingsRouteRoute,
  } as any)
const AppTenantSettingsDocumentSecurityRoute =
  AppTenantSettingsDocumentSecurityRouteImport.update({
    id: '/document-security',
    path: '/document-security',
    getParentRoute: () => AppTenantSettingsRouteRoute,
  } as any)
const AppTenantSettingsIndustryPacksRoute =
  AppTenantSettingsIndustryPacksRouteImport.update({
    id: '/industry-packs',
    path: '/industry-packs',
    getParentRoute: () => AppTenantSettingsRouteRoute,
  } as any)
const AppTenantSettingsInvitesRoute =
  AppTenantSettingsInvitesRouteImport.update({
    id: '/invites',
    path: '/invites',
    getParentRoute: () => AppTenantSettingsRouteRoute,
  } as any)
const AppTenantSettingsMetadataTemplatesRoute =
  AppTenantSettingsMetadataTemplatesRouteImport.update({
    id: '/metadata-templates',
    path: '/metadata-templates',
    getParentRoute: () => AppTenantSettingsRouteRoute,
  } as any)
const AppTenantSettingsParseEnginesRoute =
  AppTenantSettingsParseEnginesRouteImport.update({
    id: '/parse-engines',
    path: '/parse-engines',
    getParentRoute: () => AppTenantSettingsRouteRoute,
  } as any)
const AppTenantSettingsPermissionsRoute =
  AppTenantSettingsPermissionsRouteImport.update({
    id: '/permissions',
    path: '/permissions',
    getParentRoute: () => AppTenantSettingsRouteRoute,
  } as any)
const AppTenantSettingsPublicationsRoute =
  AppTenantSettingsPublicationsRouteImport.update({
    id: '/publications',
    path: '/publications',
    getParentRoute: () => AppTenantSettingsRouteRoute,
  } as any)
const AppTenantSettingsRolesRoute = AppTenantSettingsRolesRouteImport.update({
  id: '/roles',
  path: '/roles',
  getParentRoute: () => AppTenantSettingsRouteRoute,
} as any)
const AppTenantSettingsSemanticGovernanceRoute =
  AppTenantSettingsSemanticGovernanceRouteImport.update({
    id: '/semantic-governance',
    path: '/semantic-governance',
    getParentRoute: () => AppTenantSettingsRouteRoute,
  } as any)
const AppTenantSettingsShareGovernanceRoute =
  AppTenantSettingsShareGovernanceRouteImport.update({
    id: '/share-governance',
    path: '/share-governance',
    getParentRoute: () => AppTenantSettingsRouteRoute,
  } as any)
const AppTenantSettingsSystemStatusRoute =
  AppTenantSettingsSystemStatusRouteImport.update({
    id: '/system-status',
    path: '/system-status',
    getParentRoute: () => AppTenantSettingsRouteRoute,
  } as any)
const AppTenantSettingsTenantInfoRoute =
  AppTenantSettingsTenantInfoRouteImport.update({
    id: '/tenant-info',
    path: '/tenant-info',
    getParentRoute: () => AppTenantSettingsRouteRoute,
  } as any)
const AppTenantSettingsUsersRoute = AppTenantSettingsUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AppTenantSettingsRouteRoute,
} as any)
const AppTruthIndexRoute = AppTruthIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppTruthRouteRoute,
} as any)
const AppTruthComparesRoute = AppTruthComparesRouteImport.update({
  id: '/compares',
  path: '/compares',
  getParentRoute: () => AppTruthRouteRoute,
} as any)
const AppWorkbenchIndexRoute = AppWorkbenchIndexRouteImport.update({
  id: '/workbench/',
  path: '/workbench/',
  getParentRoute: () => AppRoute,
} as any)
const WorkspaceProjectsProjectIdRoute =
  WorkspaceProjectsProjectIdRouteImport.update({
    id: '/projects/$projectId',
    path: '/projects/$projectId',
    getParentRoute: () => WorkspaceRoute,
  } as any)
const DataCenterCleaningIdRoute = DataCenterCleaningIdRouteImport.update({
  id: '/data-center/cleaning/$id',
  path: '/data-center/cleaning/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const DataCenterReviewTaskIdRoute = DataCenterReviewTaskIdRouteImport.update({
  id: '/data-center/review/$taskId',
  path: '/data-center/review/$taskId',
  getParentRoute: () => rootRouteImport,
} as any)
const ShareDocTokenRoute = ShareDocTokenRouteImport.update({
  id: '/share/doc/$token',
  path: '/share/doc/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AppBotsBotIdRunRoute = AppBotsBotIdRunRouteImport.update({
  id: '/bots/$botId/run',
  path: '/bots/$botId/run',
  getParentRoute: () => AppRoute,
} as any)
const AppBotsBotIdStudioRoute = AppBotsBotIdStudioRouteImport.update({
  id: '/bots/$botId/studio',
  path: '/bots/$botId/studio',
  getParentRoute: () => AppRoute,
} as any)
const AppBotsCredentialsCredentialIdRoute =
  AppBotsCredentialsCredentialIdRouteImport.update({
    id: '/bots/credentials/$credentialId',
    path: '/bots/credentials/$credentialId',
    getParentRoute: () => AppRoute,
  } as any)
const AppBotsCredentialsNewRoute = AppBotsCredentialsNewRouteImport.update({
  id: '/bots/credentials/new',
  path: '/bots/credentials/new',
  getParentRoute: () => AppRoute,
} as any)
const AppBotsSkillsSkillIdRoute = AppBotsSkillsSkillIdRouteImport.update({
  id: '/bots/skills/$skillId',
  path: '/bots/skills/$skillId',
  getParentRoute: () => AppRoute,
} as any)
const AppBotsSkillsNewRoute = AppBotsSkillsNewRouteImport.update({
  id: '/bots/skills/new',
  path: '/bots/skills/new',
  getParentRoute: () => AppRoute,
} as any)
const AppBotsToolsToolIdRoute = AppBotsToolsToolIdRouteImport.update({
  id: '/bots/tools/$toolId',
  path: '/bots/tools/$toolId',
  getParentRoute: () => AppRoute,
} as any)
const AppBotsToolsNewRoute = AppBotsToolsNewRouteImport.update({
  id: '/bots/tools/new',
  path: '/bots/tools/new',
  getParentRoute: () => AppRoute,
} as any)
const AppDataCenterCleaningIndexRoute =
  AppDataCenterCleaningIndexRouteImport.update({
    id: '/cleaning/',
    path: '/cleaning/',
    getParentRoute: () => AppDataCenterRouteRoute,
  } as any)
const AppDataCenterExportsExportIdRoute =
  AppDataCenterExportsExportIdRouteImport.update({
    id: '/exports_/$exportId',
    path: '/exports/$exportId',
    getParentRoute: () => AppDataCenterRouteRoute,
  } as any)
const AppDataCenterExtractionIndexRoute =
  AppDataCenterExtractionIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppDataCenterExtractionRouteRoute,
  } as any)
const AppDataCenterExtractionTaskIdRoute =
  AppDataCenterExtractionTaskIdRouteImport.update({
    id: '/$taskId',
    path: '/$taskId',
    getParentRoute: () => AppDataCenterExtractionRouteRoute,
  } as any)
const AppDataCenterExtractionCreateRoute =
  AppDataCenterExtractionCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AppDataCenterExtractionRouteRoute,
  } as any)
const AppDataCenterReviewIndexRoute =
  AppDataCenterReviewIndexRouteImport.update({
    id: '/review/',
    path: '/review/',
    getParentRoute: () => AppDataCenterRouteRoute,
  } as any)
const AppDataCenterTmplIndexRoute = AppDataCenterTmplIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppDataCenterTmplRouteRoute,
} as any)
const AppDataCenterTmplMetadataRoute =
  AppDataCenterTmplMetadataRouteImport.update({
    id: '/metadata',
    path: '/metadata',
    getParentRoute: () => AppDataCenterTmplRouteRoute,
  } as any)
const AppDataCenterTmplNewRoute = AppDataCenterTmplNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppDataCenterTmplRouteRoute,
} as any)
const AppDocGenerationTaskIdIndexRoute =
  AppDocGenerationTaskIdIndexRouteImport.update({
    id: '/doc-generation/$taskId/',
    path: '/doc-generation/$taskId/',
    getParentRoute: () => AppRoute,
  } as any)
const AppDocGenerationTaskIdArtifactRoute =
  AppDocGenerationTaskIdArtifactRouteImport.update({
    id: '/doc-generation/$taskId/artifact',
    path: '/doc-generation/$taskId/artifact',
    getParentRoute: () => AppRoute,
  } as any)
const AppDocGenerationTaskIdOutlineRoute =
  AppDocGenerationTaskIdOutlineRouteImport.update({
    id: '/doc-generation/$taskId/outline',
    path: '/doc-generation/$taskId/outline',
    getParentRoute: () => AppRoute,
  } as any)
const AppDocGenerationTaskIdWritingRoute =
  AppDocGenerationTaskIdWritingRouteImport.update({
    id: '/doc-generation/$taskId/writing',
    path: '/doc-generation/$taskId/writing',
    getParentRoute: () => AppRoute,
  } as any)
const AppKbKbIdIndexRoute = AppKbKbIdIndexRouteImport.update({
  id: '/$kbId/',
  path: '/$kbId/',
  getParentRoute: () => AppKbRouteRoute,
} as any)
const AppKbKbIdDocIdRoute = AppKbKbIdDocIdRouteImport.update({
  id: '/$kbId/$docId',
  path: '/$kbId/$docId',
  getParentRoute: () => AppKbRouteRoute,
} as any)
const AppKbKbIdSettingsRoute = AppKbKbIdSettingsRouteImport.update({
  id: '/$kbId/settings',
  path: '/$kbId/settings',
  getParentRoute: () => AppKbRouteRoute,
} as any)
const AppProjectsTemplatesIndexRoute =
  AppProjectsTemplatesIndexRouteImport.update({
    id: '/projects/templates/',
    path: '/projects/templates/',
    getParentRoute: () => AppRoute,
  } as any)
const AppProjectsTemplatesTemplateIdRoute =
  AppProjectsTemplatesTemplateIdRouteImport.update({
    id: '/projects/templates/$templateId',
    path: '/projects/templates/$templateId',
    getParentRoute: () => AppRoute,
  } as any)
const AppSemanticPlatformConceptsIndexRoute =
  AppSemanticPlatformConceptsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppSemanticPlatformConceptsRouteRoute,
  } as any)
const AppSemanticPlatformConceptsIdRoute =
  AppSemanticPlatformConceptsIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AppSemanticPlatformConceptsRouteRoute,
  } as any)
const AppSemanticPlatformDataAssetsIndexRoute =
  AppSemanticPlatformDataAssetsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppSemanticPlatformDataAssetsRouteRoute,
  } as any)
const AppSemanticPlatformDataAssetsAssetIdRoute =
  AppSemanticPlatformDataAssetsAssetIdRouteImport.update({
    id: '/$assetId',
    path: '/$assetId',
    getParentRoute: () => AppSemanticPlatformDataAssetsRouteRoute,
  } as any)
const AppSemanticPlatformDataModelsIndexRoute =
  AppSemanticPlatformDataModelsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppSemanticPlatformDataModelsRouteRoute,
  } as any)
const AppSemanticPlatformDataModelsIdRoute =
  AppSemanticPlatformDataModelsIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AppSemanticPlatformDataModelsRouteRoute,
  } as any)
const AppSemanticPlatformKnowledgeDebugIndexRoute =
  AppSemanticPlatformKnowledgeDebugIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppSemanticPlatformKnowledgeDebugRouteRoute,
  } as any)
const AppSemanticPlatformNamespacesIndexRoute =
  AppSemanticPlatformNamespacesIndexRouteImport.update({
    id: '/namespaces/',
    path: '/namespaces/',
    getParentRoute: () => AppSemanticPlatformRouteRoute,
  } as any)
const AppSemanticPlatformQuantitiesIndexRoute =
  AppSemanticPlatformQuantitiesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppSemanticPlatformQuantitiesRouteRoute,
  } as any)
const AppSemanticPlatformQuantitiesIdRoute =
  AppSemanticPlatformQuantitiesIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AppSemanticPlatformQuantitiesRouteRoute,
  } as any)
const AppSemanticPlatformTagsIndexRoute =
  AppSemanticPlatformTagsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppSemanticPlatformTagsRouteRoute,
  } as any)
const AppSemanticPlatformVocabulariesIndexRoute =
  AppSemanticPlatformVocabulariesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppSemanticPlatformVocabulariesRouteRoute,
  } as any)
const AppSemanticPlatformVocabulariesIdRoute =
  AppSemanticPlatformVocabulariesIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AppSemanticPlatformVocabulariesRouteRoute,
  } as any)
const AppSettingsAuditLogsIndexRoute =
  AppSettingsAuditLogsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppSettingsAuditLogsRoute,
  } as any)
const AppSettingsAuditLogsIdRoute = AppSettingsAuditLogsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AppSettingsAuditLogsRoute,
} as any)
const AppSettingsIndustryPacksIndexRoute =
  AppSettingsIndustryPacksIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppSettingsIndustryPacksRoute,
  } as any)
const AppSettingsIndustryPacksKeyRoute =
  AppSettingsIndustryPacksKeyRouteImport.update({
    id: '/$key',
    path: '/$key',
    getParentRoute: () => AppSettingsIndustryPacksRoute,
  } as any)
const AppSettingsTenantsTenantIdRoute =
  AppSettingsTenantsTenantIdRouteImport.update({
    id: '/$tenantId',
    path: '/$tenantId',
    getParentRoute: () => AppSettingsTenantsRouteRoute,
  } as any)
const AppTenantSettingsAuditLogsIndexRoute =
  AppTenantSettingsAuditLogsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppTenantSettingsAuditLogsRoute,
  } as any)
const AppTenantSettingsAuditLogsIdRoute =
  AppTenantSettingsAuditLogsIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AppTenantSettingsAuditLogsRoute,
  } as any)
const AppTenantSettingsIndustryPacksIndexRoute =
  AppTenantSettingsIndustryPacksIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppTenantSettingsIndustryPacksRoute,
  } as any)
const AppTenantSettingsIndustryPacksKeyRoute =
  AppTenantSettingsIndustryPacksKeyRouteImport.update({
    id: '/$key',
    path: '/$key',
    getParentRoute: () => AppTenantSettingsIndustryPacksRoute,
  } as any)
const AppTenantSettingsMetadataTemplatesIndexRoute =
  AppTenantSettingsMetadataTemplatesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppTenantSettingsMetadataTemplatesRoute,
  } as any)
const AppTenantSettingsSemanticGovernanceIndexRoute =
  AppTenantSettingsSemanticGovernanceIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppTenantSettingsSemanticGovernanceRoute,
  } as any)
const AppTenantSettingsSemanticGovernanceCategoriesRoute =
  AppTenantSettingsSemanticGovernanceCategoriesRouteImport.update({
    id: '/categories',
    path: '/categories',
    getParentRoute: () => AppTenantSettingsSemanticGovernanceRoute,
  } as any)
const AppTruthComparesCompareIdRoute =
  AppTruthComparesCompareIdRouteImport.update({
    id: '/$compareId',
    path: '/$compareId',
    getParentRoute: () => AppTruthComparesRoute,
  } as any)
const AppTruthRoundsSessionIdRoute = AppTruthRoundsSessionIdRouteImport.update({
  id: '/rounds/$sessionId',
  path: '/rounds/$sessionId',
  getParentRoute: () => AppTruthRouteRoute,
} as any)
const DataCenterReviewRunRunIdRoute =
  DataCenterReviewRunRunIdRouteImport.update({
    id: '/data-center/review/run/$runId',
    path: '/data-center/review/run/$runId',
    getParentRoute: () => rootRouteImport,
  } as any)
const AppDataCenterExtractionEditTaskIdRoute =
  AppDataCenterExtractionEditTaskIdRouteImport.update({
    id: '/edit/$taskId',
    path: '/edit/$taskId',
    getParentRoute: () => AppDataCenterExtractionRouteRoute,
  } as any)
const AppDataCenterTmplEditIdRoute = AppDataCenterTmplEditIdRouteImport.update({
  id: '/edit/$id',
  path: '/edit/$id',
  getParentRoute: () => AppDataCenterTmplRouteRoute,
} as any)
const AppDataCenterTmplVersionsIdRoute =
  AppDataCenterTmplVersionsIdRouteImport.update({
    id: '/versions/$id',
    path: '/versions/$id',
    getParentRoute: () => AppDataCenterTmplRouteRoute,
  } as any)
const AppSemanticPlatformDataAssetsBatchesBatchIdRoute =
  AppSemanticPlatformDataAssetsBatchesBatchIdRouteImport.update({
    id: '/batches/$batchId',
    path: '/batches/$batchId',
    getParentRoute: () => AppSemanticPlatformDataAssetsRouteRoute,
  } as any)
const AppSemanticPlatformDataAssetsEntitiesEntityIdRoute =
  AppSemanticPlatformDataAssetsEntitiesEntityIdRouteImport.update({
    id: '/entities/$entityId',
    path: '/entities/$entityId',
    getParentRoute: () => AppSemanticPlatformDataAssetsRouteRoute,
  } as any)
const AppSemanticPlatformDataGovernanceAnalysisIndexRoute =
  AppSemanticPlatformDataGovernanceAnalysisIndexRouteImport.update({
    id: '/analysis/',
    path: '/analysis/',
    getParentRoute: () => AppSemanticPlatformDataGovernanceRouteRoute,
  } as any)
const AppSemanticPlatformDataGovernanceClassificationsIndexRoute =
  AppSemanticPlatformDataGovernanceClassificationsIndexRouteImport.update({
    id: '/classifications/',
    path: '/classifications/',
    getParentRoute: () => AppSemanticPlatformDataGovernanceRouteRoute,
  } as any)
const AppSemanticPlatformDataGovernanceImpactIndexRoute =
  AppSemanticPlatformDataGovernanceImpactIndexRouteImport.update({
    id: '/impact/',
    path: '/impact/',
    getParentRoute: () => AppSemanticPlatformDataGovernanceRouteRoute,
  } as any)
const AppSemanticPlatformDataGovernanceQualityIndexRoute =
  AppSemanticPlatformDataGovernanceQualityIndexRouteImport.update({
    id: '/quality/',
    path: '/quality/',
    getParentRoute: () => AppSemanticPlatformDataGovernanceRouteRoute,
  } as any)
const AppSemanticPlatformDataGovernanceSuggestionsIndexRoute =
  AppSemanticPlatformDataGovernanceSuggestionsIndexRouteImport.update({
    id: '/suggestions/',
    path: '/suggestions/',
    getParentRoute: () => AppSemanticPlatformDataGovernanceRouteRoute,
  } as any)
const AppSemanticPlatformDataModelsEditIdRoute =
  AppSemanticPlatformDataModelsEditIdRouteImport.update({
    id: '/edit/$id',
    path: '/edit/$id',
    getParentRoute: () => AppSemanticPlatformDataModelsRouteRoute,
  } as any)
const AppSemanticPlatformTagCenterFieldsIndexRoute =
  AppSemanticPlatformTagCenterFieldsIndexRouteImport.update({
    id: '/fields/',
    path: '/fields/',
    getParentRoute: () => AppSemanticPlatformTagCenterRouteRoute,
  } as any)
const AppSemanticPlatformTagCenterStatsIndexRoute =
  AppSemanticPlatformTagCenterStatsIndexRouteImport.update({
    id: '/stats/',
    path: '/stats/',
    getParentRoute: () => AppSemanticPlatformTagCenterRouteRoute,
  } as any)
const AppSemanticPlatformTagCenterSuggestionsIndexRoute =
  AppSemanticPlatformTagCenterSuggestionsIndexRouteImport.update({
    id: '/suggestions/',
    path: '/suggestions/',
    getParentRoute: () => AppSemanticPlatformTagCenterRouteRoute,
  } as any)
const AppSettingsJobManagerScheduleScheduleIdRoute =
  AppSettingsJobManagerScheduleScheduleIdRouteImport.update({
    id: '/schedule/$scheduleId',
    path: '/schedule/$scheduleId',
    getParentRoute: () => AppSettingsJobManagerRouteRoute,
  } as any)
const AppSettingsJobManagerTaskTaskIdRoute =
  AppSettingsJobManagerTaskTaskIdRouteImport.update({
    id: '/task/$taskId',
    path: '/task/$taskId',
    getParentRoute: () => AppSettingsJobManagerRouteRoute,
  } as any)
const AppTenantSettingsSemanticGovernanceTermsNewRoute =
  AppTenantSettingsSemanticGovernanceTermsNewRouteImport.update({
    id: '/terms/new',
    path: '/terms/new',
    getParentRoute: () => AppTenantSettingsSemanticGovernanceRoute,
  } as any)
const AppKbKbIdCompilationArtifactsArtifactIdRoute =
  AppKbKbIdCompilationArtifactsArtifactIdRouteImport.update({
    id: '/$kbId/compilation/artifacts/$artifactId',
    path: '/$kbId/compilation/artifacts/$artifactId',
    getParentRoute: () => AppKbRouteRoute,
  } as any)
const AppKbKbIdCompilationRunsRunIdRoute =
  AppKbKbIdCompilationRunsRunIdRouteImport.update({
    id: '/$kbId/compilation/runs/$runId',
    path: '/$kbId/compilation/runs/$runId',
    getParentRoute: () => AppKbRouteRoute,
  } as any)
const AppKbKbIdSettingsTermsNewRoute =
  AppKbKbIdSettingsTermsNewRouteImport.update({
    id: '/terms/new',
    path: '/terms/new',
    getParentRoute: () => AppKbKbIdSettingsRoute,
  } as any)
const AppSettingsJobManagerScheduleScheduleIdTaskIdRoute =
  AppSettingsJobManagerScheduleScheduleIdTaskIdRouteImport.update({
    id: '/$taskId',
    path: '/$taskId',
    getParentRoute: () => AppSettingsJobManagerScheduleScheduleIdRoute,
  } as any)
const AppTenantSettingsSemanticGovernanceTermsEditIdRoute =
  AppTenantSettingsSemanticGovernanceTermsEditIdRouteImport.update({
    id: '/terms/edit/$id',
    path: '/terms/edit/$id',
    getParentRoute: () => AppTenantSettingsSemanticGovernanceRoute,
  } as any)
const AppKbKbIdSettingsTermsEditIdRoute =
  AppKbKbIdSettingsTermsEditIdRouteImport.update({
    id: '/terms/edit/$id',
    path: '/terms/edit/$id',
    getParentRoute: () => AppKbKbIdSettingsRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/excel-univer-demo': typeof ExcelUniverDemoRoute
  '/login': typeof LoginRoute
  '/ppt-editor-demo': typeof PptEditorDemoRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/register': typeof RegisterRoute
  '/word-editor-demo': typeof WordEditorDemoRoute
  '/data-center': typeof AppDataCenterRouteRouteWithChildren
  '/kb': typeof AppKbRouteRouteWithChildren
  '/semantic-platform': typeof AppSemanticPlatformRouteRouteWithChildren
  '/settings': typeof AppSettingsRouteRouteWithChildren
  '/tenant-settings': typeof AppTenantSettingsRouteRouteWithChildren
  '/truth': typeof AppTruthRouteRouteWithChildren
  '/account': typeof AppAccountRoute
  '/doc-center': typeof AppDocCenterRoute
  '/recycle-bin': typeof AppRecycleBinRoute
  '/search': typeof AppSearchRoute
  '/suggestions': typeof AppSuggestionsRoute
  '/invite/$inviteId': typeof InviteInviteIdRoute
  '/data-center/extraction': typeof AppDataCenterExtractionRouteRouteWithChildren
  '/data-center/tmpl': typeof AppDataCenterTmplRouteRouteWithChildren
  '/semantic-platform/concepts': typeof AppSemanticPlatformConceptsRouteRouteWithChildren
  '/semantic-platform/data-assets': typeof AppSemanticPlatformDataAssetsRouteRouteWithChildren
  '/semantic-platform/data-governance': typeof AppSemanticPlatformDataGovernanceRouteRouteWithChildren
  '/semantic-platform/data-models': typeof AppSemanticPlatformDataModelsRouteRouteWithChildren
  '/semantic-platform/knowledge-debug': typeof AppSemanticPlatformKnowledgeDebugRouteRouteWithChildren
  '/semantic-platform/quantities': typeof AppSemanticPlatformQuantitiesRouteRouteWithChildren
  '/semantic-platform/tag-center': typeof AppSemanticPlatformTagCenterRouteRouteWithChildren
  '/semantic-platform/tags': typeof AppSemanticPlatformTagsRouteRouteWithChildren
  '/semantic-platform/vocabularies': typeof AppSemanticPlatformVocabulariesRouteRouteWithChildren
  '/settings/job-manager': typeof AppSettingsJobManagerRouteRouteWithChildren
  '/settings/tenants': typeof AppSettingsTenantsRouteRouteWithChildren
  '/bots/new': typeof AppBotsNewRoute
  '/cad-edit/$id': typeof AppCadEditIdRoute
  '/data-center/datasources': typeof AppDataCenterDatasourcesRoute
  '/data-center/exports': typeof AppDataCenterExportsRoute
  '/data-center/metadata': typeof AppDataCenterMetadataRoute
  '/doc-generation/create': typeof AppDocGenerationCreateRoute
  '/doc-generation/templates': typeof AppDocGenerationTemplatesRoute
  '/doc-generation/writing-style': typeof AppDocGenerationWritingStyleRoute
  '/file-preview/$fileId': typeof AppFilePreviewFileIdRoute
  '/semantic-platform/data-lineage': typeof AppSemanticPlatformDataLineageRoute
  '/settings/ai-models': typeof AppSettingsAiModelsRoute
  '/settings/audit-logs': typeof AppSettingsAuditLogsRouteWithChildren
  '/settings/bots': typeof AppSettingsBotsRoute
  '/settings/data-sources': typeof AppSettingsDataSourcesRoute
  '/settings/database': typeof AppSettingsDatabaseRoute
  '/settings/help-docs': typeof AppSettingsHelpDocsRoute
  '/settings/industry-packs': typeof AppSettingsIndustryPacksRouteWithChildren
  '/settings/license': typeof AppSettingsLicenseRoute
  '/settings/metadata-templates': typeof AppSettingsMetadataTemplatesRoute
  '/settings/parser': typeof AppSettingsParserRoute
  '/settings/quota-management': typeof AppSettingsQuotaManagementRoute
  '/settings/storage-cleanup': typeof AppSettingsStorageCleanupRoute
  '/settings/system': typeof AppSettingsSystemRoute
  '/settings/system-status': typeof AppSettingsSystemStatusRoute
  '/ss-bid-gen/resources': typeof AppSsBidGenResourcesRoute
  '/tenant-settings/ai-models': typeof AppTenantSettingsAiModelsRoute
  '/tenant-settings/audit-logs': typeof AppTenantSettingsAuditLogsRouteWithChildren
  '/tenant-settings/bots': typeof AppTenantSettingsBotsRoute
  '/tenant-settings/data-sources': typeof AppTenantSettingsDataSourcesRoute
  '/tenant-settings/departments': typeof AppTenantSettingsDepartmentsRoute
  '/tenant-settings/doc-settings': typeof AppTenantSettingsDocSettingsRoute
  '/tenant-settings/document-security': typeof AppTenantSettingsDocumentSecurityRoute
  '/tenant-settings/industry-packs': typeof AppTenantSettingsIndustryPacksRouteWithChildren
  '/tenant-settings/invites': typeof AppTenantSettingsInvitesRoute
  '/tenant-settings/metadata-templates': typeof AppTenantSettingsMetadataTemplatesRouteWithChildren
  '/tenant-settings/parse-engines': typeof AppTenantSettingsParseEnginesRoute
  '/tenant-settings/permissions': typeof AppTenantSettingsPermissionsRoute
  '/tenant-settings/publications': typeof AppTenantSettingsPublicationsRoute
  '/tenant-settings/roles': typeof AppTenantSettingsRolesRoute
  '/tenant-settings/semantic-governance': typeof AppTenantSettingsSemanticGovernanceRouteWithChildren
  '/tenant-settings/share-governance': typeof AppTenantSettingsShareGovernanceRoute
  '/tenant-settings/system-status': typeof AppTenantSettingsSystemStatusRoute
  '/tenant-settings/tenant-info': typeof AppTenantSettingsTenantInfoRoute
  '/tenant-settings/users': typeof AppTenantSettingsUsersRoute
  '/truth/compares': typeof AppTruthComparesRouteWithChildren
  '/projects/$projectId': typeof WorkspaceProjectsProjectIdRoute
  '/data-center/cleaning/$id': typeof DataCenterCleaningIdRoute
  '/data-center/review/$taskId': typeof DataCenterReviewTaskIdRoute
  '/share/doc/$token': typeof ShareDocTokenRoute
  '/bot-market/': typeof AppBotMarketIndexRoute
  '/bots/': typeof AppBotsIndexRoute
  '/data-center/': typeof AppDataCenterIndexRoute
  '/doc-generation/': typeof AppDocGenerationIndexRoute
  '/kb/': typeof AppKbIndexRoute
  '/projects/': typeof AppProjectsIndexRoute
  '/semantic-platform/': typeof AppSemanticPlatformIndexRoute
  '/settings/': typeof AppSettingsIndexRoute
  '/tenant-settings/': typeof AppTenantSettingsIndexRoute
  '/truth/': typeof AppTruthIndexRoute
  '/workbench/': typeof AppWorkbenchIndexRoute
  '/bots/$botId/run': typeof AppBotsBotIdRunRoute
  '/bots/$botId/studio': typeof AppBotsBotIdStudioRoute
  '/bots/credentials/$credentialId': typeof AppBotsCredentialsCredentialIdRoute
  '/bots/credentials/new': typeof AppBotsCredentialsNewRoute
  '/bots/skills/$skillId': typeof AppBotsSkillsSkillIdRoute
  '/bots/skills/new': typeof AppBotsSkillsNewRoute
  '/bots/tools/$toolId': typeof AppBotsToolsToolIdRoute
  '/bots/tools/new': typeof AppBotsToolsNewRoute
  '/data-center/exports/$exportId': typeof AppDataCenterExportsExportIdRoute
  '/data-center/extraction/$taskId': typeof AppDataCenterExtractionTaskIdRoute
  '/data-center/extraction/create': typeof AppDataCenterExtractionCreateRoute
  '/data-center/tmpl/metadata': typeof AppDataCenterTmplMetadataRoute
  '/data-center/tmpl/new': typeof AppDataCenterTmplNewRoute
  '/doc-generation/$taskId/artifact': typeof AppDocGenerationTaskIdArtifactRoute
  '/doc-generation/$taskId/outline': typeof AppDocGenerationTaskIdOutlineRoute
  '/doc-generation/$taskId/writing': typeof AppDocGenerationTaskIdWritingRoute
  '/kb/$kbId/$docId': typeof AppKbKbIdDocIdRoute
  '/kb/$kbId/settings': typeof AppKbKbIdSettingsRouteWithChildren
  '/projects/templates/$templateId': typeof AppProjectsTemplatesTemplateIdRoute
  '/semantic-platform/concepts/$id': typeof AppSemanticPlatformConceptsIdRoute
  '/semantic-platform/data-assets/$assetId': typeof AppSemanticPlatformDataAssetsAssetIdRoute
  '/semantic-platform/data-models/$id': typeof AppSemanticPlatformDataModelsIdRoute
  '/semantic-platform/quantities/$id': typeof AppSemanticPlatformQuantitiesIdRoute
  '/semantic-platform/vocabularies/$id': typeof AppSemanticPlatformVocabulariesIdRoute
  '/settings/audit-logs/$id': typeof AppSettingsAuditLogsIdRoute
  '/settings/industry-packs/$key': typeof AppSettingsIndustryPacksKeyRoute
  '/settings/tenants/$tenantId': typeof AppSettingsTenantsTenantIdRoute
  '/tenant-settings/audit-logs/$id': typeof AppTenantSettingsAuditLogsIdRoute
  '/tenant-settings/industry-packs/$key': typeof AppTenantSettingsIndustryPacksKeyRoute
  '/tenant-settings/semantic-governance/categories': typeof AppTenantSettingsSemanticGovernanceCategoriesRoute
  '/truth/compares/$compareId': typeof AppTruthComparesCompareIdRoute
  '/truth/rounds/$sessionId': typeof AppTruthRoundsSessionIdRoute
  '/data-center/review/run/$runId': typeof DataCenterReviewRunRunIdRoute
  '/data-center/cleaning/': typeof AppDataCenterCleaningIndexRoute
  '/data-center/extraction/': typeof AppDataCenterExtractionIndexRoute
  '/data-center/review/': typeof AppDataCenterReviewIndexRoute
  '/data-center/tmpl/': typeof AppDataCenterTmplIndexRoute
  '/doc-generation/$taskId/': typeof AppDocGenerationTaskIdIndexRoute
  '/kb/$kbId/': typeof AppKbKbIdIndexRoute
  '/projects/templates/': typeof AppProjectsTemplatesIndexRoute
  '/semantic-platform/concepts/': typeof AppSemanticPlatformConceptsIndexRoute
  '/semantic-platform/data-assets/': typeof AppSemanticPlatformDataAssetsIndexRoute
  '/semantic-platform/data-models/': typeof AppSemanticPlatformDataModelsIndexRoute
  '/semantic-platform/knowledge-debug/': typeof AppSemanticPlatformKnowledgeDebugIndexRoute
  '/semantic-platform/namespaces/': typeof AppSemanticPlatformNamespacesIndexRoute
  '/semantic-platform/quantities/': typeof AppSemanticPlatformQuantitiesIndexRoute
  '/semantic-platform/tags/': typeof AppSemanticPlatformTagsIndexRoute
  '/semantic-platform/vocabularies/': typeof AppSemanticPlatformVocabulariesIndexRoute
  '/settings/audit-logs/': typeof AppSettingsAuditLogsIndexRoute
  '/settings/industry-packs/': typeof AppSettingsIndustryPacksIndexRoute
  '/tenant-settings/audit-logs/': typeof AppTenantSettingsAuditLogsIndexRoute
  '/tenant-settings/industry-packs/': typeof AppTenantSettingsIndustryPacksIndexRoute
  '/tenant-settings/metadata-templates/': typeof AppTenantSettingsMetadataTemplatesIndexRoute
  '/tenant-settings/semantic-governance/': typeof AppTenantSettingsSemanticGovernanceIndexRoute
  '/data-center/extraction/edit/$taskId': typeof AppDataCenterExtractionEditTaskIdRoute
  '/data-center/tmpl/edit/$id': typeof AppDataCenterTmplEditIdRoute
  '/data-center/tmpl/versions/$id': typeof AppDataCenterTmplVersionsIdRoute
  '/semantic-platform/data-assets/batches/$batchId': typeof AppSemanticPlatformDataAssetsBatchesBatchIdRoute
  '/semantic-platform/data-assets/entities/$entityId': typeof AppSemanticPlatformDataAssetsEntitiesEntityIdRoute
  '/semantic-platform/data-models/edit/$id': typeof AppSemanticPlatformDataModelsEditIdRoute
  '/settings/job-manager/schedule/$scheduleId': typeof AppSettingsJobManagerScheduleScheduleIdRouteWithChildren
  '/settings/job-manager/task/$taskId': typeof AppSettingsJobManagerTaskTaskIdRoute
  '/tenant-settings/semantic-governance/terms/new': typeof AppTenantSettingsSemanticGovernanceTermsNewRoute
  '/semantic-platform/data-governance/analysis/': typeof AppSemanticPlatformDataGovernanceAnalysisIndexRoute
  '/semantic-platform/data-governance/classifications/': typeof AppSemanticPlatformDataGovernanceClassificationsIndexRoute
  '/semantic-platform/data-governance/impact/': typeof AppSemanticPlatformDataGovernanceImpactIndexRoute
  '/semantic-platform/data-governance/quality/': typeof AppSemanticPlatformDataGovernanceQualityIndexRoute
  '/semantic-platform/data-governance/suggestions/': typeof AppSemanticPlatformDataGovernanceSuggestionsIndexRoute
  '/semantic-platform/tag-center/fields/': typeof AppSemanticPlatformTagCenterFieldsIndexRoute
  '/semantic-platform/tag-center/stats/': typeof AppSemanticPlatformTagCenterStatsIndexRoute
  '/semantic-platform/tag-center/suggestions/': typeof AppSemanticPlatformTagCenterSuggestionsIndexRoute
  '/kb/$kbId/compilation/artifacts/$artifactId': typeof AppKbKbIdCompilationArtifactsArtifactIdRoute
  '/kb/$kbId/compilation/runs/$runId': typeof AppKbKbIdCompilationRunsRunIdRoute
  '/kb/$kbId/settings/terms/new': typeof AppKbKbIdSettingsTermsNewRoute
  '/settings/job-manager/schedule/$scheduleId/$taskId': typeof AppSettingsJobManagerScheduleScheduleIdTaskIdRoute
  '/tenant-settings/semantic-governance/terms/edit/$id': typeof AppTenantSettingsSemanticGovernanceTermsEditIdRoute
  '/kb/$kbId/settings/terms/edit/$id': typeof AppKbKbIdSettingsTermsEditIdRoute
}
export interface FileRoutesByTo {
  '/': typeof AppIndexRoute
  '/excel-univer-demo': typeof ExcelUniverDemoRoute
  '/login': typeof LoginRoute
  '/ppt-editor-demo': typeof PptEditorDemoRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/register': typeof RegisterRoute
  '/word-editor-demo': typeof WordEditorDemoRoute
  '/account': typeof AppAccountRoute
  '/doc-center': typeof AppDocCenterRoute
  '/recycle-bin': typeof AppRecycleBinRoute
  '/search': typeof AppSearchRoute
  '/suggestions': typeof AppSuggestionsRoute
  '/invite/$inviteId': typeof InviteInviteIdRoute
  '/semantic-platform/data-governance': typeof AppSemanticPlatformDataGovernanceRouteRouteWithChildren
  '/semantic-platform/tag-center': typeof AppSemanticPlatformTagCenterRouteRouteWithChildren
  '/settings/job-manager': typeof AppSettingsJobManagerRouteRouteWithChildren
  '/settings/tenants': typeof AppSettingsTenantsRouteRouteWithChildren
  '/bots/new': typeof AppBotsNewRoute
  '/cad-edit/$id': typeof AppCadEditIdRoute
  '/data-center/datasources': typeof AppDataCenterDatasourcesRoute
  '/data-center/exports': typeof AppDataCenterExportsRoute
  '/data-center/metadata': typeof AppDataCenterMetadataRoute
  '/doc-generation/create': typeof AppDocGenerationCreateRoute
  '/doc-generation/templates': typeof AppDocGenerationTemplatesRoute
  '/doc-generation/writing-style': typeof AppDocGenerationWritingStyleRoute
  '/file-preview/$fileId': typeof AppFilePreviewFileIdRoute
  '/semantic-platform/data-lineage': typeof AppSemanticPlatformDataLineageRoute
  '/settings/ai-models': typeof AppSettingsAiModelsRoute
  '/settings/bots': typeof AppSettingsBotsRoute
  '/settings/data-sources': typeof AppSettingsDataSourcesRoute
  '/settings/database': typeof AppSettingsDatabaseRoute
  '/settings/help-docs': typeof AppSettingsHelpDocsRoute
  '/settings/license': typeof AppSettingsLicenseRoute
  '/settings/metadata-templates': typeof AppSettingsMetadataTemplatesRoute
  '/settings/parser': typeof AppSettingsParserRoute
  '/settings/quota-management': typeof AppSettingsQuotaManagementRoute
  '/settings/storage-cleanup': typeof AppSettingsStorageCleanupRoute
  '/settings/system': typeof AppSettingsSystemRoute
  '/settings/system-status': typeof AppSettingsSystemStatusRoute
  '/ss-bid-gen/resources': typeof AppSsBidGenResourcesRoute
  '/tenant-settings/ai-models': typeof AppTenantSettingsAiModelsRoute
  '/tenant-settings/bots': typeof AppTenantSettingsBotsRoute
  '/tenant-settings/data-sources': typeof AppTenantSettingsDataSourcesRoute
  '/tenant-settings/departments': typeof AppTenantSettingsDepartmentsRoute
  '/tenant-settings/doc-settings': typeof AppTenantSettingsDocSettingsRoute
  '/tenant-settings/document-security': typeof AppTenantSettingsDocumentSecurityRoute
  '/tenant-settings/invites': typeof AppTenantSettingsInvitesRoute
  '/tenant-settings/parse-engines': typeof AppTenantSettingsParseEnginesRoute
  '/tenant-settings/permissions': typeof AppTenantSettingsPermissionsRoute
  '/tenant-settings/publications': typeof AppTenantSettingsPublicationsRoute
  '/tenant-settings/roles': typeof AppTenantSettingsRolesRoute
  '/tenant-settings/share-governance': typeof AppTenantSettingsShareGovernanceRoute
  '/tenant-settings/system-status': typeof AppTenantSettingsSystemStatusRoute
  '/tenant-settings/tenant-info': typeof AppTenantSettingsTenantInfoRoute
  '/tenant-settings/users': typeof AppTenantSettingsUsersRoute
  '/truth/compares': typeof AppTruthComparesRouteWithChildren
  '/projects/$projectId': typeof WorkspaceProjectsProjectIdRoute
  '/data-center/cleaning/$id': typeof DataCenterCleaningIdRoute
  '/data-center/review/$taskId': typeof DataCenterReviewTaskIdRoute
  '/share/doc/$token': typeof ShareDocTokenRoute
  '/bot-market': typeof AppBotMarketIndexRoute
  '/bots': typeof AppBotsIndexRoute
  '/data-center': typeof AppDataCenterIndexRoute
  '/doc-generation': typeof AppDocGenerationIndexRoute
  '/kb': typeof AppKbIndexRoute
  '/projects': typeof AppProjectsIndexRoute
  '/semantic-platform': typeof AppSemanticPlatformIndexRoute
  '/settings': typeof AppSettingsIndexRoute
  '/tenant-settings': typeof AppTenantSettingsIndexRoute
  '/truth': typeof AppTruthIndexRoute
  '/workbench': typeof AppWorkbenchIndexRoute
  '/bots/$botId/run': typeof AppBotsBotIdRunRoute
  '/bots/$botId/studio': typeof AppBotsBotIdStudioRoute
  '/bots/credentials/$credentialId': typeof AppBotsCredentialsCredentialIdRoute
  '/bots/credentials/new': typeof AppBotsCredentialsNewRoute
  '/bots/skills/$skillId': typeof AppBotsSkillsSkillIdRoute
  '/bots/skills/new': typeof AppBotsSkillsNewRoute
  '/bots/tools/$toolId': typeof AppBotsToolsToolIdRoute
  '/bots/tools/new': typeof AppBotsToolsNewRoute
  '/data-center/exports/$exportId': typeof AppDataCenterExportsExportIdRoute
  '/data-center/extraction/$taskId': typeof AppDataCenterExtractionTaskIdRoute
  '/data-center/extraction/create': typeof AppDataCenterExtractionCreateRoute
  '/data-center/tmpl/metadata': typeof AppDataCenterTmplMetadataRoute
  '/data-center/tmpl/new': typeof AppDataCenterTmplNewRoute
  '/doc-generation/$taskId/artifact': typeof AppDocGenerationTaskIdArtifactRoute
  '/doc-generation/$taskId/outline': typeof AppDocGenerationTaskIdOutlineRoute
  '/doc-generation/$taskId/writing': typeof AppDocGenerationTaskIdWritingRoute
  '/kb/$kbId/$docId': typeof AppKbKbIdDocIdRoute
  '/kb/$kbId/settings': typeof AppKbKbIdSettingsRouteWithChildren
  '/projects/templates/$templateId': typeof AppProjectsTemplatesTemplateIdRoute
  '/semantic-platform/concepts/$id': typeof AppSemanticPlatformConceptsIdRoute
  '/semantic-platform/data-assets/$assetId': typeof AppSemanticPlatformDataAssetsAssetIdRoute
  '/semantic-platform/data-models/$id': typeof AppSemanticPlatformDataModelsIdRoute
  '/semantic-platform/quantities/$id': typeof AppSemanticPlatformQuantitiesIdRoute
  '/semantic-platform/vocabularies/$id': typeof AppSemanticPlatformVocabulariesIdRoute
  '/settings/audit-logs/$id': typeof AppSettingsAuditLogsIdRoute
  '/settings/industry-packs/$key': typeof AppSettingsIndustryPacksKeyRoute
  '/settings/tenants/$tenantId': typeof AppSettingsTenantsTenantIdRoute
  '/tenant-settings/audit-logs/$id': typeof AppTenantSettingsAuditLogsIdRoute
  '/tenant-settings/industry-packs/$key': typeof AppTenantSettingsIndustryPacksKeyRoute
  '/tenant-settings/semantic-governance/categories': typeof AppTenantSettingsSemanticGovernanceCategoriesRoute
  '/truth/compares/$compareId': typeof AppTruthComparesCompareIdRoute
  '/truth/rounds/$sessionId': typeof AppTruthRoundsSessionIdRoute
  '/data-center/review/run/$runId': typeof DataCenterReviewRunRunIdRoute
  '/data-center/cleaning': typeof AppDataCenterCleaningIndexRoute
  '/data-center/extraction': typeof AppDataCenterExtractionIndexRoute
  '/data-center/review': typeof AppDataCenterReviewIndexRoute
  '/data-center/tmpl': typeof AppDataCenterTmplIndexRoute
  '/doc-generation/$taskId': typeof AppDocGenerationTaskIdIndexRoute
  '/kb/$kbId': typeof AppKbKbIdIndexRoute
  '/projects/templates': typeof AppProjectsTemplatesIndexRoute
  '/semantic-platform/concepts': typeof AppSemanticPlatformConceptsIndexRoute
  '/semantic-platform/data-assets': typeof AppSemanticPlatformDataAssetsIndexRoute
  '/semantic-platform/data-models': typeof AppSemanticPlatformDataModelsIndexRoute
  '/semantic-platform/knowledge-debug': typeof AppSemanticPlatformKnowledgeDebugIndexRoute
  '/semantic-platform/namespaces': typeof AppSemanticPlatformNamespacesIndexRoute
  '/semantic-platform/quantities': typeof AppSemanticPlatformQuantitiesIndexRoute
  '/semantic-platform/tags': typeof AppSemanticPlatformTagsIndexRoute
  '/semantic-platform/vocabularies': typeof AppSemanticPlatformVocabulariesIndexRoute
  '/settings/audit-logs': typeof AppSettingsAuditLogsIndexRoute
  '/settings/industry-packs': typeof AppSettingsIndustryPacksIndexRoute
  '/tenant-settings/audit-logs': typeof AppTenantSettingsAuditLogsIndexRoute
  '/tenant-settings/industry-packs': typeof AppTenantSettingsIndustryPacksIndexRoute
  '/tenant-settings/metadata-templates': typeof AppTenantSettingsMetadataTemplatesIndexRoute
  '/tenant-settings/semantic-governance': typeof AppTenantSettingsSemanticGovernanceIndexRoute
  '/data-center/extraction/edit/$taskId': typeof AppDataCenterExtractionEditTaskIdRoute
  '/data-center/tmpl/edit/$id': typeof AppDataCenterTmplEditIdRoute
  '/data-center/tmpl/versions/$id': typeof AppDataCenterTmplVersionsIdRoute
  '/semantic-platform/data-assets/batches/$batchId': typeof AppSemanticPlatformDataAssetsBatchesBatchIdRoute
  '/semantic-platform/data-assets/entities/$entityId': typeof AppSemanticPlatformDataAssetsEntitiesEntityIdRoute
  '/semantic-platform/data-models/edit/$id': typeof AppSemanticPlatformDataModelsEditIdRoute
  '/settings/job-manager/schedule/$scheduleId': typeof AppSettingsJobManagerScheduleScheduleIdRouteWithChildren
  '/settings/job-manager/task/$taskId': typeof AppSettingsJobManagerTaskTaskIdRoute
  '/tenant-settings/semantic-governance/terms/new': typeof AppTenantSettingsSemanticGovernanceTermsNewRoute
  '/semantic-platform/data-governance/analysis': typeof AppSemanticPlatformDataGovernanceAnalysisIndexRoute
  '/semantic-platform/data-governance/classifications': typeof AppSemanticPlatformDataGovernanceClassificationsIndexRoute
  '/semantic-platform/data-governance/impact': typeof AppSemanticPlatformDataGovernanceImpactIndexRoute
  '/semantic-platform/data-governance/quality': typeof AppSemanticPlatformDataGovernanceQualityIndexRoute
  '/semantic-platform/data-governance/suggestions': typeof AppSemanticPlatformDataGovernanceSuggestionsIndexRoute
  '/semantic-platform/tag-center/fields': typeof AppSemanticPlatformTagCenterFieldsIndexRoute
  '/semantic-platform/tag-center/stats': typeof AppSemanticPlatformTagCenterStatsIndexRoute
  '/semantic-platform/tag-center/suggestions': typeof AppSemanticPlatformTagCenterSuggestionsIndexRoute
  '/kb/$kbId/compilation/artifacts/$artifactId': typeof AppKbKbIdCompilationArtifactsArtifactIdRoute
  '/kb/$kbId/compilation/runs/$runId': typeof AppKbKbIdCompilationRunsRunIdRoute
  '/kb/$kbId/settings/terms/new': typeof AppKbKbIdSettingsTermsNewRoute
  '/settings/job-manager/schedule/$scheduleId/$taskId': typeof AppSettingsJobManagerScheduleScheduleIdTaskIdRoute
  '/tenant-settings/semantic-governance/terms/edit/$id': typeof AppTenantSettingsSemanticGovernanceTermsEditIdRoute
  '/kb/$kbId/settings/terms/edit/$id': typeof AppKbKbIdSettingsTermsEditIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/_workspace': typeof WorkspaceRouteWithChildren
  '/excel-univer-demo': typeof ExcelUniverDemoRoute
  '/login': typeof LoginRoute
  '/ppt-editor-demo': typeof PptEditorDemoRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/register': typeof RegisterRoute
  '/word-editor-demo': typeof WordEditorDemoRoute
  '/_app/data-center': typeof AppDataCenterRouteRouteWithChildren
  '/_app/kb': typeof AppKbRouteRouteWithChildren
  '/_app/semantic-platform': typeof AppSemanticPlatformRouteRouteWithChildren
  '/_app/settings': typeof AppSettingsRouteRouteWithChildren
  '/_app/tenant-settings': typeof AppTenantSettingsRouteRouteWithChildren
  '/_app/truth': typeof AppTruthRouteRouteWithChildren
  '/_app/account': typeof AppAccountRoute
  '/_app/doc-center': typeof AppDocCenterRoute
  '/_app/recycle-bin': typeof AppRecycleBinRoute
  '/_app/search': typeof AppSearchRoute
  '/_app/suggestions': typeof AppSuggestionsRoute
  '/invite/$inviteId': typeof InviteInviteIdRoute
  '/_app/': typeof AppIndexRoute
  '/_app/data-center/extraction': typeof AppDataCenterExtractionRouteRouteWithChildren
  '/_app/data-center/tmpl': typeof AppDataCenterTmplRouteRouteWithChildren
  '/_app/semantic-platform/concepts': typeof AppSemanticPlatformConceptsRouteRouteWithChildren
  '/_app/semantic-platform/data-assets': typeof AppSemanticPlatformDataAssetsRouteRouteWithChildren
  '/_app/semantic-platform/data-governance': typeof AppSemanticPlatformDataGovernanceRouteRouteWithChildren
  '/_app/semantic-platform/data-models': typeof AppSemanticPlatformDataModelsRouteRouteWithChildren
  '/_app/semantic-platform/knowledge-debug': typeof AppSemanticPlatformKnowledgeDebugRouteRouteWithChildren
  '/_app/semantic-platform/quantities': typeof AppSemanticPlatformQuantitiesRouteRouteWithChildren
  '/_app/semantic-platform/tag-center': typeof AppSemanticPlatformTagCenterRouteRouteWithChildren
  '/_app/semantic-platform/tags': typeof AppSemanticPlatformTagsRouteRouteWithChildren
  '/_app/semantic-platform/vocabularies': typeof AppSemanticPlatformVocabulariesRouteRouteWithChildren
  '/_app/settings/job-manager': typeof AppSettingsJobManagerRouteRouteWithChildren
  '/_app/settings/tenants': typeof AppSettingsTenantsRouteRouteWithChildren
  '/_app/bots/new': typeof AppBotsNewRoute
  '/_app/cad-edit/$id': typeof AppCadEditIdRoute
  '/_app/data-center/datasources': typeof AppDataCenterDatasourcesRoute
  '/_app/data-center/exports': typeof AppDataCenterExportsRoute
  '/_app/data-center/metadata': typeof AppDataCenterMetadataRoute
  '/_app/doc-generation/create': typeof AppDocGenerationCreateRoute
  '/_app/doc-generation/templates': typeof AppDocGenerationTemplatesRoute
  '/_app/doc-generation/writing-style': typeof AppDocGenerationWritingStyleRoute
  '/_app/file-preview/$fileId': typeof AppFilePreviewFileIdRoute
  '/_app/semantic-platform/data-lineage': typeof AppSemanticPlatformDataLineageRoute
  '/_app/settings/ai-models': typeof AppSettingsAiModelsRoute
  '/_app/settings/audit-logs': typeof AppSettingsAuditLogsRouteWithChildren
  '/_app/settings/bots': typeof AppSettingsBotsRoute
  '/_app/settings/data-sources': typeof AppSettingsDataSourcesRoute
  '/_app/settings/database': typeof AppSettingsDatabaseRoute
  '/_app/settings/help-docs': typeof AppSettingsHelpDocsRoute
  '/_app/settings/industry-packs': typeof AppSettingsIndustryPacksRouteWithChildren
  '/_app/settings/license': typeof AppSettingsLicenseRoute
  '/_app/settings/metadata-templates': typeof AppSettingsMetadataTemplatesRoute
  '/_app/settings/parser': typeof AppSettingsParserRoute
  '/_app/settings/quota-management': typeof AppSettingsQuotaManagementRoute
  '/_app/settings/storage-cleanup': typeof AppSettingsStorageCleanupRoute
  '/_app/settings/system': typeof AppSettingsSystemRoute
  '/_app/settings/system-status': typeof AppSettingsSystemStatusRoute
  '/_app/ss-bid-gen/resources': typeof AppSsBidGenResourcesRoute
  '/_app/tenant-settings/ai-models': typeof AppTenantSettingsAiModelsRoute
  '/_app/tenant-settings/audit-logs': typeof AppTenantSettingsAuditLogsRouteWithChildren
  '/_app/tenant-settings/bots': typeof AppTenantSettingsBotsRoute
  '/_app/tenant-settings/data-sources': typeof AppTenantSettingsDataSourcesRoute
  '/_app/tenant-settings/departments': typeof AppTenantSettingsDepartmentsRoute
  '/_app/tenant-settings/doc-settings': typeof AppTenantSettingsDocSettingsRoute
  '/_app/tenant-settings/document-security': typeof AppTenantSettingsDocumentSecurityRoute
  '/_app/tenant-settings/industry-packs': typeof AppTenantSettingsIndustryPacksRouteWithChildren
  '/_app/tenant-settings/invites': typeof AppTenantSettingsInvitesRoute
  '/_app/tenant-settings/metadata-templates': typeof AppTenantSettingsMetadataTemplatesRouteWithChildren
  '/_app/tenant-settings/parse-engines': typeof AppTenantSettingsParseEnginesRoute
  '/_app/tenant-settings/permissions': typeof AppTenantSettingsPermissionsRoute
  '/_app/tenant-settings/publications': typeof AppTenantSettingsPublicationsRoute
  '/_app/tenant-settings/roles': typeof AppTenantSettingsRolesRoute
  '/_app/tenant-settings/semantic-governance': typeof AppTenantSettingsSemanticGovernanceRouteWithChildren
  '/_app/tenant-settings/share-governance': typeof AppTenantSettingsShareGovernanceRoute
  '/_app/tenant-settings/system-status': typeof AppTenantSettingsSystemStatusRoute
  '/_app/tenant-settings/tenant-info': typeof AppTenantSettingsTenantInfoRoute
  '/_app/tenant-settings/users': typeof AppTenantSettingsUsersRoute
  '/_app/truth/compares': typeof AppTruthComparesRouteWithChildren
  '/_workspace/projects/$projectId': typeof WorkspaceProjectsProjectIdRoute
  '/data-center/cleaning/$id': typeof DataCenterCleaningIdRoute
  '/data-center/review/$taskId': typeof DataCenterReviewTaskIdRoute
  '/share/doc/$token': typeof ShareDocTokenRoute
  '/_app/bot-market/': typeof AppBotMarketIndexRoute
  '/_app/bots/': typeof AppBotsIndexRoute
  '/_app/data-center/': typeof AppDataCenterIndexRoute
  '/_app/doc-generation/': typeof AppDocGenerationIndexRoute
  '/_app/kb/': typeof AppKbIndexRoute
  '/_app/projects/': typeof AppProjectsIndexRoute
  '/_app/semantic-platform/': typeof AppSemanticPlatformIndexRoute
  '/_app/settings/': typeof AppSettingsIndexRoute
  '/_app/tenant-settings/': typeof AppTenantSettingsIndexRoute
  '/_app/truth/': typeof AppTruthIndexRoute
  '/_app/workbench/': typeof AppWorkbenchIndexRoute
  '/_app/bots/$botId/run': typeof AppBotsBotIdRunRoute
  '/_app/bots/$botId/studio': typeof AppBotsBotIdStudioRoute
  '/_app/bots/credentials/$credentialId': typeof AppBotsCredentialsCredentialIdRoute
  '/_app/bots/credentials/new': typeof AppBotsCredentialsNewRoute
  '/_app/bots/skills/$skillId': typeof AppBotsSkillsSkillIdRoute
  '/_app/bots/skills/new': typeof AppBotsSkillsNewRoute
  '/_app/bots/tools/$toolId': typeof AppBotsToolsToolIdRoute
  '/_app/bots/tools/new': typeof AppBotsToolsNewRoute
  '/_app/data-center/exports_/$exportId': typeof AppDataCenterExportsExportIdRoute
  '/_app/data-center/extraction/$taskId': typeof AppDataCenterExtractionTaskIdRoute
  '/_app/data-center/extraction/create': typeof AppDataCenterExtractionCreateRoute
  '/_app/data-center/tmpl/metadata': typeof AppDataCenterTmplMetadataRoute
  '/_app/data-center/tmpl/new': typeof AppDataCenterTmplNewRoute
  '/_app/doc-generation/$taskId/artifact': typeof AppDocGenerationTaskIdArtifactRoute
  '/_app/doc-generation/$taskId/outline': typeof AppDocGenerationTaskIdOutlineRoute
  '/_app/doc-generation/$taskId/writing': typeof AppDocGenerationTaskIdWritingRoute
  '/_app/kb/$kbId/$docId': typeof AppKbKbIdDocIdRoute
  '/_app/kb/$kbId/settings': typeof AppKbKbIdSettingsRouteWithChildren
  '/_app/projects/templates/$templateId': typeof AppProjectsTemplatesTemplateIdRoute
  '/_app/semantic-platform/concepts/$id': typeof AppSemanticPlatformConceptsIdRoute
  '/_app/semantic-platform/data-assets/$assetId': typeof AppSemanticPlatformDataAssetsAssetIdRoute
  '/_app/semantic-platform/data-models/$id': typeof AppSemanticPlatformDataModelsIdRoute
  '/_app/semantic-platform/quantities/$id': typeof AppSemanticPlatformQuantitiesIdRoute
  '/_app/semantic-platform/vocabularies/$id': typeof AppSemanticPlatformVocabulariesIdRoute
  '/_app/settings/audit-logs/$id': typeof AppSettingsAuditLogsIdRoute
  '/_app/settings/industry-packs/$key': typeof AppSettingsIndustryPacksKeyRoute
  '/_app/settings/tenants/$tenantId': typeof AppSettingsTenantsTenantIdRoute
  '/_app/tenant-settings/audit-logs/$id': typeof AppTenantSettingsAuditLogsIdRoute
  '/_app/tenant-settings/industry-packs/$key': typeof AppTenantSettingsIndustryPacksKeyRoute
  '/_app/tenant-settings/semantic-governance/categories': typeof AppTenantSettingsSemanticGovernanceCategoriesRoute
  '/_app/truth/compares/$compareId': typeof AppTruthComparesCompareIdRoute
  '/_app/truth/rounds/$sessionId': typeof AppTruthRoundsSessionIdRoute
  '/data-center/review/run/$runId': typeof DataCenterReviewRunRunIdRoute
  '/_app/data-center/cleaning/': typeof AppDataCenterCleaningIndexRoute
  '/_app/data-center/extraction/': typeof AppDataCenterExtractionIndexRoute
  '/_app/data-center/review/': typeof AppDataCenterReviewIndexRoute
  '/_app/data-center/tmpl/': typeof AppDataCenterTmplIndexRoute
  '/_app/doc-generation/$taskId/': typeof AppDocGenerationTaskIdIndexRoute
  '/_app/kb/$kbId/': typeof AppKbKbIdIndexRoute
  '/_app/projects/templates/': typeof AppProjectsTemplatesIndexRoute
  '/_app/semantic-platform/concepts/': typeof AppSemanticPlatformConceptsIndexRoute
  '/_app/semantic-platform/data-assets/': typeof AppSemanticPlatformDataAssetsIndexRoute
  '/_app/semantic-platform/data-models/': typeof AppSemanticPlatformDataModelsIndexRoute
  '/_app/semantic-platform/knowledge-debug/': typeof AppSemanticPlatformKnowledgeDebugIndexRoute
  '/_app/semantic-platform/namespaces/': typeof AppSemanticPlatformNamespacesIndexRoute
  '/_app/semantic-platform/quantities/': typeof AppSemanticPlatformQuantitiesIndexRoute
  '/_app/semantic-platform/tags/': typeof AppSemanticPlatformTagsIndexRoute
  '/_app/semantic-platform/vocabularies/': typeof AppSemanticPlatformVocabulariesIndexRoute
  '/_app/settings/audit-logs/': typeof AppSettingsAuditLogsIndexRoute
  '/_app/settings/industry-packs/': typeof AppSettingsIndustryPacksIndexRoute
  '/_app/tenant-settings/audit-logs/': typeof AppTenantSettingsAuditLogsIndexRoute
  '/_app/tenant-settings/industry-packs/': typeof AppTenantSettingsIndustryPacksIndexRoute
  '/_app/tenant-settings/metadata-templates/': typeof AppTenantSettingsMetadataTemplatesIndexRoute
  '/_app/tenant-settings/semantic-governance/': typeof AppTenantSettingsSemanticGovernanceIndexRoute
  '/_app/data-center/extraction/edit/$taskId': typeof AppDataCenterExtractionEditTaskIdRoute
  '/_app/data-center/tmpl/edit/$id': typeof AppDataCenterTmplEditIdRoute
  '/_app/data-center/tmpl/versions/$id': typeof AppDataCenterTmplVersionsIdRoute
  '/_app/semantic-platform/data-assets/batches/$batchId': typeof AppSemanticPlatformDataAssetsBatchesBatchIdRoute
  '/_app/semantic-platform/data-assets/entities/$entityId': typeof AppSemanticPlatformDataAssetsEntitiesEntityIdRoute
  '/_app/semantic-platform/data-models/edit/$id': typeof AppSemanticPlatformDataModelsEditIdRoute
  '/_app/settings/job-manager/schedule/$scheduleId': typeof AppSettingsJobManagerScheduleScheduleIdRouteWithChildren
  '/_app/settings/job-manager/task/$taskId': typeof AppSettingsJobManagerTaskTaskIdRoute
  '/_app/tenant-settings/semantic-governance/terms/new': typeof AppTenantSettingsSemanticGovernanceTermsNewRoute
  '/_app/semantic-platform/data-governance/analysis/': typeof AppSemanticPlatformDataGovernanceAnalysisIndexRoute
  '/_app/semantic-platform/data-governance/classifications/': typeof AppSemanticPlatformDataGovernanceClassificationsIndexRoute
  '/_app/semantic-platform/data-governance/impact/': typeof AppSemanticPlatformDataGovernanceImpactIndexRoute
  '/_app/semantic-platform/data-governance/quality/': typeof AppSemanticPlatformDataGovernanceQualityIndexRoute
  '/_app/semantic-platform/data-governance/suggestions/': typeof AppSemanticPlatformDataGovernanceSuggestionsIndexRoute
  '/_app/semantic-platform/tag-center/fields/': typeof AppSemanticPlatformTagCenterFieldsIndexRoute
  '/_app/semantic-platform/tag-center/stats/': typeof AppSemanticPlatformTagCenterStatsIndexRoute
  '/_app/semantic-platform/tag-center/suggestions/': typeof AppSemanticPlatformTagCenterSuggestionsIndexRoute
  '/_app/kb/$kbId/compilation/artifacts/$artifactId': typeof AppKbKbIdCompilationArtifactsArtifactIdRoute
  '/_app/kb/$kbId/compilation/runs/$runId': typeof AppKbKbIdCompilationRunsRunIdRoute
  '/_app/kb/$kbId/settings/terms/new': typeof AppKbKbIdSettingsTermsNewRoute
  '/_app/settings/job-manager/schedule/$scheduleId/$taskId': typeof AppSettingsJobManagerScheduleScheduleIdTaskIdRoute
  '/_app/tenant-settings/semantic-governance/terms/edit/$id': typeof AppTenantSettingsSemanticGovernanceTermsEditIdRoute
  '/_app/kb/$kbId/settings/terms/edit/$id': typeof AppKbKbIdSettingsTermsEditIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/excel-univer-demo'
    | '/login'
    | '/ppt-editor-demo'
    | '/privacy-policy'
    | '/register'
    | '/word-editor-demo'
    | '/data-center'
    | '/kb'
    | '/semantic-platform'
    | '/settings'
    | '/tenant-settings'
    | '/truth'
    | '/account'
    | '/doc-center'
    | '/recycle-bin'
    | '/search'
    | '/suggestions'
    | '/invite/$inviteId'
    | '/data-center/extraction'
    | '/data-center/tmpl'
    | '/semantic-platform/concepts'
    | '/semantic-platform/data-assets'
    | '/semantic-platform/data-governance'
    | '/semantic-platform/data-models'
    | '/semantic-platform/knowledge-debug'
    | '/semantic-platform/quantities'
    | '/semantic-platform/tag-center'
    | '/semantic-platform/tags'
    | '/semantic-platform/vocabularies'
    | '/settings/job-manager'
    | '/settings/tenants'
    | '/bots/new'
    | '/cad-edit/$id'
    | '/data-center/datasources'
    | '/data-center/exports'
    | '/data-center/metadata'
    | '/doc-generation/create'
    | '/doc-generation/templates'
    | '/doc-generation/writing-style'
    | '/file-preview/$fileId'
    | '/semantic-platform/data-lineage'
    | '/settings/ai-models'
    | '/settings/audit-logs'
    | '/settings/bots'
    | '/settings/data-sources'
    | '/settings/database'
    | '/settings/help-docs'
    | '/settings/industry-packs'
    | '/settings/license'
    | '/settings/metadata-templates'
    | '/settings/parser'
    | '/settings/quota-management'
    | '/settings/storage-cleanup'
    | '/settings/system'
    | '/settings/system-status'
    | '/ss-bid-gen/resources'
    | '/tenant-settings/ai-models'
    | '/tenant-settings/audit-logs'
    | '/tenant-settings/bots'
    | '/tenant-settings/data-sources'
    | '/tenant-settings/departments'
    | '/tenant-settings/doc-settings'
    | '/tenant-settings/document-security'
    | '/tenant-settings/industry-packs'
    | '/tenant-settings/invites'
    | '/tenant-settings/metadata-templates'
    | '/tenant-settings/parse-engines'
    | '/tenant-settings/permissions'
    | '/tenant-settings/publications'
    | '/tenant-settings/roles'
    | '/tenant-settings/semantic-governance'
    | '/tenant-settings/share-governance'
    | '/tenant-settings/system-status'
    | '/tenant-settings/tenant-info'
    | '/tenant-settings/users'
    | '/truth/compares'
    | '/projects/$projectId'
    | '/data-center/cleaning/$id'
    | '/data-center/review/$taskId'
    | '/share/doc/$token'
    | '/bot-market/'
    | '/bots/'
    | '/data-center/'
    | '/doc-generation/'
    | '/kb/'
    | '/projects/'
    | '/semantic-platform/'
    | '/settings/'
    | '/tenant-settings/'
    | '/truth/'
    | '/workbench/'
    | '/bots/$botId/run'
    | '/bots/$botId/studio'
    | '/bots/credentials/$credentialId'
    | '/bots/credentials/new'
    | '/bots/skills/$skillId'
    | '/bots/skills/new'
    | '/bots/tools/$toolId'
    | '/bots/tools/new'
    | '/data-center/exports/$exportId'
    | '/data-center/extraction/$taskId'
    | '/data-center/extraction/create'
    | '/data-center/tmpl/metadata'
    | '/data-center/tmpl/new'
    | '/doc-generation/$taskId/artifact'
    | '/doc-generation/$taskId/outline'
    | '/doc-generation/$taskId/writing'
    | '/kb/$kbId/$docId'
    | '/kb/$kbId/settings'
    | '/projects/templates/$templateId'
    | '/semantic-platform/concepts/$id'
    | '/semantic-platform/data-assets/$assetId'
    | '/semantic-platform/data-models/$id'
    | '/semantic-platform/quantities/$id'
    | '/semantic-platform/vocabularies/$id'
    | '/settings/audit-logs/$id'
    | '/settings/industry-packs/$key'
    | '/settings/tenants/$tenantId'
    | '/tenant-settings/audit-logs/$id'
    | '/tenant-settings/industry-packs/$key'
    | '/tenant-settings/semantic-governance/categories'
    | '/truth/compares/$compareId'
    | '/truth/rounds/$sessionId'
    | '/data-center/review/run/$runId'
    | '/data-center/cleaning/'
    | '/data-center/extraction/'
    | '/data-center/review/'
    | '/data-center/tmpl/'
    | '/doc-generation/$taskId/'
    | '/kb/$kbId/'
    | '/projects/templates/'
    | '/semantic-platform/concepts/'
    | '/semantic-platform/data-assets/'
    | '/semantic-platform/data-models/'
    | '/semantic-platform/knowledge-debug/'
    | '/semantic-platform/namespaces/'
    | '/semantic-platform/quantities/'
    | '/semantic-platform/tags/'
    | '/semantic-platform/vocabularies/'
    | '/settings/audit-logs/'
    | '/settings/industry-packs/'
    | '/tenant-settings/audit-logs/'
    | '/tenant-settings/industry-packs/'
    | '/tenant-settings/metadata-templates/'
    | '/tenant-settings/semantic-governance/'
    | '/data-center/extraction/edit/$taskId'
    | '/data-center/tmpl/edit/$id'
    | '/data-center/tmpl/versions/$id'
    | '/semantic-platform/data-assets/batches/$batchId'
    | '/semantic-platform/data-assets/entities/$entityId'
    | '/semantic-platform/data-models/edit/$id'
    | '/settings/job-manager/schedule/$scheduleId'
    | '/settings/job-manager/task/$taskId'
    | '/tenant-settings/semantic-governance/terms/new'
    | '/semantic-platform/data-governance/analysis/'
    | '/semantic-platform/data-governance/classifications/'
    | '/semantic-platform/data-governance/impact/'
    | '/semantic-platform/data-governance/quality/'
    | '/semantic-platform/data-governance/suggestions/'
    | '/semantic-platform/tag-center/fields/'
    | '/semantic-platform/tag-center/stats/'
    | '/semantic-platform/tag-center/suggestions/'
    | '/kb/$kbId/compilation/artifacts/$artifactId'
    | '/kb/$kbId/compilation/runs/$runId'
    | '/kb/$kbId/settings/terms/new'
    | '/settings/job-manager/schedule/$scheduleId/$taskId'
    | '/tenant-settings/semantic-governance/terms/edit/$id'
    | '/kb/$kbId/settings/terms/edit/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/excel-univer-demo'
    | '/login'
    | '/ppt-editor-demo'
    | '/privacy-policy'
    | '/register'
    | '/word-editor-demo'
    | '/account'
    | '/doc-center'
    | '/recycle-bin'
    | '/search'
    | '/suggestions'
    | '/invite/$inviteId'
    | '/semantic-platform/data-governance'
    | '/semantic-platform/tag-center'
    | '/settings/job-manager'
    | '/settings/tenants'
    | '/bots/new'
    | '/cad-edit/$id'
    | '/data-center/datasources'
    | '/data-center/exports'
    | '/data-center/metadata'
    | '/doc-generation/create'
    | '/doc-generation/templates'
    | '/doc-generation/writing-style'
    | '/file-preview/$fileId'
    | '/semantic-platform/data-lineage'
    | '/settings/ai-models'
    | '/settings/bots'
    | '/settings/data-sources'
    | '/settings/database'
    | '/settings/help-docs'
    | '/settings/license'
    | '/settings/metadata-templates'
    | '/settings/parser'
    | '/settings/quota-management'
    | '/settings/storage-cleanup'
    | '/settings/system'
    | '/settings/system-status'
    | '/ss-bid-gen/resources'
    | '/tenant-settings/ai-models'
    | '/tenant-settings/bots'
    | '/tenant-settings/data-sources'
    | '/tenant-settings/departments'
    | '/tenant-settings/doc-settings'
    | '/tenant-settings/document-security'
    | '/tenant-settings/invites'
    | '/tenant-settings/parse-engines'
    | '/tenant-settings/permissions'
    | '/tenant-settings/publications'
    | '/tenant-settings/roles'
    | '/tenant-settings/share-governance'
    | '/tenant-settings/system-status'
    | '/tenant-settings/tenant-info'
    | '/tenant-settings/users'
    | '/truth/compares'
    | '/projects/$projectId'
    | '/data-center/cleaning/$id'
    | '/data-center/review/$taskId'
    | '/share/doc/$token'
    | '/bot-market'
    | '/bots'
    | '/data-center'
    | '/doc-generation'
    | '/kb'
    | '/projects'
    | '/semantic-platform'
    | '/settings'
    | '/tenant-settings'
    | '/truth'
    | '/workbench'
    | '/bots/$botId/run'
    | '/bots/$botId/studio'
    | '/bots/credentials/$credentialId'
    | '/bots/credentials/new'
    | '/bots/skills/$skillId'
    | '/bots/skills/new'
    | '/bots/tools/$toolId'
    | '/bots/tools/new'
    | '/data-center/exports/$exportId'
    | '/data-center/extraction/$taskId'
    | '/data-center/extraction/create'
    | '/data-center/tmpl/metadata'
    | '/data-center/tmpl/new'
    | '/doc-generation/$taskId/artifact'
    | '/doc-generation/$taskId/outline'
    | '/doc-generation/$taskId/writing'
    | '/kb/$kbId/$docId'
    | '/kb/$kbId/settings'
    | '/projects/templates/$templateId'
    | '/semantic-platform/concepts/$id'
    | '/semantic-platform/data-assets/$assetId'
    | '/semantic-platform/data-models/$id'
    | '/semantic-platform/quantities/$id'
    | '/semantic-platform/vocabularies/$id'
    | '/settings/audit-logs/$id'
    | '/settings/industry-packs/$key'
    | '/settings/tenants/$tenantId'
    | '/tenant-settings/audit-logs/$id'
    | '/tenant-settings/industry-packs/$key'
    | '/tenant-settings/semantic-governance/categories'
    | '/truth/compares/$compareId'
    | '/truth/rounds/$sessionId'
    | '/data-center/review/run/$runId'
    | '/data-center/cleaning'
    | '/data-center/extraction'
    | '/data-center/review'
    | '/data-center/tmpl'
    | '/doc-generation/$taskId'
    | '/kb/$kbId'
    | '/projects/templates'
    | '/semantic-platform/concepts'
    | '/semantic-platform/data-assets'
    | '/semantic-platform/data-models'
    | '/semantic-platform/knowledge-debug'
    | '/semantic-platform/namespaces'
    | '/semantic-platform/quantities'
    | '/semantic-platform/tags'
    | '/semantic-platform/vocabularies'
    | '/settings/audit-logs'
    | '/settings/industry-packs'
    | '/tenant-settings/audit-logs'
    | '/tenant-settings/industry-packs'
    | '/tenant-settings/metadata-templates'
    | '/tenant-settings/semantic-governance'
    | '/data-center/extraction/edit/$taskId'
    | '/data-center/tmpl/edit/$id'
    | '/data-center/tmpl/versions/$id'
    | '/semantic-platform/data-assets/batches/$batchId'
    | '/semantic-platform/data-assets/entities/$entityId'
    | '/semantic-platform/data-models/edit/$id'
    | '/settings/job-manager/schedule/$scheduleId'
    | '/settings/job-manager/task/$taskId'
    | '/tenant-settings/semantic-governance/terms/new'
    | '/semantic-platform/data-governance/analysis'
    | '/semantic-platform/data-governance/classifications'
    | '/semantic-platform/data-governance/impact'
    | '/semantic-platform/data-governance/quality'
    | '/semantic-platform/data-governance/suggestions'
    | '/semantic-platform/tag-center/fields'
    | '/semantic-platform/tag-center/stats'
    | '/semantic-platform/tag-center/suggestions'
    | '/kb/$kbId/compilation/artifacts/$artifactId'
    | '/kb/$kbId/compilation/runs/$runId'
    | '/kb/$kbId/settings/terms/new'
    | '/settings/job-manager/schedule/$scheduleId/$taskId'
    | '/tenant-settings/semantic-governance/terms/edit/$id'
    | '/kb/$kbId/settings/terms/edit/$id'
  id:
    | '__root__'
    | '/_app'
    | '/_workspace'
    | '/excel-univer-demo'
    | '/login'
    | '/ppt-editor-demo'
    | '/privacy-policy'
    | '/register'
    | '/word-editor-demo'
    | '/_app/data-center'
    | '/_app/kb'
    | '/_app/semantic-platform'
    | '/_app/settings'
    | '/_app/tenant-settings'
    | '/_app/truth'
    | '/_app/account'
    | '/_app/doc-center'
    | '/_app/recycle-bin'
    | '/_app/search'
    | '/_app/suggestions'
    | '/invite/$inviteId'
    | '/_app/'
    | '/_app/data-center/extraction'
    | '/_app/data-center/tmpl'
    | '/_app/semantic-platform/concepts'
    | '/_app/semantic-platform/data-assets'
    | '/_app/semantic-platform/data-governance'
    | '/_app/semantic-platform/data-models'
    | '/_app/semantic-platform/knowledge-debug'
    | '/_app/semantic-platform/quantities'
    | '/_app/semantic-platform/tag-center'
    | '/_app/semantic-platform/tags'
    | '/_app/semantic-platform/vocabularies'
    | '/_app/settings/job-manager'
    | '/_app/settings/tenants'
    | '/_app/bots/new'
    | '/_app/cad-edit/$id'
    | '/_app/data-center/datasources'
    | '/_app/data-center/exports'
    | '/_app/data-center/metadata'
    | '/_app/doc-generation/create'
    | '/_app/doc-generation/templates'
    | '/_app/doc-generation/writing-style'
    | '/_app/file-preview/$fileId'
    | '/_app/semantic-platform/data-lineage'
    | '/_app/settings/ai-models'
    | '/_app/settings/audit-logs'
    | '/_app/settings/bots'
    | '/_app/settings/data-sources'
    | '/_app/settings/database'
    | '/_app/settings/help-docs'
    | '/_app/settings/industry-packs'
    | '/_app/settings/license'
    | '/_app/settings/metadata-templates'
    | '/_app/settings/parser'
    | '/_app/settings/quota-management'
    | '/_app/settings/storage-cleanup'
    | '/_app/settings/system'
    | '/_app/settings/system-status'
    | '/_app/ss-bid-gen/resources'
    | '/_app/tenant-settings/ai-models'
    | '/_app/tenant-settings/audit-logs'
    | '/_app/tenant-settings/bots'
    | '/_app/tenant-settings/data-sources'
    | '/_app/tenant-settings/departments'
    | '/_app/tenant-settings/doc-settings'
    | '/_app/tenant-settings/document-security'
    | '/_app/tenant-settings/industry-packs'
    | '/_app/tenant-settings/invites'
    | '/_app/tenant-settings/metadata-templates'
    | '/_app/tenant-settings/parse-engines'
    | '/_app/tenant-settings/permissions'
    | '/_app/tenant-settings/publications'
    | '/_app/tenant-settings/roles'
    | '/_app/tenant-settings/semantic-governance'
    | '/_app/tenant-settings/share-governance'
    | '/_app/tenant-settings/system-status'
    | '/_app/tenant-settings/tenant-info'
    | '/_app/tenant-settings/users'
    | '/_app/truth/compares'
    | '/_workspace/projects/$projectId'
    | '/data-center/cleaning/$id'
    | '/data-center/review/$taskId'
    | '/share/doc/$token'
    | '/_app/bot-market/'
    | '/_app/bots/'
    | '/_app/data-center/'
    | '/_app/doc-generation/'
    | '/_app/kb/'
    | '/_app/projects/'
    | '/_app/semantic-platform/'
    | '/_app/settings/'
    | '/_app/tenant-settings/'
    | '/_app/truth/'
    | '/_app/workbench/'
    | '/_app/bots/$botId/run'
    | '/_app/bots/$botId/studio'
    | '/_app/bots/credentials/$credentialId'
    | '/_app/bots/credentials/new'
    | '/_app/bots/skills/$skillId'
    | '/_app/bots/skills/new'
    | '/_app/bots/tools/$toolId'
    | '/_app/bots/tools/new'
    | '/_app/data-center/exports_/$exportId'
    | '/_app/data-center/extraction/$taskId'
    | '/_app/data-center/extraction/create'
    | '/_app/data-center/tmpl/metadata'
    | '/_app/data-center/tmpl/new'
    | '/_app/doc-generation/$taskId/artifact'
    | '/_app/doc-generation/$taskId/outline'
    | '/_app/doc-generation/$taskId/writing'
    | '/_app/kb/$kbId/$docId'
    | '/_app/kb/$kbId/settings'
    | '/_app/projects/templates/$templateId'
    | '/_app/semantic-platform/concepts/$id'
    | '/_app/semantic-platform/data-assets/$assetId'
    | '/_app/semantic-platform/data-models/$id'
    | '/_app/semantic-platform/quantities/$id'
    | '/_app/semantic-platform/vocabularies/$id'
    | '/_app/settings/audit-logs/$id'
    | '/_app/settings/industry-packs/$key'
    | '/_app/settings/tenants/$tenantId'
    | '/_app/tenant-settings/audit-logs/$id'
    | '/_app/tenant-settings/industry-packs/$key'
    | '/_app/tenant-settings/semantic-governance/categories'
    | '/_app/truth/compares/$compareId'
    | '/_app/truth/rounds/$sessionId'
    | '/data-center/review/run/$runId'
    | '/_app/data-center/cleaning/'
    | '/_app/data-center/extraction/'
    | '/_app/data-center/review/'
    | '/_app/data-center/tmpl/'
    | '/_app/doc-generation/$taskId/'
    | '/_app/kb/$kbId/'
    | '/_app/projects/templates/'
    | '/_app/semantic-platform/concepts/'
    | '/_app/semantic-platform/data-assets/'
    | '/_app/semantic-platform/data-models/'
    | '/_app/semantic-platform/knowledge-debug/'
    | '/_app/semantic-platform/namespaces/'
    | '/_app/semantic-platform/quantities/'
    | '/_app/semantic-platform/tags/'
    | '/_app/semantic-platform/vocabularies/'
    | '/_app/settings/audit-logs/'
    | '/_app/settings/industry-packs/'
    | '/_app/tenant-settings/audit-logs/'
    | '/_app/tenant-settings/industry-packs/'
    | '/_app/tenant-settings/metadata-templates/'
    | '/_app/tenant-settings/semantic-governance/'
    | '/_app/data-center/extraction/edit/$taskId'
    | '/_app/data-center/tmpl/edit/$id'
    | '/_app/data-center/tmpl/versions/$id'
    | '/_app/semantic-platform/data-assets/batches/$batchId'
    | '/_app/semantic-platform/data-assets/entities/$entityId'
    | '/_app/semantic-platform/data-models/edit/$id'
    | '/_app/settings/job-manager/schedule/$scheduleId'
    | '/_app/settings/job-manager/task/$taskId'
    | '/_app/tenant-settings/semantic-governance/terms/new'
    | '/_app/semantic-platform/data-governance/analysis/'
    | '/_app/semantic-platform/data-governance/classifications/'
    | '/_app/semantic-platform/data-governance/impact/'
    | '/_app/semantic-platform/data-governance/quality/'
    | '/_app/semantic-platform/data-governance/suggestions/'
    | '/_app/semantic-platform/tag-center/fields/'
    | '/_app/semantic-platform/tag-center/stats/'
    | '/_app/semantic-platform/tag-center/suggestions/'
    | '/_app/kb/$kbId/compilation/artifacts/$artifactId'
    | '/_app/kb/$kbId/compilation/runs/$runId'
    | '/_app/kb/$kbId/settings/terms/new'
    | '/_app/settings/job-manager/schedule/$scheduleId/$taskId'
    | '/_app/tenant-settings/semantic-governance/terms/edit/$id'
    | '/_app/kb/$kbId/settings/terms/edit/$id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  WorkspaceRoute: typeof WorkspaceRouteWithChildren
  ExcelUniverDemoRoute: typeof ExcelUniverDemoRoute
  LoginRoute: typeof LoginRoute
  PptEditorDemoRoute: typeof PptEditorDemoRoute
  PrivacyPolicyRoute: typeof PrivacyPolicyRoute
  RegisterRoute: typeof RegisterRoute
  WordEditorDemoRoute: typeof WordEditorDemoRoute
  InviteInviteIdRoute: typeof InviteInviteIdRoute
  DataCenterCleaningIdRoute: typeof DataCenterCleaningIdRoute
  DataCenterReviewTaskIdRoute: typeof DataCenterReviewTaskIdRoute
  ShareDocTokenRoute: typeof ShareDocTokenRoute
  DataCenterReviewRunRunIdRoute: typeof DataCenterReviewRunRunIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_workspace': {
      id: '/_workspace'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof WorkspaceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/excel-univer-demo': {
      id: '/excel-univer-demo'
      path: '/excel-univer-demo'
      fullPath: '/excel-univer-demo'
      preLoaderRoute: typeof ExcelUniverDemoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ppt-editor-demo': {
      id: '/ppt-editor-demo'
      path: '/ppt-editor-demo'
      fullPath: '/ppt-editor-demo'
      preLoaderRoute: typeof PptEditorDemoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy-policy': {
      id: '/privacy-policy'
      path: '/privacy-policy'
      fullPath: '/privacy-policy'
      preLoaderRoute: typeof PrivacyPolicyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/word-editor-demo': {
      id: '/word-editor-demo'
      path: '/word-editor-demo'
      fullPath: '/word-editor-demo'
      preLoaderRoute: typeof WordEditorDemoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/account': {
      id: '/_app/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AppAccountRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/data-center': {
      id: '/_app/data-center'
      path: '/data-center'
      fullPath: '/data-center'
      preLoaderRoute: typeof AppDataCenterRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/doc-center': {
      id: '/_app/doc-center'
      path: '/doc-center'
      fullPath: '/doc-center'
      preLoaderRoute: typeof AppDocCenterRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/kb': {
      id: '/_app/kb'
      path: '/kb'
      fullPath: '/kb'
      preLoaderRoute: typeof AppKbRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/recycle-bin': {
      id: '/_app/recycle-bin'
      path: '/recycle-bin'
      fullPath: '/recycle-bin'
      preLoaderRoute: typeof AppRecycleBinRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/search': {
      id: '/_app/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof AppSearchRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/semantic-platform': {
      id: '/_app/semantic-platform'
      path: '/semantic-platform'
      fullPath: '/semantic-platform'
      preLoaderRoute: typeof AppSemanticPlatformRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/suggestions': {
      id: '/_app/suggestions'
      path: '/suggestions'
      fullPath: '/suggestions'
      preLoaderRoute: typeof AppSuggestionsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tenant-settings': {
      id: '/_app/tenant-settings'
      path: '/tenant-settings'
      fullPath: '/tenant-settings'
      preLoaderRoute: typeof AppTenantSettingsRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/truth': {
      id: '/_app/truth'
      path: '/truth'
      fullPath: '/truth'
      preLoaderRoute: typeof AppTruthRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/invite/$inviteId': {
      id: '/invite/$inviteId'
      path: '/invite/$inviteId'
      fullPath: '/invite/$inviteId'
      preLoaderRoute: typeof InviteInviteIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/bot-market/': {
      id: '/_app/bot-market/'
      path: '/bot-market'
      fullPath: '/bot-market/'
      preLoaderRoute: typeof AppBotMarketIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/bots/': {
      id: '/_app/bots/'
      path: '/bots'
      fullPath: '/bots/'
      preLoaderRoute: typeof AppBotsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/bots/new': {
      id: '/_app/bots/new'
      path: '/bots/new'
      fullPath: '/bots/new'
      preLoaderRoute: typeof AppBotsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/cad-edit/$id': {
      id: '/_app/cad-edit/$id'
      path: '/cad-edit/$id'
      fullPath: '/cad-edit/$id'
      preLoaderRoute: typeof AppCadEditIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/data-center/': {
      id: '/_app/data-center/'
      path: '/'
      fullPath: '/data-center/'
      preLoaderRoute: typeof AppDataCenterIndexRouteImport
      parentRoute: typeof AppDataCenterRouteRoute
    }
    '/_app/data-center/datasources': {
      id: '/_app/data-center/datasources'
      path: '/datasources'
      fullPath: '/data-center/datasources'
      preLoaderRoute: typeof AppDataCenterDatasourcesRouteImport
      parentRoute: typeof AppDataCenterRouteRoute
    }
    '/_app/data-center/exports': {
      id: '/_app/data-center/exports'
      path: '/exports'
      fullPath: '/data-center/exports'
      preLoaderRoute: typeof AppDataCenterExportsRouteImport
      parentRoute: typeof AppDataCenterRouteRoute
    }
    '/_app/data-center/extraction': {
      id: '/_app/data-center/extraction'
      path: '/extraction'
      fullPath: '/data-center/extraction'
      preLoaderRoute: typeof AppDataCenterExtractionRouteRouteImport
      parentRoute: typeof AppDataCenterRouteRoute
    }
    '/_app/data-center/metadata': {
      id: '/_app/data-center/metadata'
      path: '/metadata'
      fullPath: '/data-center/metadata'
      preLoaderRoute: typeof AppDataCenterMetadataRouteImport
      parentRoute: typeof AppDataCenterRouteRoute
    }
    '/_app/data-center/tmpl': {
      id: '/_app/data-center/tmpl'
      path: '/tmpl'
      fullPath: '/data-center/tmpl'
      preLoaderRoute: typeof AppDataCenterTmplRouteRouteImport
      parentRoute: typeof AppDataCenterRouteRoute
    }
    '/_app/doc-generation/': {
      id: '/_app/doc-generation/'
      path: '/doc-generation'
      fullPath: '/doc-generation/'
      preLoaderRoute: typeof AppDocGenerationIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/doc-generation/create': {
      id: '/_app/doc-generation/create'
      path: '/doc-generation/create'
      fullPath: '/doc-generation/create'
      preLoaderRoute: typeof AppDocGenerationCreateRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/doc-generation/templates': {
      id: '/_app/doc-generation/templates'
      path: '/doc-generation/templates'
      fullPath: '/doc-generation/templates'
      preLoaderRoute: typeof AppDocGenerationTemplatesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/doc-generation/writing-style': {
      id: '/_app/doc-generation/writing-style'
      path: '/doc-generation/writing-style'
      fullPath: '/doc-generation/writing-style'
      preLoaderRoute: typeof AppDocGenerationWritingStyleRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/file-preview/$fileId': {
      id: '/_app/file-preview/$fileId'
      path: '/file-preview/$fileId'
      fullPath: '/file-preview/$fileId'
      preLoaderRoute: typeof AppFilePreviewFileIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/kb/': {
      id: '/_app/kb/'
      path: '/'
      fullPath: '/kb/'
      preLoaderRoute: typeof AppKbIndexRouteImport
      parentRoute: typeof AppKbRouteRoute
    }
    '/_app/projects/': {
      id: '/_app/projects/'
      path: '/projects'
      fullPath: '/projects/'
      preLoaderRoute: typeof AppProjectsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/semantic-platform/': {
      id: '/_app/semantic-platform/'
      path: '/'
      fullPath: '/semantic-platform/'
      preLoaderRoute: typeof AppSemanticPlatformIndexRouteImport
      parentRoute: typeof AppSemanticPlatformRouteRoute
    }
    '/_app/semantic-platform/concepts': {
      id: '/_app/semantic-platform/concepts'
      path: '/concepts'
      fullPath: '/semantic-platform/concepts'
      preLoaderRoute: typeof AppSemanticPlatformConceptsRouteRouteImport
      parentRoute: typeof AppSemanticPlatformRouteRoute
    }
    '/_app/semantic-platform/data-assets': {
      id: '/_app/semantic-platform/data-assets'
      path: '/data-assets'
      fullPath: '/semantic-platform/data-assets'
      preLoaderRoute: typeof AppSemanticPlatformDataAssetsRouteRouteImport
      parentRoute: typeof AppSemanticPlatformRouteRoute
    }
    '/_app/semantic-platform/data-governance': {
      id: '/_app/semantic-platform/data-governance'
      path: '/data-governance'
      fullPath: '/semantic-platform/data-governance'
      preLoaderRoute: typeof AppSemanticPlatformDataGovernanceRouteRouteImport
      parentRoute: typeof AppSemanticPlatformRouteRoute
    }
    '/_app/semantic-platform/data-lineage': {
      id: '/_app/semantic-platform/data-lineage'
      path: '/data-lineage'
      fullPath: '/semantic-platform/data-lineage'
      preLoaderRoute: typeof AppSemanticPlatformDataLineageRouteImport
      parentRoute: typeof AppSemanticPlatformRouteRoute
    }
    '/_app/semantic-platform/data-models': {
      id: '/_app/semantic-platform/data-models'
      path: '/data-models'
      fullPath: '/semantic-platform/data-models'
      preLoaderRoute: typeof AppSemanticPlatformDataModelsRouteRouteImport
      parentRoute: typeof AppSemanticPlatformRouteRoute
    }
    '/_app/semantic-platform/knowledge-debug': {
      id: '/_app/semantic-platform/knowledge-debug'
      path: '/knowledge-debug'
      fullPath: '/semantic-platform/knowledge-debug'
      preLoaderRoute: typeof AppSemanticPlatformKnowledgeDebugRouteRouteImport
      parentRoute: typeof AppSemanticPlatformRouteRoute
    }
    '/_app/semantic-platform/quantities': {
      id: '/_app/semantic-platform/quantities'
      path: '/quantities'
      fullPath: '/semantic-platform/quantities'
      preLoaderRoute: typeof AppSemanticPlatformQuantitiesRouteRouteImport
      parentRoute: typeof AppSemanticPlatformRouteRoute
    }
    '/_app/semantic-platform/tag-center': {
      id: '/_app/semantic-platform/tag-center'
      path: '/tag-center'
      fullPath: '/semantic-platform/tag-center'
      preLoaderRoute: typeof AppSemanticPlatformTagCenterRouteRouteImport
      parentRoute: typeof AppSemanticPlatformRouteRoute
    }
    '/_app/semantic-platform/tags': {
      id: '/_app/semantic-platform/tags'
      path: '/tags'
      fullPath: '/semantic-platform/tags'
      preLoaderRoute: typeof AppSemanticPlatformTagsRouteRouteImport
      parentRoute: typeof AppSemanticPlatformRouteRoute
    }
    '/_app/semantic-platform/vocabularies': {
      id: '/_app/semantic-platform/vocabularies'
      path: '/vocabularies'
      fullPath: '/semantic-platform/vocabularies'
      preLoaderRoute: typeof AppSemanticPlatformVocabulariesRouteRouteImport
      parentRoute: typeof AppSemanticPlatformRouteRoute
    }
    '/_app/settings/': {
      id: '/_app/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AppSettingsIndexRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/ai-models': {
      id: '/_app/settings/ai-models'
      path: '/ai-models'
      fullPath: '/settings/ai-models'
      preLoaderRoute: typeof AppSettingsAiModelsRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/audit-logs': {
      id: '/_app/settings/audit-logs'
      path: '/audit-logs'
      fullPath: '/settings/audit-logs'
      preLoaderRoute: typeof AppSettingsAuditLogsRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/bots': {
      id: '/_app/settings/bots'
      path: '/bots'
      fullPath: '/settings/bots'
      preLoaderRoute: typeof AppSettingsBotsRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/data-sources': {
      id: '/_app/settings/data-sources'
      path: '/data-sources'
      fullPath: '/settings/data-sources'
      preLoaderRoute: typeof AppSettingsDataSourcesRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/database': {
      id: '/_app/settings/database'
      path: '/database'
      fullPath: '/settings/database'
      preLoaderRoute: typeof AppSettingsDatabaseRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/help-docs': {
      id: '/_app/settings/help-docs'
      path: '/help-docs'
      fullPath: '/settings/help-docs'
      preLoaderRoute: typeof AppSettingsHelpDocsRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/industry-packs': {
      id: '/_app/settings/industry-packs'
      path: '/industry-packs'
      fullPath: '/settings/industry-packs'
      preLoaderRoute: typeof AppSettingsIndustryPacksRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/job-manager': {
      id: '/_app/settings/job-manager'
      path: '/job-manager'
      fullPath: '/settings/job-manager'
      preLoaderRoute: typeof AppSettingsJobManagerRouteRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/license': {
      id: '/_app/settings/license'
      path: '/license'
      fullPath: '/settings/license'
      preLoaderRoute: typeof AppSettingsLicenseRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/metadata-templates': {
      id: '/_app/settings/metadata-templates'
      path: '/metadata-templates'
      fullPath: '/settings/metadata-templates'
      preLoaderRoute: typeof AppSettingsMetadataTemplatesRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/parser': {
      id: '/_app/settings/parser'
      path: '/parser'
      fullPath: '/settings/parser'
      preLoaderRoute: typeof AppSettingsParserRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/quota-management': {
      id: '/_app/settings/quota-management'
      path: '/quota-management'
      fullPath: '/settings/quota-management'
      preLoaderRoute: typeof AppSettingsQuotaManagementRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/storage-cleanup': {
      id: '/_app/settings/storage-cleanup'
      path: '/storage-cleanup'
      fullPath: '/settings/storage-cleanup'
      preLoaderRoute: typeof AppSettingsStorageCleanupRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/system': {
      id: '/_app/settings/system'
      path: '/system'
      fullPath: '/settings/system'
      preLoaderRoute: typeof AppSettingsSystemRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/system-status': {
      id: '/_app/settings/system-status'
      path: '/system-status'
      fullPath: '/settings/system-status'
      preLoaderRoute: typeof AppSettingsSystemStatusRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/tenants': {
      id: '/_app/settings/tenants'
      path: '/tenants'
      fullPath: '/settings/tenants'
      preLoaderRoute: typeof AppSettingsTenantsRouteRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/ss-bid-gen/resources': {
      id: '/_app/ss-bid-gen/resources'
      path: '/ss-bid-gen/resources'
      fullPath: '/ss-bid-gen/resources'
      preLoaderRoute: typeof AppSsBidGenResourcesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tenant-settings/': {
      id: '/_app/tenant-settings/'
      path: '/'
      fullPath: '/tenant-settings/'
      preLoaderRoute: typeof AppTenantSettingsIndexRouteImport
      parentRoute: typeof AppTenantSettingsRouteRoute
    }
    '/_app/tenant-settings/ai-models': {
      id: '/_app/tenant-settings/ai-models'
      path: '/ai-models'
      fullPath: '/tenant-settings/ai-models'
      preLoaderRoute: typeof AppTenantSettingsAiModelsRouteImport
      parentRoute: typeof AppTenantSettingsRouteRoute
    }
    '/_app/tenant-settings/audit-logs': {
      id: '/_app/tenant-settings/audit-logs'
      path: '/audit-logs'
      fullPath: '/tenant-settings/audit-logs'
      preLoaderRoute: typeof AppTenantSettingsAuditLogsRouteImport
      parentRoute: typeof AppTenantSettingsRouteRoute
    }
    '/_app/tenant-settings/bots': {
      id: '/_app/tenant-settings/bots'
      path: '/bots'
      fullPath: '/tenant-settings/bots'
      preLoaderRoute: typeof AppTenantSettingsBotsRouteImport
      parentRoute: typeof AppTenantSettingsRouteRoute
    }
    '/_app/tenant-settings/data-sources': {
      id: '/_app/tenant-settings/data-sources'
      path: '/data-sources'
      fullPath: '/tenant-settings/data-sources'
      preLoaderRoute: typeof AppTenantSettingsDataSourcesRouteImport
      parentRoute: typeof AppTenantSettingsRouteRoute
    }
    '/_app/tenant-settings/departments': {
      id: '/_app/tenant-settings/departments'
      path: '/departments'
      fullPath: '/tenant-settings/departments'
      preLoaderRoute: typeof AppTenantSettingsDepartmentsRouteImport
      parentRoute: typeof AppTenantSettingsRouteRoute
    }
    '/_app/tenant-settings/doc-settings': {
      id: '/_app/tenant-settings/doc-settings'
      path: '/doc-settings'
      fullPath: '/tenant-settings/doc-settings'
      preLoaderRoute: typeof AppTenantSettingsDocSettingsRouteImport
      parentRoute: typeof AppTenantSettingsRouteRoute
    }
    '/_app/tenant-settings/document-security': {
      id: '/_app/tenant-settings/document-security'
      path: '/document-security'
      fullPath: '/tenant-settings/document-security'
      preLoaderRoute: typeof AppTenantSettingsDocumentSecurityRouteImport
      parentRoute: typeof AppTenantSettingsRouteRoute
    }
    '/_app/tenant-settings/industry-packs': {
      id: '/_app/tenant-settings/industry-packs'
      path: '/industry-packs'
      fullPath: '/tenant-settings/industry-packs'
      preLoaderRoute: typeof AppTenantSettingsIndustryPacksRouteImport
      parentRoute: typeof AppTenantSettingsRouteRoute
    }
    '/_app/tenant-settings/invites': {
      id: '/_app/tenant-settings/invites'
      path: '/invites'
      fullPath: '/tenant-settings/invites'
      preLoaderRoute: typeof AppTenantSettingsInvitesRouteImport
      parentRoute: typeof AppTenantSettingsRouteRoute
    }
    '/_app/tenant-settings/metadata-templates': {
      id: '/_app/tenant-settings/metadata-templates'
      path: '/metadata-templates'
      fullPath: '/tenant-settings/metadata-templates'
      preLoaderRoute: typeof AppTenantSettingsMetadataTemplatesRouteImport
      parentRoute: typeof AppTenantSettingsRouteRoute
    }
    '/_app/tenant-settings/parse-engines': {
      id: '/_app/tenant-settings/parse-engines'
      path: '/parse-engines'
      fullPath: '/tenant-settings/parse-engines'
      preLoaderRoute: typeof AppTenantSettingsParseEnginesRouteImport
      parentRoute: typeof AppTenantSettingsRouteRoute
    }
    '/_app/tenant-settings/permissions': {
      id: '/_app/tenant-settings/permissions'
      path: '/permissions'
      fullPath: '/tenant-settings/permissions'
      preLoaderRoute: typeof AppTenantSettingsPermissionsRouteImport
      parentRoute: typeof AppTenantSettingsRouteRoute
    }
    '/_app/tenant-settings/publications': {
      id: '/_app/tenant-settings/publications'
      path: '/publications'
      fullPath: '/tenant-settings/publications'
      preLoaderRoute: typeof AppTenantSettingsPublicationsRouteImport
      parentRoute: typeof AppTenantSettingsRouteRoute
    }
    '/_app/tenant-settings/roles': {
      id: '/_app/tenant-settings/roles'
      path: '/roles'
      fullPath: '/tenant-settings/roles'
      preLoaderRoute: typeof AppTenantSettingsRolesRouteImport
      parentRoute: typeof AppTenantSettingsRouteRoute
    }
    '/_app/tenant-settings/semantic-governance': {
      id: '/_app/tenant-settings/semantic-governance'
      path: '/semantic-governance'
      fullPath: '/tenant-settings/semantic-governance'
      preLoaderRoute: typeof AppTenantSettingsSemanticGovernanceRouteImport
      parentRoute: typeof AppTenantSettingsRouteRoute
    }
    '/_app/tenant-settings/share-governance': {
      id: '/_app/tenant-settings/share-governance'
      path: '/share-governance'
      fullPath: '/tenant-settings/share-governance'
      preLoaderRoute: typeof AppTenantSettingsShareGovernanceRouteImport
      parentRoute: typeof AppTenantSettingsRouteRoute
    }
    '/_app/tenant-settings/system-status': {
      id: '/_app/tenant-settings/system-status'
      path: '/system-status'
      fullPath: '/tenant-settings/system-status'
      preLoaderRoute: typeof AppTenantSettingsSystemStatusRouteImport
      parentRoute: typeof AppTenantSettingsRouteRoute
    }
    '/_app/tenant-settings/tenant-info': {
      id: '/_app/tenant-settings/tenant-info'
      path: '/tenant-info'
      fullPath: '/tenant-settings/tenant-info'
      preLoaderRoute: typeof AppTenantSettingsTenantInfoRouteImport
      parentRoute: typeof AppTenantSettingsRouteRoute
    }
    '/_app/tenant-settings/users': {
      id: '/_app/tenant-settings/users'
      path: '/users'
      fullPath: '/tenant-settings/users'
      preLoaderRoute: typeof AppTenantSettingsUsersRouteImport
      parentRoute: typeof AppTenantSettingsRouteRoute
    }
    '/_app/truth/': {
      id: '/_app/truth/'
      path: '/'
      fullPath: '/truth/'
      preLoaderRoute: typeof AppTruthIndexRouteImport
      parentRoute: typeof AppTruthRouteRoute
    }
    '/_app/truth/compares': {
      id: '/_app/truth/compares'
      path: '/compares'
      fullPath: '/truth/compares'
      preLoaderRoute: typeof AppTruthComparesRouteImport
      parentRoute: typeof AppTruthRouteRoute
    }
    '/_app/workbench/': {
      id: '/_app/workbench/'
      path: '/workbench'
      fullPath: '/workbench/'
      preLoaderRoute: typeof AppWorkbenchIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_workspace/projects/$projectId': {
      id: '/_workspace/projects/$projectId'
      path: '/projects/$projectId'
      fullPath: '/projects/$projectId'
      preLoaderRoute: typeof WorkspaceProjectsProjectIdRouteImport
      parentRoute: typeof WorkspaceRoute
    }
    '/data-center/cleaning/$id': {
      id: '/data-center/cleaning/$id'
      path: '/data-center/cleaning/$id'
      fullPath: '/data-center/cleaning/$id'
      preLoaderRoute: typeof DataCenterCleaningIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/data-center/review/$taskId': {
      id: '/data-center/review/$taskId'
      path: '/data-center/review/$taskId'
      fullPath: '/data-center/review/$taskId'
      preLoaderRoute: typeof DataCenterReviewTaskIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/share/doc/$token': {
      id: '/share/doc/$token'
      path: '/share/doc/$token'
      fullPath: '/share/doc/$token'
      preLoaderRoute: typeof ShareDocTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/bots/$botId/run': {
      id: '/_app/bots/$botId/run'
      path: '/bots/$botId/run'
      fullPath: '/bots/$botId/run'
      preLoaderRoute: typeof AppBotsBotIdRunRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/bots/$botId/studio': {
      id: '/_app/bots/$botId/studio'
      path: '/bots/$botId/studio'
      fullPath: '/bots/$botId/studio'
      preLoaderRoute: typeof AppBotsBotIdStudioRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/bots/credentials/$credentialId': {
      id: '/_app/bots/credentials/$credentialId'
      path: '/bots/credentials/$credentialId'
      fullPath: '/bots/credentials/$credentialId'
      preLoaderRoute: typeof AppBotsCredentialsCredentialIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/bots/credentials/new': {
      id: '/_app/bots/credentials/new'
      path: '/bots/credentials/new'
      fullPath: '/bots/credentials/new'
      preLoaderRoute: typeof AppBotsCredentialsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/bots/skills/$skillId': {
      id: '/_app/bots/skills/$skillId'
      path: '/bots/skills/$skillId'
      fullPath: '/bots/skills/$skillId'
      preLoaderRoute: typeof AppBotsSkillsSkillIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/bots/skills/new': {
      id: '/_app/bots/skills/new'
      path: '/bots/skills/new'
      fullPath: '/bots/skills/new'
      preLoaderRoute: typeof AppBotsSkillsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/bots/tools/$toolId': {
      id: '/_app/bots/tools/$toolId'
      path: '/bots/tools/$toolId'
      fullPath: '/bots/tools/$toolId'
      preLoaderRoute: typeof AppBotsToolsToolIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/bots/tools/new': {
      id: '/_app/bots/tools/new'
      path: '/bots/tools/new'
      fullPath: '/bots/tools/new'
      preLoaderRoute: typeof AppBotsToolsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/data-center/cleaning/': {
      id: '/_app/data-center/cleaning/'
      path: '/cleaning'
      fullPath: '/data-center/cleaning/'
      preLoaderRoute: typeof AppDataCenterCleaningIndexRouteImport
      parentRoute: typeof AppDataCenterRouteRoute
    }
    '/_app/data-center/exports_/$exportId': {
      id: '/_app/data-center/exports_/$exportId'
      path: '/exports/$exportId'
      fullPath: '/data-center/exports/$exportId'
      preLoaderRoute: typeof AppDataCenterExportsExportIdRouteImport
      parentRoute: typeof AppDataCenterRouteRoute
    }
    '/_app/data-center/extraction/': {
      id: '/_app/data-center/extraction/'
      path: '/'
      fullPath: '/data-center/extraction/'
      preLoaderRoute: typeof AppDataCenterExtractionIndexRouteImport
      parentRoute: typeof AppDataCenterExtractionRouteRoute
    }
    '/_app/data-center/extraction/$taskId': {
      id: '/_app/data-center/extraction/$taskId'
      path: '/$taskId'
      fullPath: '/data-center/extraction/$taskId'
      preLoaderRoute: typeof AppDataCenterExtractionTaskIdRouteImport
      parentRoute: typeof AppDataCenterExtractionRouteRoute
    }
    '/_app/data-center/extraction/create': {
      id: '/_app/data-center/extraction/create'
      path: '/create'
      fullPath: '/data-center/extraction/create'
      preLoaderRoute: typeof AppDataCenterExtractionCreateRouteImport
      parentRoute: typeof AppDataCenterExtractionRouteRoute
    }
    '/_app/data-center/review/': {
      id: '/_app/data-center/review/'
      path: '/review'
      fullPath: '/data-center/review/'
      preLoaderRoute: typeof AppDataCenterReviewIndexRouteImport
      parentRoute: typeof AppDataCenterRouteRoute
    }
    '/_app/data-center/tmpl/': {
      id: '/_app/data-center/tmpl/'
      path: '/'
      fullPath: '/data-center/tmpl/'
      preLoaderRoute: typeof AppDataCenterTmplIndexRouteImport
      parentRoute: typeof AppDataCenterTmplRouteRoute
    }
    '/_app/data-center/tmpl/metadata': {
      id: '/_app/data-center/tmpl/metadata'
      path: '/metadata'
      fullPath: '/data-center/tmpl/metadata'
      preLoaderRoute: typeof AppDataCenterTmplMetadataRouteImport
      parentRoute: typeof AppDataCenterTmplRouteRoute
    }
    '/_app/data-center/tmpl/new': {
      id: '/_app/data-center/tmpl/new'
      path: '/new'
      fullPath: '/data-center/tmpl/new'
      preLoaderRoute: typeof AppDataCenterTmplNewRouteImport
      parentRoute: typeof AppDataCenterTmplRouteRoute
    }
    '/_app/doc-generation/$taskId/': {
      id: '/_app/doc-generation/$taskId/'
      path: '/doc-generation/$taskId'
      fullPath: '/doc-generation/$taskId/'
      preLoaderRoute: typeof AppDocGenerationTaskIdIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/doc-generation/$taskId/artifact': {
      id: '/_app/doc-generation/$taskId/artifact'
      path: '/doc-generation/$taskId/artifact'
      fullPath: '/doc-generation/$taskId/artifact'
      preLoaderRoute: typeof AppDocGenerationTaskIdArtifactRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/doc-generation/$taskId/outline': {
      id: '/_app/doc-generation/$taskId/outline'
      path: '/doc-generation/$taskId/outline'
      fullPath: '/doc-generation/$taskId/outline'
      preLoaderRoute: typeof AppDocGenerationTaskIdOutlineRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/doc-generation/$taskId/writing': {
      id: '/_app/doc-generation/$taskId/writing'
      path: '/doc-generation/$taskId/writing'
      fullPath: '/doc-generation/$taskId/writing'
      preLoaderRoute: typeof AppDocGenerationTaskIdWritingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/kb/$kbId/': {
      id: '/_app/kb/$kbId/'
      path: '/$kbId'
      fullPath: '/kb/$kbId/'
      preLoaderRoute: typeof AppKbKbIdIndexRouteImport
      parentRoute: typeof AppKbRouteRoute
    }
    '/_app/kb/$kbId/$docId': {
      id: '/_app/kb/$kbId/$docId'
      path: '/$kbId/$docId'
      fullPath: '/kb/$kbId/$docId'
      preLoaderRoute: typeof AppKbKbIdDocIdRouteImport
      parentRoute: typeof AppKbRouteRoute
    }
    '/_app/kb/$kbId/settings': {
      id: '/_app/kb/$kbId/settings'
      path: '/$kbId/settings'
      fullPath: '/kb/$kbId/settings'
      preLoaderRoute: typeof AppKbKbIdSettingsRouteImport
      parentRoute: typeof AppKbRouteRoute
    }
    '/_app/projects/templates/': {
      id: '/_app/projects/templates/'
      path: '/projects/templates'
      fullPath: '/projects/templates/'
      preLoaderRoute: typeof AppProjectsTemplatesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects/templates/$templateId': {
      id: '/_app/projects/templates/$templateId'
      path: '/projects/templates/$templateId'
      fullPath: '/projects/templates/$templateId'
      preLoaderRoute: typeof AppProjectsTemplatesTemplateIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/semantic-platform/concepts/': {
      id: '/_app/semantic-platform/concepts/'
      path: '/'
      fullPath: '/semantic-platform/concepts/'
      preLoaderRoute: typeof AppSemanticPlatformConceptsIndexRouteImport
      parentRoute: typeof AppSemanticPlatformConceptsRouteRoute
    }
    '/_app/semantic-platform/concepts/$id': {
      id: '/_app/semantic-platform/concepts/$id'
      path: '/$id'
      fullPath: '/semantic-platform/concepts/$id'
      preLoaderRoute: typeof AppSemanticPlatformConceptsIdRouteImport
      parentRoute: typeof AppSemanticPlatformConceptsRouteRoute
    }
    '/_app/semantic-platform/data-assets/': {
      id: '/_app/semantic-platform/data-assets/'
      path: '/'
      fullPath: '/semantic-platform/data-assets/'
      preLoaderRoute: typeof AppSemanticPlatformDataAssetsIndexRouteImport
      parentRoute: typeof AppSemanticPlatformDataAssetsRouteRoute
    }
    '/_app/semantic-platform/data-assets/$assetId': {
      id: '/_app/semantic-platform/data-assets/$assetId'
      path: '/$assetId'
      fullPath: '/semantic-platform/data-assets/$assetId'
      preLoaderRoute: typeof AppSemanticPlatformDataAssetsAssetIdRouteImport
      parentRoute: typeof AppSemanticPlatformDataAssetsRouteRoute
    }
    '/_app/semantic-platform/data-models/': {
      id: '/_app/semantic-platform/data-models/'
      path: '/'
      fullPath: '/semantic-platform/data-models/'
      preLoaderRoute: typeof AppSemanticPlatformDataModelsIndexRouteImport
      parentRoute: typeof AppSemanticPlatformDataModelsRouteRoute
    }
    '/_app/semantic-platform/data-models/$id': {
      id: '/_app/semantic-platform/data-models/$id'
      path: '/$id'
      fullPath: '/semantic-platform/data-models/$id'
      preLoaderRoute: typeof AppSemanticPlatformDataModelsIdRouteImport
      parentRoute: typeof AppSemanticPlatformDataModelsRouteRoute
    }
    '/_app/semantic-platform/knowledge-debug/': {
      id: '/_app/semantic-platform/knowledge-debug/'
      path: '/'
      fullPath: '/semantic-platform/knowledge-debug/'
      preLoaderRoute: typeof AppSemanticPlatformKnowledgeDebugIndexRouteImport
      parentRoute: typeof AppSemanticPlatformKnowledgeDebugRouteRoute
    }
    '/_app/semantic-platform/namespaces/': {
      id: '/_app/semantic-platform/namespaces/'
      path: '/namespaces'
      fullPath: '/semantic-platform/namespaces/'
      preLoaderRoute: typeof AppSemanticPlatformNamespacesIndexRouteImport
      parentRoute: typeof AppSemanticPlatformRouteRoute
    }
    '/_app/semantic-platform/quantities/': {
      id: '/_app/semantic-platform/quantities/'
      path: '/'
      fullPath: '/semantic-platform/quantities/'
      preLoaderRoute: typeof AppSemanticPlatformQuantitiesIndexRouteImport
      parentRoute: typeof AppSemanticPlatformQuantitiesRouteRoute
    }
    '/_app/semantic-platform/quantities/$id': {
      id: '/_app/semantic-platform/quantities/$id'
      path: '/$id'
      fullPath: '/semantic-platform/quantities/$id'
      preLoaderRoute: typeof AppSemanticPlatformQuantitiesIdRouteImport
      parentRoute: typeof AppSemanticPlatformQuantitiesRouteRoute
    }
    '/_app/semantic-platform/tags/': {
      id: '/_app/semantic-platform/tags/'
      path: '/'
      fullPath: '/semantic-platform/tags/'
      preLoaderRoute: typeof AppSemanticPlatformTagsIndexRouteImport
      parentRoute: typeof AppSemanticPlatformTagsRouteRoute
    }
    '/_app/semantic-platform/vocabularies/': {
      id: '/_app/semantic-platform/vocabularies/'
      path: '/'
      fullPath: '/semantic-platform/vocabularies/'
      preLoaderRoute: typeof AppSemanticPlatformVocabulariesIndexRouteImport
      parentRoute: typeof AppSemanticPlatformVocabulariesRouteRoute
    }
    '/_app/semantic-platform/vocabularies/$id': {
      id: '/_app/semantic-platform/vocabularies/$id'
      path: '/$id'
      fullPath: '/semantic-platform/vocabularies/$id'
      preLoaderRoute: typeof AppSemanticPlatformVocabulariesIdRouteImport
      parentRoute: typeof AppSemanticPlatformVocabulariesRouteRoute
    }
    '/_app/settings/audit-logs/': {
      id: '/_app/settings/audit-logs/'
      path: '/'
      fullPath: '/settings/audit-logs/'
      preLoaderRoute: typeof AppSettingsAuditLogsIndexRouteImport
      parentRoute: typeof AppSettingsAuditLogsRoute
    }
    '/_app/settings/audit-logs/$id': {
      id: '/_app/settings/audit-logs/$id'
      path: '/$id'
      fullPath: '/settings/audit-logs/$id'
      preLoaderRoute: typeof AppSettingsAuditLogsIdRouteImport
      parentRoute: typeof AppSettingsAuditLogsRoute
    }
    '/_app/settings/industry-packs/': {
      id: '/_app/settings/industry-packs/'
      path: '/'
      fullPath: '/settings/industry-packs/'
      preLoaderRoute: typeof AppSettingsIndustryPacksIndexRouteImport
      parentRoute: typeof AppSettingsIndustryPacksRoute
    }
    '/_app/settings/industry-packs/$key': {
      id: '/_app/settings/industry-packs/$key'
      path: '/$key'
      fullPath: '/settings/industry-packs/$key'
      preLoaderRoute: typeof AppSettingsIndustryPacksKeyRouteImport
      parentRoute: typeof AppSettingsIndustryPacksRoute
    }
    '/_app/settings/tenants/$tenantId': {
      id: '/_app/settings/tenants/$tenantId'
      path: '/$tenantId'
      fullPath: '/settings/tenants/$tenantId'
      preLoaderRoute: typeof AppSettingsTenantsTenantIdRouteImport
      parentRoute: typeof AppSettingsTenantsRouteRoute
    }
    '/_app/tenant-settings/audit-logs/': {
      id: '/_app/tenant-settings/audit-logs/'
      path: '/'
      fullPath: '/tenant-settings/audit-logs/'
      preLoaderRoute: typeof AppTenantSettingsAuditLogsIndexRouteImport
      parentRoute: typeof AppTenantSettingsAuditLogsRoute
    }
    '/_app/tenant-settings/audit-logs/$id': {
      id: '/_app/tenant-settings/audit-logs/$id'
      path: '/$id'
      fullPath: '/tenant-settings/audit-logs/$id'
      preLoaderRoute: typeof AppTenantSettingsAuditLogsIdRouteImport
      parentRoute: typeof AppTenantSettingsAuditLogsRoute
    }
    '/_app/tenant-settings/industry-packs/': {
      id: '/_app/tenant-settings/industry-packs/'
      path: '/'
      fullPath: '/tenant-settings/industry-packs/'
      preLoaderRoute: typeof AppTenantSettingsIndustryPacksIndexRouteImport
      parentRoute: typeof AppTenantSettingsIndustryPacksRoute
    }
    '/_app/tenant-settings/industry-packs/$key': {
      id: '/_app/tenant-settings/industry-packs/$key'
      path: '/$key'
      fullPath: '/tenant-settings/industry-packs/$key'
      preLoaderRoute: typeof AppTenantSettingsIndustryPacksKeyRouteImport
      parentRoute: typeof AppTenantSettingsIndustryPacksRoute
    }
    '/_app/tenant-settings/metadata-templates/': {
      id: '/_app/tenant-settings/metadata-templates/'
      path: '/'
      fullPath: '/tenant-settings/metadata-templates/'
      preLoaderRoute: typeof AppTenantSettingsMetadataTemplatesIndexRouteImport
      parentRoute: typeof AppTenantSettingsMetadataTemplatesRoute
    }
    '/_app/tenant-settings/semantic-governance/': {
      id: '/_app/tenant-settings/semantic-governance/'
      path: '/'
      fullPath: '/tenant-settings/semantic-governance/'
      preLoaderRoute: typeof AppTenantSettingsSemanticGovernanceIndexRouteImport
      parentRoute: typeof AppTenantSettingsSemanticGovernanceRoute
    }
    '/_app/tenant-settings/semantic-governance/categories': {
      id: '/_app/tenant-settings/semantic-governance/categories'
      path: '/categories'
      fullPath: '/tenant-settings/semantic-governance/categories'
      preLoaderRoute: typeof AppTenantSettingsSemanticGovernanceCategoriesRouteImport
      parentRoute: typeof AppTenantSettingsSemanticGovernanceRoute
    }
    '/_app/truth/compares/$compareId': {
      id: '/_app/truth/compares/$compareId'
      path: '/$compareId'
      fullPath: '/truth/compares/$compareId'
      preLoaderRoute: typeof AppTruthComparesCompareIdRouteImport
      parentRoute: typeof AppTruthComparesRoute
    }
    '/_app/truth/rounds/$sessionId': {
      id: '/_app/truth/rounds/$sessionId'
      path: '/rounds/$sessionId'
      fullPath: '/truth/rounds/$sessionId'
      preLoaderRoute: typeof AppTruthRoundsSessionIdRouteImport
      parentRoute: typeof AppTruthRouteRoute
    }
    '/data-center/review/run/$runId': {
      id: '/data-center/review/run/$runId'
      path: '/data-center/review/run/$runId'
      fullPath: '/data-center/review/run/$runId'
      preLoaderRoute: typeof DataCenterReviewRunRunIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/data-center/extraction/edit/$taskId': {
      id: '/_app/data-center/extraction/edit/$taskId'
      path: '/edit/$taskId'
      fullPath: '/data-center/extraction/edit/$taskId'
      preLoaderRoute: typeof AppDataCenterExtractionEditTaskIdRouteImport
      parentRoute: typeof AppDataCenterExtractionRouteRoute
    }
    '/_app/data-center/tmpl/edit/$id': {
      id: '/_app/data-center/tmpl/edit/$id'
      path: '/edit/$id'
      fullPath: '/data-center/tmpl/edit/$id'
      preLoaderRoute: typeof AppDataCenterTmplEditIdRouteImport
      parentRoute: typeof AppDataCenterTmplRouteRoute
    }
    '/_app/data-center/tmpl/versions/$id': {
      id: '/_app/data-center/tmpl/versions/$id'
      path: '/versions/$id'
      fullPath: '/data-center/tmpl/versions/$id'
      preLoaderRoute: typeof AppDataCenterTmplVersionsIdRouteImport
      parentRoute: typeof AppDataCenterTmplRouteRoute
    }
    '/_app/semantic-platform/data-assets/batches/$batchId': {
      id: '/_app/semantic-platform/data-assets/batches/$batchId'
      path: '/batches/$batchId'
      fullPath: '/semantic-platform/data-assets/batches/$batchId'
      preLoaderRoute: typeof AppSemanticPlatformDataAssetsBatchesBatchIdRouteImport
      parentRoute: typeof AppSemanticPlatformDataAssetsRouteRoute
    }
    '/_app/semantic-platform/data-assets/entities/$entityId': {
      id: '/_app/semantic-platform/data-assets/entities/$entityId'
      path: '/entities/$entityId'
      fullPath: '/semantic-platform/data-assets/entities/$entityId'
      preLoaderRoute: typeof AppSemanticPlatformDataAssetsEntitiesEntityIdRouteImport
      parentRoute: typeof AppSemanticPlatformDataAssetsRouteRoute
    }
    '/_app/semantic-platform/data-governance/analysis/': {
      id: '/_app/semantic-platform/data-governance/analysis/'
      path: '/analysis'
      fullPath: '/semantic-platform/data-governance/analysis/'
      preLoaderRoute: typeof AppSemanticPlatformDataGovernanceAnalysisIndexRouteImport
      parentRoute: typeof AppSemanticPlatformDataGovernanceRouteRoute
    }
    '/_app/semantic-platform/data-governance/classifications/': {
      id: '/_app/semantic-platform/data-governance/classifications/'
      path: '/classifications'
      fullPath: '/semantic-platform/data-governance/classifications/'
      preLoaderRoute: typeof AppSemanticPlatformDataGovernanceClassificationsIndexRouteImport
      parentRoute: typeof AppSemanticPlatformDataGovernanceRouteRoute
    }
    '/_app/semantic-platform/data-governance/impact/': {
      id: '/_app/semantic-platform/data-governance/impact/'
      path: '/impact'
      fullPath: '/semantic-platform/data-governance/impact/'
      preLoaderRoute: typeof AppSemanticPlatformDataGovernanceImpactIndexRouteImport
      parentRoute: typeof AppSemanticPlatformDataGovernanceRouteRoute
    }
    '/_app/semantic-platform/data-governance/quality/': {
      id: '/_app/semantic-platform/data-governance/quality/'
      path: '/quality'
      fullPath: '/semantic-platform/data-governance/quality/'
      preLoaderRoute: typeof AppSemanticPlatformDataGovernanceQualityIndexRouteImport
      parentRoute: typeof AppSemanticPlatformDataGovernanceRouteRoute
    }
    '/_app/semantic-platform/data-governance/suggestions/': {
      id: '/_app/semantic-platform/data-governance/suggestions/'
      path: '/suggestions'
      fullPath: '/semantic-platform/data-governance/suggestions/'
      preLoaderRoute: typeof AppSemanticPlatformDataGovernanceSuggestionsIndexRouteImport
      parentRoute: typeof AppSemanticPlatformDataGovernanceRouteRoute
    }
    '/_app/semantic-platform/data-models/edit/$id': {
      id: '/_app/semantic-platform/data-models/edit/$id'
      path: '/edit/$id'
      fullPath: '/semantic-platform/data-models/edit/$id'
      preLoaderRoute: typeof AppSemanticPlatformDataModelsEditIdRouteImport
      parentRoute: typeof AppSemanticPlatformDataModelsRouteRoute
    }
    '/_app/semantic-platform/tag-center/fields/': {
      id: '/_app/semantic-platform/tag-center/fields/'
      path: '/fields'
      fullPath: '/semantic-platform/tag-center/fields/'
      preLoaderRoute: typeof AppSemanticPlatformTagCenterFieldsIndexRouteImport
      parentRoute: typeof AppSemanticPlatformTagCenterRouteRoute
    }
    '/_app/semantic-platform/tag-center/stats/': {
      id: '/_app/semantic-platform/tag-center/stats/'
      path: '/stats'
      fullPath: '/semantic-platform/tag-center/stats/'
      preLoaderRoute: typeof AppSemanticPlatformTagCenterStatsIndexRouteImport
      parentRoute: typeof AppSemanticPlatformTagCenterRouteRoute
    }
    '/_app/semantic-platform/tag-center/suggestions/': {
      id: '/_app/semantic-platform/tag-center/suggestions/'
      path: '/suggestions'
      fullPath: '/semantic-platform/tag-center/suggestions/'
      preLoaderRoute: typeof AppSemanticPlatformTagCenterSuggestionsIndexRouteImport
      parentRoute: typeof AppSemanticPlatformTagCenterRouteRoute
    }
    '/_app/settings/job-manager/schedule/$scheduleId': {
      id: '/_app/settings/job-manager/schedule/$scheduleId'
      path: '/schedule/$scheduleId'
      fullPath: '/settings/job-manager/schedule/$scheduleId'
      preLoaderRoute: typeof AppSettingsJobManagerScheduleScheduleIdRouteImport
      parentRoute: typeof AppSettingsJobManagerRouteRoute
    }
    '/_app/settings/job-manager/task/$taskId': {
      id: '/_app/settings/job-manager/task/$taskId'
      path: '/task/$taskId'
      fullPath: '/settings/job-manager/task/$taskId'
      preLoaderRoute: typeof AppSettingsJobManagerTaskTaskIdRouteImport
      parentRoute: typeof AppSettingsJobManagerRouteRoute
    }
    '/_app/tenant-settings/semantic-governance/terms/new': {
      id: '/_app/tenant-settings/semantic-governance/terms/new'
      path: '/terms/new'
      fullPath: '/tenant-settings/semantic-governance/terms/new'
      preLoaderRoute: typeof AppTenantSettingsSemanticGovernanceTermsNewRouteImport
      parentRoute: typeof AppTenantSettingsSemanticGovernanceRoute
    }
    '/_app/kb/$kbId/compilation/artifacts/$artifactId': {
      id: '/_app/kb/$kbId/compilation/artifacts/$artifactId'
      path: '/$kbId/compilation/artifacts/$artifactId'
      fullPath: '/kb/$kbId/compilation/artifacts/$artifactId'
      preLoaderRoute: typeof AppKbKbIdCompilationArtifactsArtifactIdRouteImport
      parentRoute: typeof AppKbRouteRoute
    }
    '/_app/kb/$kbId/compilation/runs/$runId': {
      id: '/_app/kb/$kbId/compilation/runs/$runId'
      path: '/$kbId/compilation/runs/$runId'
      fullPath: '/kb/$kbId/compilation/runs/$runId'
      preLoaderRoute: typeof AppKbKbIdCompilationRunsRunIdRouteImport
      parentRoute: typeof AppKbRouteRoute
    }
    '/_app/kb/$kbId/settings/terms/new': {
      id: '/_app/kb/$kbId/settings/terms/new'
      path: '/terms/new'
      fullPath: '/kb/$kbId/settings/terms/new'
      preLoaderRoute: typeof AppKbKbIdSettingsTermsNewRouteImport
      parentRoute: typeof AppKbKbIdSettingsRoute
    }
    '/_app/settings/job-manager/schedule/$scheduleId/$taskId': {
      id: '/_app/settings/job-manager/schedule/$scheduleId/$taskId'
      path: '/$taskId'
      fullPath: '/settings/job-manager/schedule/$scheduleId/$taskId'
      preLoaderRoute: typeof AppSettingsJobManagerScheduleScheduleIdTaskIdRouteImport
      parentRoute: typeof AppSettingsJobManagerScheduleScheduleIdRoute
    }
    '/_app/tenant-settings/semantic-governance/terms/edit/$id': {
      id: '/_app/tenant-settings/semantic-governance/terms/edit/$id'
      path: '/terms/edit/$id'
      fullPath: '/tenant-settings/semantic-governance/terms/edit/$id'
      preLoaderRoute: typeof AppTenantSettingsSemanticGovernanceTermsEditIdRouteImport
      parentRoute: typeof AppTenantSettingsSemanticGovernanceRoute
    }
    '/_app/kb/$kbId/settings/terms/edit/$id': {
      id: '/_app/kb/$kbId/settings/terms/edit/$id'
      path: '/terms/edit/$id'
      fullPath: '/kb/$kbId/settings/terms/edit/$id'
      preLoaderRoute: typeof AppKbKbIdSettingsTermsEditIdRouteImport
      parentRoute: typeof AppKbKbIdSettingsRoute
    }
  }
}

interface AppDataCenterExtractionRouteRouteChildren {
  AppDataCenterExtractionTaskIdRoute: typeof AppDataCenterExtractionTaskIdRoute
  AppDataCenterExtractionCreateRoute: typeof AppDataCenterExtractionCreateRoute
  AppDataCenterExtractionIndexRoute: typeof AppDataCenterExtractionIndexRoute
  AppDataCenterExtractionEditTaskIdRoute: typeof AppDataCenterExtractionEditTaskIdRoute
}

const AppDataCenterExtractionRouteRouteChildren: AppDataCenterExtractionRouteRouteChildren =
  {
    AppDataCenterExtractionTaskIdRoute: AppDataCenterExtractionTaskIdRoute,
    AppDataCenterExtractionCreateRoute: AppDataCenterExtractionCreateRoute,
    AppDataCenterExtractionIndexRoute: AppDataCenterExtractionIndexRoute,
    AppDataCenterExtractionEditTaskIdRoute:
      AppDataCenterExtractionEditTaskIdRoute,
  }

const AppDataCenterExtractionRouteRouteWithChildren =
  AppDataCenterExtractionRouteRoute._addFileChildren(
    AppDataCenterExtractionRouteRouteChildren,
  )

interface AppDataCenterTmplRouteRouteChildren {
  AppDataCenterTmplMetadataRoute: typeof AppDataCenterTmplMetadataRoute
  AppDataCenterTmplNewRoute: typeof AppDataCenterTmplNewRoute
  AppDataCenterTmplIndexRoute: typeof AppDataCenterTmplIndexRoute
  AppDataCenterTmplEditIdRoute: typeof AppDataCenterTmplEditIdRoute
  AppDataCenterTmplVersionsIdRoute: typeof AppDataCenterTmplVersionsIdRoute
}

const AppDataCenterTmplRouteRouteChildren: AppDataCenterTmplRouteRouteChildren =
  {
    AppDataCenterTmplMetadataRoute: AppDataCenterTmplMetadataRoute,
    AppDataCenterTmplNewRoute: AppDataCenterTmplNewRoute,
    AppDataCenterTmplIndexRoute: AppDataCenterTmplIndexRoute,
    AppDataCenterTmplEditIdRoute: AppDataCenterTmplEditIdRoute,
    AppDataCenterTmplVersionsIdRoute: AppDataCenterTmplVersionsIdRoute,
  }

const AppDataCenterTmplRouteRouteWithChildren =
  AppDataCenterTmplRouteRoute._addFileChildren(
    AppDataCenterTmplRouteRouteChildren,
  )

interface AppDataCenterRouteRouteChildren {
  AppDataCenterExtractionRouteRoute: typeof AppDataCenterExtractionRouteRouteWithChildren
  AppDataCenterTmplRouteRoute: typeof AppDataCenterTmplRouteRouteWithChildren
  AppDataCenterDatasourcesRoute: typeof AppDataCenterDatasourcesRoute
  AppDataCenterExportsRoute: typeof AppDataCenterExportsRoute
  AppDataCenterMetadataRoute: typeof AppDataCenterMetadataRoute
  AppDataCenterIndexRoute: typeof AppDataCenterIndexRoute
  AppDataCenterExportsExportIdRoute: typeof AppDataCenterExportsExportIdRoute
  AppDataCenterCleaningIndexRoute: typeof AppDataCenterCleaningIndexRoute
  AppDataCenterReviewIndexRoute: typeof AppDataCenterReviewIndexRoute
}

const AppDataCenterRouteRouteChildren: AppDataCenterRouteRouteChildren = {
  AppDataCenterExtractionRouteRoute:
    AppDataCenterExtractionRouteRouteWithChildren,
  AppDataCenterTmplRouteRoute: AppDataCenterTmplRouteRouteWithChildren,
  AppDataCenterDatasourcesRoute: AppDataCenterDatasourcesRoute,
  AppDataCenterExportsRoute: AppDataCenterExportsRoute,
  AppDataCenterMetadataRoute: AppDataCenterMetadataRoute,
  AppDataCenterIndexRoute: AppDataCenterIndexRoute,
  AppDataCenterExportsExportIdRoute: AppDataCenterExportsExportIdRoute,
  AppDataCenterCleaningIndexRoute: AppDataCenterCleaningIndexRoute,
  AppDataCenterReviewIndexRoute: AppDataCenterReviewIndexRoute,
}

const AppDataCenterRouteRouteWithChildren =
  AppDataCenterRouteRoute._addFileChildren(AppDataCenterRouteRouteChildren)

interface AppKbKbIdSettingsRouteChildren {
  AppKbKbIdSettingsTermsNewRoute: typeof AppKbKbIdSettingsTermsNewRoute
  AppKbKbIdSettingsTermsEditIdRoute: typeof AppKbKbIdSettingsTermsEditIdRoute
}

const AppKbKbIdSettingsRouteChildren: AppKbKbIdSettingsRouteChildren = {
  AppKbKbIdSettingsTermsNewRoute: AppKbKbIdSettingsTermsNewRoute,
  AppKbKbIdSettingsTermsEditIdRoute: AppKbKbIdSettingsTermsEditIdRoute,
}

const AppKbKbIdSettingsRouteWithChildren =
  AppKbKbIdSettingsRoute._addFileChildren(AppKbKbIdSettingsRouteChildren)

interface AppKbRouteRouteChildren {
  AppKbIndexRoute: typeof AppKbIndexRoute
  AppKbKbIdDocIdRoute: typeof AppKbKbIdDocIdRoute
  AppKbKbIdSettingsRoute: typeof AppKbKbIdSettingsRouteWithChildren
  AppKbKbIdIndexRoute: typeof AppKbKbIdIndexRoute
  AppKbKbIdCompilationArtifactsArtifactIdRoute: typeof AppKbKbIdCompilationArtifactsArtifactIdRoute
  AppKbKbIdCompilationRunsRunIdRoute: typeof AppKbKbIdCompilationRunsRunIdRoute
}

const AppKbRouteRouteChildren: AppKbRouteRouteChildren = {
  AppKbIndexRoute: AppKbIndexRoute,
  AppKbKbIdDocIdRoute: AppKbKbIdDocIdRoute,
  AppKbKbIdSettingsRoute: AppKbKbIdSettingsRouteWithChildren,
  AppKbKbIdIndexRoute: AppKbKbIdIndexRoute,
  AppKbKbIdCompilationArtifactsArtifactIdRoute:
    AppKbKbIdCompilationArtifactsArtifactIdRoute,
  AppKbKbIdCompilationRunsRunIdRoute: AppKbKbIdCompilationRunsRunIdRoute,
}

const AppKbRouteRouteWithChildren = AppKbRouteRoute._addFileChildren(
  AppKbRouteRouteChildren,
)

interface AppSemanticPlatformConceptsRouteRouteChildren {
  AppSemanticPlatformConceptsIdRoute: typeof AppSemanticPlatformConceptsIdRoute
  AppSemanticPlatformConceptsIndexRoute: typeof AppSemanticPlatformConceptsIndexRoute
}

const AppSemanticPlatformConceptsRouteRouteChildren: AppSemanticPlatformConceptsRouteRouteChildren =
  {
    AppSemanticPlatformConceptsIdRoute: AppSemanticPlatformConceptsIdRoute,
    AppSemanticPlatformConceptsIndexRoute:
      AppSemanticPlatformConceptsIndexRoute,
  }

const AppSemanticPlatformConceptsRouteRouteWithChildren =
  AppSemanticPlatformConceptsRouteRoute._addFileChildren(
    AppSemanticPlatformConceptsRouteRouteChildren,
  )

interface AppSemanticPlatformDataAssetsRouteRouteChildren {
  AppSemanticPlatformDataAssetsAssetIdRoute: typeof AppSemanticPlatformDataAssetsAssetIdRoute
  AppSemanticPlatformDataAssetsIndexRoute: typeof AppSemanticPlatformDataAssetsIndexRoute
  AppSemanticPlatformDataAssetsBatchesBatchIdRoute: typeof AppSemanticPlatformDataAssetsBatchesBatchIdRoute
  AppSemanticPlatformDataAssetsEntitiesEntityIdRoute: typeof AppSemanticPlatformDataAssetsEntitiesEntityIdRoute
}

const AppSemanticPlatformDataAssetsRouteRouteChildren: AppSemanticPlatformDataAssetsRouteRouteChildren =
  {
    AppSemanticPlatformDataAssetsAssetIdRoute:
      AppSemanticPlatformDataAssetsAssetIdRoute,
    AppSemanticPlatformDataAssetsIndexRoute:
      AppSemanticPlatformDataAssetsIndexRoute,
    AppSemanticPlatformDataAssetsBatchesBatchIdRoute:
      AppSemanticPlatformDataAssetsBatchesBatchIdRoute,
    AppSemanticPlatformDataAssetsEntitiesEntityIdRoute:
      AppSemanticPlatformDataAssetsEntitiesEntityIdRoute,
  }

const AppSemanticPlatformDataAssetsRouteRouteWithChildren =
  AppSemanticPlatformDataAssetsRouteRoute._addFileChildren(
    AppSemanticPlatformDataAssetsRouteRouteChildren,
  )

interface AppSemanticPlatformDataGovernanceRouteRouteChildren {
  AppSemanticPlatformDataGovernanceAnalysisIndexRoute: typeof AppSemanticPlatformDataGovernanceAnalysisIndexRoute
  AppSemanticPlatformDataGovernanceClassificationsIndexRoute: typeof AppSemanticPlatformDataGovernanceClassificationsIndexRoute
  AppSemanticPlatformDataGovernanceImpactIndexRoute: typeof AppSemanticPlatformDataGovernanceImpactIndexRoute
  AppSemanticPlatformDataGovernanceQualityIndexRoute: typeof AppSemanticPlatformDataGovernanceQualityIndexRoute
  AppSemanticPlatformDataGovernanceSuggestionsIndexRoute: typeof AppSemanticPlatformDataGovernanceSuggestionsIndexRoute
}

const AppSemanticPlatformDataGovernanceRouteRouteChildren: AppSemanticPlatformDataGovernanceRouteRouteChildren =
  {
    AppSemanticPlatformDataGovernanceAnalysisIndexRoute:
      AppSemanticPlatformDataGovernanceAnalysisIndexRoute,
    AppSemanticPlatformDataGovernanceClassificationsIndexRoute:
      AppSemanticPlatformDataGovernanceClassificationsIndexRoute,
    AppSemanticPlatformDataGovernanceImpactIndexRoute:
      AppSemanticPlatformDataGovernanceImpactIndexRoute,
    AppSemanticPlatformDataGovernanceQualityIndexRoute:
      AppSemanticPlatformDataGovernanceQualityIndexRoute,
    AppSemanticPlatformDataGovernanceSuggestionsIndexRoute:
      AppSemanticPlatformDataGovernanceSuggestionsIndexRoute,
  }

const AppSemanticPlatformDataGovernanceRouteRouteWithChildren =
  AppSemanticPlatformDataGovernanceRouteRoute._addFileChildren(
    AppSemanticPlatformDataGovernanceRouteRouteChildren,
  )

interface AppSemanticPlatformDataModelsRouteRouteChildren {
  AppSemanticPlatformDataModelsIdRoute: typeof AppSemanticPlatformDataModelsIdRoute
  AppSemanticPlatformDataModelsIndexRoute: typeof AppSemanticPlatformDataModelsIndexRoute
  AppSemanticPlatformDataModelsEditIdRoute: typeof AppSemanticPlatformDataModelsEditIdRoute
}

const AppSemanticPlatformDataModelsRouteRouteChildren: AppSemanticPlatformDataModelsRouteRouteChildren =
  {
    AppSemanticPlatformDataModelsIdRoute: AppSemanticPlatformDataModelsIdRoute,
    AppSemanticPlatformDataModelsIndexRoute:
      AppSemanticPlatformDataModelsIndexRoute,
    AppSemanticPlatformDataModelsEditIdRoute:
      AppSemanticPlatformDataModelsEditIdRoute,
  }

const AppSemanticPlatformDataModelsRouteRouteWithChildren =
  AppSemanticPlatformDataModelsRouteRoute._addFileChildren(
    AppSemanticPlatformDataModelsRouteRouteChildren,
  )

interface AppSemanticPlatformKnowledgeDebugRouteRouteChildren {
  AppSemanticPlatformKnowledgeDebugIndexRoute: typeof AppSemanticPlatformKnowledgeDebugIndexRoute
}

const AppSemanticPlatformKnowledgeDebugRouteRouteChildren: AppSemanticPlatformKnowledgeDebugRouteRouteChildren =
  {
    AppSemanticPlatformKnowledgeDebugIndexRoute:
      AppSemanticPlatformKnowledgeDebugIndexRoute,
  }

const AppSemanticPlatformKnowledgeDebugRouteRouteWithChildren =
  AppSemanticPlatformKnowledgeDebugRouteRoute._addFileChildren(
    AppSemanticPlatformKnowledgeDebugRouteRouteChildren,
  )

interface AppSemanticPlatformQuantitiesRouteRouteChildren {
  AppSemanticPlatformQuantitiesIdRoute: typeof AppSemanticPlatformQuantitiesIdRoute
  AppSemanticPlatformQuantitiesIndexRoute: typeof AppSemanticPlatformQuantitiesIndexRoute
}

const AppSemanticPlatformQuantitiesRouteRouteChildren: AppSemanticPlatformQuantitiesRouteRouteChildren =
  {
    AppSemanticPlatformQuantitiesIdRoute: AppSemanticPlatformQuantitiesIdRoute,
    AppSemanticPlatformQuantitiesIndexRoute:
      AppSemanticPlatformQuantitiesIndexRoute,
  }

const AppSemanticPlatformQuantitiesRouteRouteWithChildren =
  AppSemanticPlatformQuantitiesRouteRoute._addFileChildren(
    AppSemanticPlatformQuantitiesRouteRouteChildren,
  )

interface AppSemanticPlatformTagCenterRouteRouteChildren {
  AppSemanticPlatformTagCenterFieldsIndexRoute: typeof AppSemanticPlatformTagCenterFieldsIndexRoute
  AppSemanticPlatformTagCenterStatsIndexRoute: typeof AppSemanticPlatformTagCenterStatsIndexRoute
  AppSemanticPlatformTagCenterSuggestionsIndexRoute: typeof AppSemanticPlatformTagCenterSuggestionsIndexRoute
}

const AppSemanticPlatformTagCenterRouteRouteChildren: AppSemanticPlatformTagCenterRouteRouteChildren =
  {
    AppSemanticPlatformTagCenterFieldsIndexRoute:
      AppSemanticPlatformTagCenterFieldsIndexRoute,
    AppSemanticPlatformTagCenterStatsIndexRoute:
      AppSemanticPlatformTagCenterStatsIndexRoute,
    AppSemanticPlatformTagCenterSuggestionsIndexRoute:
      AppSemanticPlatformTagCenterSuggestionsIndexRoute,
  }

const AppSemanticPlatformTagCenterRouteRouteWithChildren =
  AppSemanticPlatformTagCenterRouteRoute._addFileChildren(
    AppSemanticPlatformTagCenterRouteRouteChildren,
  )

interface AppSemanticPlatformTagsRouteRouteChildren {
  AppSemanticPlatformTagsIndexRoute: typeof AppSemanticPlatformTagsIndexRoute
}

const AppSemanticPlatformTagsRouteRouteChildren: AppSemanticPlatformTagsRouteRouteChildren =
  {
    AppSemanticPlatformTagsIndexRoute: AppSemanticPlatformTagsIndexRoute,
  }

const AppSemanticPlatformTagsRouteRouteWithChildren =
  AppSemanticPlatformTagsRouteRoute._addFileChildren(
    AppSemanticPlatformTagsRouteRouteChildren,
  )

interface AppSemanticPlatformVocabulariesRouteRouteChildren {
  AppSemanticPlatformVocabulariesIdRoute: typeof AppSemanticPlatformVocabulariesIdRoute
  AppSemanticPlatformVocabulariesIndexRoute: typeof AppSemanticPlatformVocabulariesIndexRoute
}

const AppSemanticPlatformVocabulariesRouteRouteChildren: AppSemanticPlatformVocabulariesRouteRouteChildren =
  {
    AppSemanticPlatformVocabulariesIdRoute:
      AppSemanticPlatformVocabulariesIdRoute,
    AppSemanticPlatformVocabulariesIndexRoute:
      AppSemanticPlatformVocabulariesIndexRoute,
  }

const AppSemanticPlatformVocabulariesRouteRouteWithChildren =
  AppSemanticPlatformVocabulariesRouteRoute._addFileChildren(
    AppSemanticPlatformVocabulariesRouteRouteChildren,
  )

interface AppSemanticPlatformRouteRouteChildren {
  AppSemanticPlatformConceptsRouteRoute: typeof AppSemanticPlatformConceptsRouteRouteWithChildren
  AppSemanticPlatformDataAssetsRouteRoute: typeof AppSemanticPlatformDataAssetsRouteRouteWithChildren
  AppSemanticPlatformDataGovernanceRouteRoute: typeof AppSemanticPlatformDataGovernanceRouteRouteWithChildren
  AppSemanticPlatformDataModelsRouteRoute: typeof AppSemanticPlatformDataModelsRouteRouteWithChildren
  AppSemanticPlatformKnowledgeDebugRouteRoute: typeof AppSemanticPlatformKnowledgeDebugRouteRouteWithChildren
  AppSemanticPlatformQuantitiesRouteRoute: typeof AppSemanticPlatformQuantitiesRouteRouteWithChildren
  AppSemanticPlatformTagCenterRouteRoute: typeof AppSemanticPlatformTagCenterRouteRouteWithChildren
  AppSemanticPlatformTagsRouteRoute: typeof AppSemanticPlatformTagsRouteRouteWithChildren
  AppSemanticPlatformVocabulariesRouteRoute: typeof AppSemanticPlatformVocabulariesRouteRouteWithChildren
  AppSemanticPlatformDataLineageRoute: typeof AppSemanticPlatformDataLineageRoute
  AppSemanticPlatformIndexRoute: typeof AppSemanticPlatformIndexRoute
  AppSemanticPlatformNamespacesIndexRoute: typeof AppSemanticPlatformNamespacesIndexRoute
}

const AppSemanticPlatformRouteRouteChildren: AppSemanticPlatformRouteRouteChildren =
  {
    AppSemanticPlatformConceptsRouteRoute:
      AppSemanticPlatformConceptsRouteRouteWithChildren,
    AppSemanticPlatformDataAssetsRouteRoute:
      AppSemanticPlatformDataAssetsRouteRouteWithChildren,
    AppSemanticPlatformDataGovernanceRouteRoute:
      AppSemanticPlatformDataGovernanceRouteRouteWithChildren,
    AppSemanticPlatformDataModelsRouteRoute:
      AppSemanticPlatformDataModelsRouteRouteWithChildren,
    AppSemanticPlatformKnowledgeDebugRouteRoute:
      AppSemanticPlatformKnowledgeDebugRouteRouteWithChildren,
    AppSemanticPlatformQuantitiesRouteRoute:
      AppSemanticPlatformQuantitiesRouteRouteWithChildren,
    AppSemanticPlatformTagCenterRouteRoute:
      AppSemanticPlatformTagCenterRouteRouteWithChildren,
    AppSemanticPlatformTagsRouteRoute:
      AppSemanticPlatformTagsRouteRouteWithChildren,
    AppSemanticPlatformVocabulariesRouteRoute:
      AppSemanticPlatformVocabulariesRouteRouteWithChildren,
    AppSemanticPlatformDataLineageRoute: AppSemanticPlatformDataLineageRoute,
    AppSemanticPlatformIndexRoute: AppSemanticPlatformIndexRoute,
    AppSemanticPlatformNamespacesIndexRoute:
      AppSemanticPlatformNamespacesIndexRoute,
  }

const AppSemanticPlatformRouteRouteWithChildren =
  AppSemanticPlatformRouteRoute._addFileChildren(
    AppSemanticPlatformRouteRouteChildren,
  )

interface AppSettingsJobManagerScheduleScheduleIdRouteChildren {
  AppSettingsJobManagerScheduleScheduleIdTaskIdRoute: typeof AppSettingsJobManagerScheduleScheduleIdTaskIdRoute
}

const AppSettingsJobManagerScheduleScheduleIdRouteChildren: AppSettingsJobManagerScheduleScheduleIdRouteChildren =
  {
    AppSettingsJobManagerScheduleScheduleIdTaskIdRoute:
      AppSettingsJobManagerScheduleScheduleIdTaskIdRoute,
  }

const AppSettingsJobManagerScheduleScheduleIdRouteWithChildren =
  AppSettingsJobManagerScheduleScheduleIdRoute._addFileChildren(
    AppSettingsJobManagerScheduleScheduleIdRouteChildren,
  )

interface AppSettingsJobManagerRouteRouteChildren {
  AppSettingsJobManagerScheduleScheduleIdRoute: typeof AppSettingsJobManagerScheduleScheduleIdRouteWithChildren
  AppSettingsJobManagerTaskTaskIdRoute: typeof AppSettingsJobManagerTaskTaskIdRoute
}

const AppSettingsJobManagerRouteRouteChildren: AppSettingsJobManagerRouteRouteChildren =
  {
    AppSettingsJobManagerScheduleScheduleIdRoute:
      AppSettingsJobManagerScheduleScheduleIdRouteWithChildren,
    AppSettingsJobManagerTaskTaskIdRoute: AppSettingsJobManagerTaskTaskIdRoute,
  }

const AppSettingsJobManagerRouteRouteWithChildren =
  AppSettingsJobManagerRouteRoute._addFileChildren(
    AppSettingsJobManagerRouteRouteChildren,
  )

interface AppSettingsTenantsRouteRouteChildren {
  AppSettingsTenantsTenantIdRoute: typeof AppSettingsTenantsTenantIdRoute
}

const AppSettingsTenantsRouteRouteChildren: AppSettingsTenantsRouteRouteChildren =
  {
    AppSettingsTenantsTenantIdRoute: AppSettingsTenantsTenantIdRoute,
  }

const AppSettingsTenantsRouteRouteWithChildren =
  AppSettingsTenantsRouteRoute._addFileChildren(
    AppSettingsTenantsRouteRouteChildren,
  )

interface AppSettingsAuditLogsRouteChildren {
  AppSettingsAuditLogsIdRoute: typeof AppSettingsAuditLogsIdRoute
  AppSettingsAuditLogsIndexRoute: typeof AppSettingsAuditLogsIndexRoute
}

const AppSettingsAuditLogsRouteChildren: AppSettingsAuditLogsRouteChildren = {
  AppSettingsAuditLogsIdRoute: AppSettingsAuditLogsIdRoute,
  AppSettingsAuditLogsIndexRoute: AppSettingsAuditLogsIndexRoute,
}

const AppSettingsAuditLogsRouteWithChildren =
  AppSettingsAuditLogsRoute._addFileChildren(AppSettingsAuditLogsRouteChildren)

interface AppSettingsIndustryPacksRouteChildren {
  AppSettingsIndustryPacksKeyRoute: typeof AppSettingsIndustryPacksKeyRoute
  AppSettingsIndustryPacksIndexRoute: typeof AppSettingsIndustryPacksIndexRoute
}

const AppSettingsIndustryPacksRouteChildren: AppSettingsIndustryPacksRouteChildren =
  {
    AppSettingsIndustryPacksKeyRoute: AppSettingsIndustryPacksKeyRoute,
    AppSettingsIndustryPacksIndexRoute: AppSettingsIndustryPacksIndexRoute,
  }

const AppSettingsIndustryPacksRouteWithChildren =
  AppSettingsIndustryPacksRoute._addFileChildren(
    AppSettingsIndustryPacksRouteChildren,
  )

interface AppSettingsRouteRouteChildren {
  AppSettingsJobManagerRouteRoute: typeof AppSettingsJobManagerRouteRouteWithChildren
  AppSettingsTenantsRouteRoute: typeof AppSettingsTenantsRouteRouteWithChildren
  AppSettingsAiModelsRoute: typeof AppSettingsAiModelsRoute
  AppSettingsAuditLogsRoute: typeof AppSettingsAuditLogsRouteWithChildren
  AppSettingsBotsRoute: typeof AppSettingsBotsRoute
  AppSettingsDataSourcesRoute: typeof AppSettingsDataSourcesRoute
  AppSettingsDatabaseRoute: typeof AppSettingsDatabaseRoute
  AppSettingsHelpDocsRoute: typeof AppSettingsHelpDocsRoute
  AppSettingsIndustryPacksRoute: typeof AppSettingsIndustryPacksRouteWithChildren
  AppSettingsLicenseRoute: typeof AppSettingsLicenseRoute
  AppSettingsMetadataTemplatesRoute: typeof AppSettingsMetadataTemplatesRoute
  AppSettingsParserRoute: typeof AppSettingsParserRoute
  AppSettingsQuotaManagementRoute: typeof AppSettingsQuotaManagementRoute
  AppSettingsStorageCleanupRoute: typeof AppSettingsStorageCleanupRoute
  AppSettingsSystemRoute: typeof AppSettingsSystemRoute
  AppSettingsSystemStatusRoute: typeof AppSettingsSystemStatusRoute
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute
}

const AppSettingsRouteRouteChildren: AppSettingsRouteRouteChildren = {
  AppSettingsJobManagerRouteRoute: AppSettingsJobManagerRouteRouteWithChildren,
  AppSettingsTenantsRouteRoute: AppSettingsTenantsRouteRouteWithChildren,
  AppSettingsAiModelsRoute: AppSettingsAiModelsRoute,
  AppSettingsAuditLogsRoute: AppSettingsAuditLogsRouteWithChildren,
  AppSettingsBotsRoute: AppSettingsBotsRoute,
  AppSettingsDataSourcesRoute: AppSettingsDataSourcesRoute,
  AppSettingsDatabaseRoute: AppSettingsDatabaseRoute,
  AppSettingsHelpDocsRoute: AppSettingsHelpDocsRoute,
  AppSettingsIndustryPacksRoute: AppSettingsIndustryPacksRouteWithChildren,
  AppSettingsLicenseRoute: AppSettingsLicenseRoute,
  AppSettingsMetadataTemplatesRoute: AppSettingsMetadataTemplatesRoute,
  AppSettingsParserRoute: AppSettingsParserRoute,
  AppSettingsQuotaManagementRoute: AppSettingsQuotaManagementRoute,
  AppSettingsStorageCleanupRoute: AppSettingsStorageCleanupRoute,
  AppSettingsSystemRoute: AppSettingsSystemRoute,
  AppSettingsSystemStatusRoute: AppSettingsSystemStatusRoute,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
}

const AppSettingsRouteRouteWithChildren =
  AppSettingsRouteRoute._addFileChildren(AppSettingsRouteRouteChildren)

interface AppTenantSettingsAuditLogsRouteChildren {
  AppTenantSettingsAuditLogsIdRoute: typeof AppTenantSettingsAuditLogsIdRoute
  AppTenantSettingsAuditLogsIndexRoute: typeof AppTenantSettingsAuditLogsIndexRoute
}

const AppTenantSettingsAuditLogsRouteChildren: AppTenantSettingsAuditLogsRouteChildren =
  {
    AppTenantSettingsAuditLogsIdRoute: AppTenantSettingsAuditLogsIdRoute,
    AppTenantSettingsAuditLogsIndexRoute: AppTenantSettingsAuditLogsIndexRoute,
  }

const AppTenantSettingsAuditLogsRouteWithChildren =
  AppTenantSettingsAuditLogsRoute._addFileChildren(
    AppTenantSettingsAuditLogsRouteChildren,
  )

interface AppTenantSettingsIndustryPacksRouteChildren {
  AppTenantSettingsIndustryPacksKeyRoute: typeof AppTenantSettingsIndustryPacksKeyRoute
  AppTenantSettingsIndustryPacksIndexRoute: typeof AppTenantSettingsIndustryPacksIndexRoute
}

const AppTenantSettingsIndustryPacksRouteChildren: AppTenantSettingsIndustryPacksRouteChildren =
  {
    AppTenantSettingsIndustryPacksKeyRoute:
      AppTenantSettingsIndustryPacksKeyRoute,
    AppTenantSettingsIndustryPacksIndexRoute:
      AppTenantSettingsIndustryPacksIndexRoute,
  }

const AppTenantSettingsIndustryPacksRouteWithChildren =
  AppTenantSettingsIndustryPacksRoute._addFileChildren(
    AppTenantSettingsIndustryPacksRouteChildren,
  )

interface AppTenantSettingsMetadataTemplatesRouteChildren {
  AppTenantSettingsMetadataTemplatesIndexRoute: typeof AppTenantSettingsMetadataTemplatesIndexRoute
}

const AppTenantSettingsMetadataTemplatesRouteChildren: AppTenantSettingsMetadataTemplatesRouteChildren =
  {
    AppTenantSettingsMetadataTemplatesIndexRoute:
      AppTenantSettingsMetadataTemplatesIndexRoute,
  }

const AppTenantSettingsMetadataTemplatesRouteWithChildren =
  AppTenantSettingsMetadataTemplatesRoute._addFileChildren(
    AppTenantSettingsMetadataTemplatesRouteChildren,
  )

interface AppTenantSettingsSemanticGovernanceRouteChildren {
  AppTenantSettingsSemanticGovernanceCategoriesRoute: typeof AppTenantSettingsSemanticGovernanceCategoriesRoute
  AppTenantSettingsSemanticGovernanceIndexRoute: typeof AppTenantSettingsSemanticGovernanceIndexRoute
  AppTenantSettingsSemanticGovernanceTermsNewRoute: typeof AppTenantSettingsSemanticGovernanceTermsNewRoute
  AppTenantSettingsSemanticGovernanceTermsEditIdRoute: typeof AppTenantSettingsSemanticGovernanceTermsEditIdRoute
}

const AppTenantSettingsSemanticGovernanceRouteChildren: AppTenantSettingsSemanticGovernanceRouteChildren =
  {
    AppTenantSettingsSemanticGovernanceCategoriesRoute:
      AppTenantSettingsSemanticGovernanceCategoriesRoute,
    AppTenantSettingsSemanticGovernanceIndexRoute:
      AppTenantSettingsSemanticGovernanceIndexRoute,
    AppTenantSettingsSemanticGovernanceTermsNewRoute:
      AppTenantSettingsSemanticGovernanceTermsNewRoute,
    AppTenantSettingsSemanticGovernanceTermsEditIdRoute:
      AppTenantSettingsSemanticGovernanceTermsEditIdRoute,
  }

const AppTenantSettingsSemanticGovernanceRouteWithChildren =
  AppTenantSettingsSemanticGovernanceRoute._addFileChildren(
    AppTenantSettingsSemanticGovernanceRouteChildren,
  )

interface AppTenantSettingsRouteRouteChildren {
  AppTenantSettingsAiModelsRoute: typeof AppTenantSettingsAiModelsRoute
  AppTenantSettingsAuditLogsRoute: typeof AppTenantSettingsAuditLogsRouteWithChildren
  AppTenantSettingsBotsRoute: typeof AppTenantSettingsBotsRoute
  AppTenantSettingsDataSourcesRoute: typeof AppTenantSettingsDataSourcesRoute
  AppTenantSettingsDepartmentsRoute: typeof AppTenantSettingsDepartmentsRoute
  AppTenantSettingsDocSettingsRoute: typeof AppTenantSettingsDocSettingsRoute
  AppTenantSettingsDocumentSecurityRoute: typeof AppTenantSettingsDocumentSecurityRoute
  AppTenantSettingsIndustryPacksRoute: typeof AppTenantSettingsIndustryPacksRouteWithChildren
  AppTenantSettingsInvitesRoute: typeof AppTenantSettingsInvitesRoute
  AppTenantSettingsMetadataTemplatesRoute: typeof AppTenantSettingsMetadataTemplatesRouteWithChildren
  AppTenantSettingsParseEnginesRoute: typeof AppTenantSettingsParseEnginesRoute
  AppTenantSettingsPermissionsRoute: typeof AppTenantSettingsPermissionsRoute
  AppTenantSettingsPublicationsRoute: typeof AppTenantSettingsPublicationsRoute
  AppTenantSettingsRolesRoute: typeof AppTenantSettingsRolesRoute
  AppTenantSettingsSemanticGovernanceRoute: typeof AppTenantSettingsSemanticGovernanceRouteWithChildren
  AppTenantSettingsShareGovernanceRoute: typeof AppTenantSettingsShareGovernanceRoute
  AppTenantSettingsSystemStatusRoute: typeof AppTenantSettingsSystemStatusRoute
  AppTenantSettingsTenantInfoRoute: typeof AppTenantSettingsTenantInfoRoute
  AppTenantSettingsUsersRoute: typeof AppTenantSettingsUsersRoute
  AppTenantSettingsIndexRoute: typeof AppTenantSettingsIndexRoute
}

const AppTenantSettingsRouteRouteChildren: AppTenantSettingsRouteRouteChildren =
  {
    AppTenantSettingsAiModelsRoute: AppTenantSettingsAiModelsRoute,
    AppTenantSettingsAuditLogsRoute:
      AppTenantSettingsAuditLogsRouteWithChildren,
    AppTenantSettingsBotsRoute: AppTenantSettingsBotsRoute,
    AppTenantSettingsDataSourcesRoute: AppTenantSettingsDataSourcesRoute,
    AppTenantSettingsDepartmentsRoute: AppTenantSettingsDepartmentsRoute,
    AppTenantSettingsDocSettingsRoute: AppTenantSettingsDocSettingsRoute,
    AppTenantSettingsDocumentSecurityRoute:
      AppTenantSettingsDocumentSecurityRoute,
    AppTenantSettingsIndustryPacksRoute:
      AppTenantSettingsIndustryPacksRouteWithChildren,
    AppTenantSettingsInvitesRoute: AppTenantSettingsInvitesRoute,
    AppTenantSettingsMetadataTemplatesRoute:
      AppTenantSettingsMetadataTemplatesRouteWithChildren,
    AppTenantSettingsParseEnginesRoute: AppTenantSettingsParseEnginesRoute,
    AppTenantSettingsPermissionsRoute: AppTenantSettingsPermissionsRoute,
    AppTenantSettingsPublicationsRoute: AppTenantSettingsPublicationsRoute,
    AppTenantSettingsRolesRoute: AppTenantSettingsRolesRoute,
    AppTenantSettingsSemanticGovernanceRoute:
      AppTenantSettingsSemanticGovernanceRouteWithChildren,
    AppTenantSettingsShareGovernanceRoute:
      AppTenantSettingsShareGovernanceRoute,
    AppTenantSettingsSystemStatusRoute: AppTenantSettingsSystemStatusRoute,
    AppTenantSettingsTenantInfoRoute: AppTenantSettingsTenantInfoRoute,
    AppTenantSettingsUsersRoute: AppTenantSettingsUsersRoute,
    AppTenantSettingsIndexRoute: AppTenantSettingsIndexRoute,
  }

const AppTenantSettingsRouteRouteWithChildren =
  AppTenantSettingsRouteRoute._addFileChildren(
    AppTenantSettingsRouteRouteChildren,
  )

interface AppTruthComparesRouteChildren {
  AppTruthComparesCompareIdRoute: typeof AppTruthComparesCompareIdRoute
}

const AppTruthComparesRouteChildren: AppTruthComparesRouteChildren = {
  AppTruthComparesCompareIdRoute: AppTruthComparesCompareIdRoute,
}

const AppTruthComparesRouteWithChildren =
  AppTruthComparesRoute._addFileChildren(AppTruthComparesRouteChildren)

interface AppTruthRouteRouteChildren {
  AppTruthComparesRoute: typeof AppTruthComparesRouteWithChildren
  AppTruthIndexRoute: typeof AppTruthIndexRoute
  AppTruthRoundsSessionIdRoute: typeof AppTruthRoundsSessionIdRoute
}

const AppTruthRouteRouteChildren: AppTruthRouteRouteChildren = {
  AppTruthComparesRoute: AppTruthComparesRouteWithChildren,
  AppTruthIndexRoute: AppTruthIndexRoute,
  AppTruthRoundsSessionIdRoute: AppTruthRoundsSessionIdRoute,
}

const AppTruthRouteRouteWithChildren = AppTruthRouteRoute._addFileChildren(
  AppTruthRouteRouteChildren,
)

interface AppRouteChildren {
  AppDataCenterRouteRoute: typeof AppDataCenterRouteRouteWithChildren
  AppKbRouteRoute: typeof AppKbRouteRouteWithChildren
  AppSemanticPlatformRouteRoute: typeof AppSemanticPlatformRouteRouteWithChildren
  AppSettingsRouteRoute: typeof AppSettingsRouteRouteWithChildren
  AppTenantSettingsRouteRoute: typeof AppTenantSettingsRouteRouteWithChildren
  AppTruthRouteRoute: typeof AppTruthRouteRouteWithChildren
  AppAccountRoute: typeof AppAccountRoute
  AppDocCenterRoute: typeof AppDocCenterRoute
  AppRecycleBinRoute: typeof AppRecycleBinRoute
  AppSearchRoute: typeof AppSearchRoute
  AppSuggestionsRoute: typeof AppSuggestionsRoute
  AppIndexRoute: typeof AppIndexRoute
  AppBotsNewRoute: typeof AppBotsNewRoute
  AppCadEditIdRoute: typeof AppCadEditIdRoute
  AppDocGenerationCreateRoute: typeof AppDocGenerationCreateRoute
  AppDocGenerationTemplatesRoute: typeof AppDocGenerationTemplatesRoute
  AppDocGenerationWritingStyleRoute: typeof AppDocGenerationWritingStyleRoute
  AppFilePreviewFileIdRoute: typeof AppFilePreviewFileIdRoute
  AppSsBidGenResourcesRoute: typeof AppSsBidGenResourcesRoute
  AppBotMarketIndexRoute: typeof AppBotMarketIndexRoute
  AppBotsIndexRoute: typeof AppBotsIndexRoute
  AppDocGenerationIndexRoute: typeof AppDocGenerationIndexRoute
  AppProjectsIndexRoute: typeof AppProjectsIndexRoute
  AppWorkbenchIndexRoute: typeof AppWorkbenchIndexRoute
  AppBotsBotIdRunRoute: typeof AppBotsBotIdRunRoute
  AppBotsBotIdStudioRoute: typeof AppBotsBotIdStudioRoute
  AppBotsCredentialsCredentialIdRoute: typeof AppBotsCredentialsCredentialIdRoute
  AppBotsCredentialsNewRoute: typeof AppBotsCredentialsNewRoute
  AppBotsSkillsSkillIdRoute: typeof AppBotsSkillsSkillIdRoute
  AppBotsSkillsNewRoute: typeof AppBotsSkillsNewRoute
  AppBotsToolsToolIdRoute: typeof AppBotsToolsToolIdRoute
  AppBotsToolsNewRoute: typeof AppBotsToolsNewRoute
  AppDocGenerationTaskIdArtifactRoute: typeof AppDocGenerationTaskIdArtifactRoute
  AppDocGenerationTaskIdOutlineRoute: typeof AppDocGenerationTaskIdOutlineRoute
  AppDocGenerationTaskIdWritingRoute: typeof AppDocGenerationTaskIdWritingRoute
  AppProjectsTemplatesTemplateIdRoute: typeof AppProjectsTemplatesTemplateIdRoute
  AppDocGenerationTaskIdIndexRoute: typeof AppDocGenerationTaskIdIndexRoute
  AppProjectsTemplatesIndexRoute: typeof AppProjectsTemplatesIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppDataCenterRouteRoute: AppDataCenterRouteRouteWithChildren,
  AppKbRouteRoute: AppKbRouteRouteWithChildren,
  AppSemanticPlatformRouteRoute: AppSemanticPlatformRouteRouteWithChildren,
  AppSettingsRouteRoute: AppSettingsRouteRouteWithChildren,
  AppTenantSettingsRouteRoute: AppTenantSettingsRouteRouteWithChildren,
  AppTruthRouteRoute: AppTruthRouteRouteWithChildren,
  AppAccountRoute: AppAccountRoute,
  AppDocCenterRoute: AppDocCenterRoute,
  AppRecycleBinRoute: AppRecycleBinRoute,
  AppSearchRoute: AppSearchRoute,
  AppSuggestionsRoute: AppSuggestionsRoute,
  AppIndexRoute: AppIndexRoute,
  AppBotsNewRoute: AppBotsNewRoute,
  AppCadEditIdRoute: AppCadEditIdRoute,
  AppDocGenerationCreateRoute: AppDocGenerationCreateRoute,
  AppDocGenerationTemplatesRoute: AppDocGenerationTemplatesRoute,
  AppDocGenerationWritingStyleRoute: AppDocGenerationWritingStyleRoute,
  AppFilePreviewFileIdRoute: AppFilePreviewFileIdRoute,
  AppSsBidGenResourcesRoute: AppSsBidGenResourcesRoute,
  AppBotMarketIndexRoute: AppBotMarketIndexRoute,
  AppBotsIndexRoute: AppBotsIndexRoute,
  AppDocGenerationIndexRoute: AppDocGenerationIndexRoute,
  AppProjectsIndexRoute: AppProjectsIndexRoute,
  AppWorkbenchIndexRoute: AppWorkbenchIndexRoute,
  AppBotsBotIdRunRoute: AppBotsBotIdRunRoute,
  AppBotsBotIdStudioRoute: AppBotsBotIdStudioRoute,
  AppBotsCredentialsCredentialIdRoute: AppBotsCredentialsCredentialIdRoute,
  AppBotsCredentialsNewRoute: AppBotsCredentialsNewRoute,
  AppBotsSkillsSkillIdRoute: AppBotsSkillsSkillIdRoute,
  AppBotsSkillsNewRoute: AppBotsSkillsNewRoute,
  AppBotsToolsToolIdRoute: AppBotsToolsToolIdRoute,
  AppBotsToolsNewRoute: AppBotsToolsNewRoute,
  AppDocGenerationTaskIdArtifactRoute: AppDocGenerationTaskIdArtifactRoute,
  AppDocGenerationTaskIdOutlineRoute: AppDocGenerationTaskIdOutlineRoute,
  AppDocGenerationTaskIdWritingRoute: AppDocGenerationTaskIdWritingRoute,
  AppProjectsTemplatesTemplateIdRoute: AppProjectsTemplatesTemplateIdRoute,
  AppDocGenerationTaskIdIndexRoute: AppDocGenerationTaskIdIndexRoute,
  AppProjectsTemplatesIndexRoute: AppProjectsTemplatesIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface WorkspaceRouteChildren {
  WorkspaceProjectsProjectIdRoute: typeof WorkspaceProjectsProjectIdRoute
}

const WorkspaceRouteChildren: WorkspaceRouteChildren = {
  WorkspaceProjectsProjectIdRoute: WorkspaceProjectsProjectIdRoute,
}

const WorkspaceRouteWithChildren = WorkspaceRoute._addFileChildren(
  WorkspaceRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  WorkspaceRoute: WorkspaceRouteWithChildren,
  ExcelUniverDemoRoute: ExcelUniverDemoRoute,
  LoginRoute: LoginRoute,
  PptEditorDemoRoute: PptEditorDemoRoute,
  PrivacyPolicyRoute: PrivacyPolicyRoute,
  RegisterRoute: RegisterRoute,
  WordEditorDemoRoute: WordEditorDemoRoute,
  InviteInviteIdRoute: InviteInviteIdRoute,
  DataCenterCleaningIdRoute: DataCenterCleaningIdRoute,
  DataCenterReviewTaskIdRoute: DataCenterReviewTaskIdRoute,
  ShareDocTokenRoute: ShareDocTokenRoute,
  DataCenterReviewRunRunIdRoute: DataCenterReviewRunRunIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
